import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

const messages = {
  en: {
    welcome: "Welcome",
    hello: "Hello, World!",
    logout: "Logout",
    nav: {
      aboutus: "About Us",
      aboutusInfo: "About Us",
      newsCenter: "News Center",
      joinus: "Join Us",
      consultnow: "Consult Now",
      ecoVadis: "EcoVadis",
      puroEarth: "Puro.earth",
      SBTi: "SBTi",
      // carbonDisclosure: "Carbon/Environmental Data Disclosure",
      // lifecycleAssessment: "Life Cycle Assessment",
      cdpDep: "CDP",
      epdDep: "EPD",
      supplyChain: "Supply Chain Carbon Management",
      apiIntegration: "API Integration System",
      aiRedC: "AI RedC",
      lca: "LCA",
      ccer: "CCER",
      // carbonPrediction: "Carbon Emission Prediction",
      pas: "PAS",
      redcPlus: {
        title: "RedC+",
        try: "Try RedC2.0 >",
        login: "Log-in RedC >",
        loginMobile: "Log-in RedC",
        whatIs: {
          title: "What is RedC+",
          description1: "RedC+ is a consulting and verification enterprise management process added to the RedC carbon management software by Carbon Trust Foundation. In the past, consulting companies briefly dominated the market with their professional capabilities in carbon emission accounting and reduction strategies. However, with the rapid development of large models and generative artificial intelligence (AIGC), the entire industry is undergoing unprecedented changes. Today, with the leap in data processing speed, significant cost reduction, and comprehensive improvement in intelligence levels, these technological advances are quietly restructuring the industrial ecology. RedC+ helps the consulting service industry break through transformation bottlenecks and achieve business upgrades.",
          description2: "With increasing global attention to climate change issues, carbon emission management has become an important topic for governments and enterprises worldwide. As a crucial means of ensuring the accuracy and transparency of carbon emission data, the standardization of carbon verification work processes and methods is particularly important."
        },
        workflow: {
          title: "Verification Workflow",
          items: [
            "Industry Chain Data Center",
            "Industry Chain Monitoring",
            "Industry Evaluation",
            "Industry Map",
            "Intelligent Investment Attraction System and Services"
          ],
          description: "Carbon verification refers to the process of detecting, measuring, and evaluating the carbon emissions of enterprises, organizations, or individuals. Its purpose is to ensure that relevant entities comply with national and local carbon emission standards and regulations, promoting their low-carbon development. Through verification, we can comprehensively understand the actual situation of carbon emissions, provide scientific basis for formulating effective emission reduction strategies, and help improve the accuracy and transparency of carbon emission data, promoting government, enterprise and public supervision and participation in emission reduction actions. Carbon verification work is important for promoting low-carbon economic development and enterprise emission reduction actions. Through verification, we can comprehensively understand enterprise carbon emissions and provide scientific basis for formulating effective emission reduction strategies. However, carbon verification work also faces many challenges. For example, different industries and enterprises have different carbon emissions, requiring targeted verification methods and standards; verification data information is huge, data collection is difficult, and verification personnel's professional level and experience vary. Therefore, it is necessary to continuously strengthen the standardization and informatization of carbon verification work to improve the efficiency and quality of verification work. The Red+ system helps verification and certification companies solve these problems and difficulties."
        },
        roadmap: {
          title: "Transformation Roadmap and Project Objectives",
          items: [
            "Industry Chain Data Center",
            "Industry Chain Monitoring",
            "Industry Evaluation",
            "Industry Map",
            "Intelligent Investment Attraction System and Services"
          ]
        },
        verificationSteps: {
          title: "Main Steps of Carbon Verification",
          preparation: {
            title: "Preparation Stage",
            items: [
              "Sign verification agreement, clarifying verification scope, applicable standards and methods, verification process, expected completion time, responsibilities and obligations of both parties, confidentiality clauses, etc.",
              "Form verification team composed of verifiers with relevant professional knowledge and skills, ensure professionalism and accuracy of verification work, and develop detailed verification plan"
            ]
          },
          documentReview: {
            title: "Document Review Stage",
            items: [
              "Review greenhouse gas emission reports and related supporting materials submitted by verification subjects. Review content includes emission facility list, emission source list, activity data and emission factor related information, etc."
            ]
          },
          onSiteVerification: {
            title: "On-site Verification Stage",
            items: [
              "Develop on-site verification plan: Verification team needs to develop detailed on-site verification plan based on document review results, clarifying verification purpose, scope, methods and schedule",
              "Implement on-site verification: Verification team needs to go deep into verification subject's site, conduct comprehensive assessment of carbon emissions through site inspection, data collection and problem identification"
            ]
          },
          reportPreparation: {
            title: "Report Preparation and Review Stage",
            items: [
              "Prepare verification report: Verification team needs to prepare detailed verification report based on on-site verification results. Report content includes verification purpose, scope, methods, results, conclusions and recommendations. Report writing needs to follow relevant carbon verification guidelines and criteria to ensure report accuracy and comparability",
              "Internal technical review: Verification report undergoes internal technical review by verification body to ensure report content completeness, data accuracy, and scientific methodology"
            ]
          },
          resultNotification: {
            title: "Result Notification and Record Keeping Stage",
            items: [
              "Notify verification results",
              "Keep records: Verification body will securely and confidentially maintain all written and electronic documents during verification process, including verification agreement, communication records, supporting documents, verification reports, etc."
            ]
          }
        }
      },
      ssccp: "SustainableSupplyChainCloud",
      toolCloud: "ToolCloud",
      aboutUsHLY: "About Us",
      aiKnowledge: "AI Pool",
      news: "News",
      readMore: "Read More",
      pricing: "Pricing",
      startTrial: "Consult",
      shopping: "Shopping",
      onlineTraining: "Training",
      ociit: "Organize Carbon Inventory Inspection Training",
      pcft: "Product Carbon Footprint Training",
      ESGmtapt: "ESG Management Theory and Practice Training",
      eat: "Energy Audit Training",
      emsiat: "Environmental Management System Internal Auditor Training",
      iatfems: "Internal auditor training for energy management system",
      ISCC: "ISCC system internal auditor training",
      ecovadisTraining: "Ecovadis declaration training",
      cbamTraining: "CBAM application training",
      euBatteryTraining: "EU Battery Act Training",
      ctc: "Customized Training Camp"
    },
    auth: {
      login: "Login",
      register: "Register Now",
      useDemo: "Experience Now"
    },
    home: {
      title: "Sustainable Supply Chain Cloud Platform",
      description: "We are a strategic management service organization dedicated to building green and sustainable supply chains for enterprises. We are committed to energy conservation, low-carbon, and environmental protection ESG、 We have rich practical experience in digital transformation and other fields, and have multiple senior industry technical experts to safeguard the implementation of projects.",
      privacyNote: "Our vision is to provide our users with professional and efficient one-stop solutions, and to work together towards a new era of sustainable development.",
      trialCBAM: "Apply for a free trial of CBAM",
      trialName: "name",
      trialName2: "Please enter your name",
      trialPhone: "phone",
      trialPhone2: "Please enter your phone",
      trialEmail: "email",
      trialEmail2: "Please enter your email",
      trialUse: "Free experience",
      startTrial: "Get started for free",
      featuredApps: "APP",
      apps: {
        redc: {
          title: "RedC2.0",
          description: "A unique and powerful software suite to Carbon Management"
        },
        cbam: {
          title: "CBAM",
          description: "Carbon Tax Pro"
        },
        goldTrade: {
          title: "Green Trade Platform",
          description: "Carbon platform designed for trade business"
        },
        greenEnergy: {
          title: "ePaper Platform",
          description: "Industry supply-chain services"
        },
        industryChain: {
          title: "AI Pool",
          description: "Helpdesk software to deliver comprehensive EHS & ESG Policy support"
        },
        viewAll: "Browse All Products"
      },
      contact: {
        wechat: "WeChat",
        phone: "Phone",
        demo: "Book"
      }
    },
    redc: {
      title: "All-in-one Suite",
      subtitle: "RedC - The operating system for carbon management",
      description: "RedC (Risk Evaluation Dimension Carbon)helps consulting service industry optimize consulting service process and helps enterprise customers optimize carbon management process throughout the lifecycle from design, implementation, operation to maintenance, improving efficiency, reducing costs and ensuring compliance.",
      tryFree: "Try RedC >",
      toolDescription: "Simple，Easy-to-Use, Efficient",
      techTitle: "RedC2.0"
    },
    todo: {
      title: "Our Products",
      description: "Run your entire carbon management on RedC with our unified cloud software, designed to help you break down silos between complicated regulations and increase compliant efficiency.",
      learnMore: "Learn More >>",
      services: {
        SustainableSupplyChainCloud: {
          title: "Low Carbon",
          desc: "",
          items: [
            "ISO14064 Carbon Accounting",
            "ISO14067 Carbon Footprint",
            "ISO14068 Carbon Neutrality",
            "LCA Life Cycle Assessment",
            "ISCC PLUS/EU",
            "ETANS Carbon Management System",
            "CBAM EU Carbon Border Tax"
          ]
        },
        toolCloud: {
          title: "Energy",
          desc: "",
          items: [
            "ISO50001 Energy Management System",
            "Energy Audit/Diagnosis",
            "Special Energy Efficiency Testing",
            "Electricity/Water/Heat Balance Testing",
            "Energy-saving Subsidy Application",
            "Energy-saving Assessment Services"
          ]
        },
        OrganizeCarbonInventoryInspectionTraining: {
          title: "Green Building",
          desc: "",
          items: [
            "EPD Environmental Product Declaration",
            "ISO14046 Water Footprint",
            "LEED Green Building",
            "WELL Healthy Building",
            "China Green Building"
          ]
        },
        ProductCarbonFootprintTraining: {
          title: "Compliant Production",
          desc: "",
          items: [
            "ISO14001 Environmental Management System",
            "Governance Structure Design & Optimization",
            "Green Factory",
            "Zero-carbon Factory",
            "Green Supply Chain"
          ]
        },
        ESGManagementTheoryandPracticeTraining: {
          title: "Traceability Management",
          desc: "",
          items: [
            "Supply Chain EHS Audit",
            "FSC Forest Certification",
            "EUDR EU Deforestation Regulation",
            "GRS Global Recycled Standard",
            "Zero Waste to Landfill System",
            "EU Battery Regulation Consulting",
            "ISO20400 Sustainable Procurement"
          ]
        },
        EnergyAuditTraining: {
          title: "Social Responsibility",
          desc: "",
          items: [
            "ESG Report Preparation",
            "ESG Current Status Analysis",
            "CDP Environmental Disclosure",
            "EcoVadis Score Improvement",
            "Employee Satisfaction Survey",
            "SA8000 Social Responsibility",
            "HIGG/SEDEX Reporting Guidance"
          ]
        },
        EnvironmentalManagementSystemInternalAuditorTraining: {
          title: "Health & Safety",
          desc: "",
          items: [
            "ISO45001",
            "Electrical Safety Assessment",
            "Fire Safety Assessment",
            "Construction Safety Guidance",
            "HS Legal & Regulatory List",
            "HS Compliance Evaluation"
          ]
        },
        InternalAuditorTrainingForEnergyManagementSystem: {
          title: "Compliance Risk",
          desc: "",
          items: [
            "ISO27001 Information Security",
            "ISO22301 Business Continuity",
            "ISO37301 Compliance Management System",
            "ISO31000 Risk Management"
          ]
        },
        ISCCsystemInternalAuditorTraining: {
          title: "Capacity Building",
          desc: "",
          items: [
            "EU Battery Regulation",
            "CBAM EU Carbon Border Tax",
            "Dual Carbon Policy Interpretation",
            "Energy Assessment Engineer",
            "Customized Training Camp"
          ]
        },
        // EcovadisDeclarationTraining: {
        //   title: "Ecovadis Declaration Training",
        //   desc: ""
        // },
        // CBAMapplicationTraining: {
        //   title: "CBAM Declaration Training",
        //   desc: ""
        // },
        // EUBatteryActTraining: {
        //   title: "EU Battery Act Training",
        //   desc: ""
        // },
        // CustomizedTrainingCamp: {
        //   title: "Customized Training Camp",
        //   desc: ""
        // },
        more: {
          title: "More...",
          desc: "Coming soon..."
        }
      }
    },
    company: {
      quote: "RedC’s carbon operating system is very robust and contains the collective memory of entire carbon data. With the professional services, infrastructure, support, and security, the Carbon Trust Cornerstone team streamline complex carbon process and procedure, build strong relationships with customers. ",
      quote_2: "Working Together on the Road to Net Zero",
      coreTech: {
        title: "Core Technology",
        description: "RedC core technologies include carbon accounting, model building, carbon reduction analysis, process optimization, supply chain management, and real-time operational support. Carbon Trust software solutions can be widely applied across various industries and fields."
      },
      enterprise: {
        title: "RedC for Enterprise",
        description: "RedC continuously improves product intelligence and customer service quality, helping customers achieve efficient and reliable application systems; enhancing data security, compliance, and traceability."
      },
      customers: {
        title: "Our Customers"
      },
      learnMore: "Learn More"
    },
    core: {
      title1: "Using technology to promote environmental protection and green transformation,",
      title2: "making life better!",
      tryFree: "Get started for free >"
    },
    privacy: {
      title: "Privacy Security First",
      description: "We put the privacy security of every user first. We will never possess or sell your data in any way at any time.",
      learnMore: "Learn More >"
    },
    values: {
      title: "Our Values",
      commitment: {
        title: "Innovation",
        desc: "We passionately pursue new technologies, capabilities and approaches to dedicate to environmental protection."
      },
      development: {
        title: "Cooperation",
        desc: "We work closely with individuals, groups or organizations towards to our common goal and objective. We are strongly supportive to the cooperators and partners. "
      },
      customer: {
        title: "Customer First",
        desc: "We actively listen to our customers, deeply understand the needs and deliver the unique solutions that ensure carbon neutrality and sustainable development."
      }
    },
    productionBrain: {
      title: "Product Carbon",
      whatIs: "What is Product Carbon",
      description: "Product carbon, or Product Carbon Footprint (PCF), refers to the total amount of greenhouse gas emissions released throughout a product's entire life cycle, typically measured in carbon dioxide equivalent (CO2e).",
      explanation: "It can be explained in depth through two dimensions - connotation and extension:",
      connotation: {
        title: "Connotation",
        lifecycle: {
          title: "Lifecycle Perspective",
          desc: "Product carbon calculation covers all stages of a product from 'cradle to grave', including raw material acquisition and processing, product manufacturing, transportation and distribution, product use, and post-use disposal or recycling."
        },
        emissions: {
          title: "Total Greenhouse Gas Emissions",
          desc: "At each life cycle stage of the product, various activities and processes generate multiple greenhouse gases such as carbon dioxide (CO₂), methane (CH₄), and nitrous oxide (N₂O). Product carbon converts these different types of greenhouse gases into carbon dioxide equivalents based on their Global Warming Potential (GWP) and then adds them up to comprehensively measure the product's potential impact on climate change."
        }
      },
      extension: {
        title: "Extension",
        quantitative: {
          title: "Quantitative Indicator",
          desc: "Product carbon is a quantitative indicator that reflects the greenhouse gas emissions contribution of a product throughout its entire life cycle in specific values. This makes carbon emissions comparable between different products, allowing companies to identify high-emission links and products through comparison of different product carbon footprints, thereby taking targeted reduction measures."
        },
        environmental: {
          title: "Environmental Impact Indicator",
          desc: "Product carbon is an important indicator of a product's environmental impact, directly showing the environmental cost of the product in terms of climate change. In the global context of addressing climate change, product carbon information is significant for consumers, businesses, and policymakers. Consumers can make more environmentally friendly purchasing decisions based on product carbon information, businesses can use it as an important environmental management tool, and policymakers can develop relevant environmental policies and regulations accordingly."
        }
      },
      flowchart: "Product Carbon Flow Chart",
      database: "Ecoinvent Authoritative Factor Database Search",
      report: "One-Click Product Carbon Footprint Report Generation",
      allocation: "Allocation Methods",
      procard: {
        title: "The product carbon footprint basic model is embedded into the system process in the form of software programs and algorithms. The model will automatically call relevant data and preset carbon emission factors to calculate carbon emissions. Enterprises can also understand the carbon footprint of products in real-time at various stages such as product design, production, and sales, thereby making decisions that are more conducive to environmental protection and sustainable development. Through the continuous operation and data accumulation of the product carbon footprint model in the system process, enterprises can monitor and analyze product carbon emissions in the long term, discover potential emission reduction opportunities, formulate targeted emission reduction measures, and achieve sustainable development goals.",
        features: {
          simplified: "Simplified",
          intelligent: "Intelligent",
          efficient: "Efficient"
        }
      },
      procard3: {
        title: "The system integrates the internationally recognized authoritative lifecycle database Ecoinvent and multi-source data factor libraries. The database has powerful search capabilities and convenient user experience, laying a solid foundation for accurate carbon footprint calculation and carbon emission quantification.",
      },
      organizationCarbon: {
        title: "Organization Carbon",
        whatIs: "What is Organization Carbon?",
        description: "Organization carbon typically refers to the Organization Carbon Footprint, which is a quantified assessment of the greenhouse gas emissions generated by an organization’s activities over a specific period. A detailed explanation is provided below regarding its coverage and calculation boundaries:",
        scope: {
          title: "Scope:",
          items: {
            energy: {
              title: "Energy-related Emissions",
              desc: "The carbon emissions generated from various energy consumption during organization operations are a significant part of organization carbon. This includes the electricity and heat consumption of buildings, such as the electricity consumed for office lighting and air conditioning, as well as the carbon dioxide emissions from burning fossil fuels like coal and natural gas in industrial production processes."
            },
            transport: {
              title: "Transportation Emissions",
              desc: "Emissions resulting from transportation activities such as business travel and freight transport. For example, emissions generated when employees travel by plane or when company trucks transport raw materials or products, during which the burning of fuel in vehicles releases greenhouse gases."
            },
            production: {
              title: "Production Process Emissions",
              desc: "For manufacturing companies, emissions can also be generated from chemical reactions and material handling during the production process. For instance, in the chemical industry, chemical reactions in product manufacturing directly produce carbon dioxide, methane, and other greenhouse gases. Similarly, in cement production, processes like limestone decomposition release significant amounts of carbon dioxide."
            },
            waste: {
              title: "Waste Treatment Emissions",
              desc: "Emissions from waste treatment processes, such as methane generated by organic matter decomposition in landfills and carbon dioxide produced from waste incineration."
            }
          }
        },
        boundary: {
          title: "Calculation Boundaries:",
          items: {
            direct: {
              title: "Direct Emissions",
              desc: "This refers to emissions generated from sources owned or controlled by the organization, such as exhaust emissions from company-owned vehicles and emissions from the burning of fuel in company-owned boilers."
            },
            indirect: {
              title: "Energy Indirect Emissions",
              desc: "These emissions primarily arise from the electricity, heat, and other energy consumed by the organization, which leads to emissions during production. Although these emissions are not directly generated by the organization, they are closely related to the organization’s energy usage."
            },
            other: {
              title: "Other Indirect Emissions",
              desc: "This includes emissions related to the organization’s activities in the upstream and downstream supply chain, such as emissions from raw material procurement, product sales, and usage. For example, a clothing company’s emissions from fertilizer use in cotton farming, as well as emissions from consumer activities like washing and drying clothes, are considered other indirect emissions of the organization."
            }
          }
        },
        flowchart: "Organization Carbon Flow Chart",
        database: "Ecoinvent Authoritative Factor Database Search",
        report: "One-Click Organization Carbon Report Generation",
        allocation: "Allocation Methods",
        procard: {
          title: "The organization carbon system uses visualization tools to clearly display the overall picture of carbon emission-related activities, processes, and data flows within the organization, presenting from initial data collection to carbon emission calculation, analysis, and strategy formulation, helping personnel at all levels of the organization understand the operational logic of organization carbon management and providing guidance for effective carbon emission management and enterprise strategic decision-making. For group companies or enterprises with multiple factories or companies, the system uses an integrated architecture to complete data collection, accounting methods, carbon emission calculations, etc., according to unified standards, specifications, and processes for enterprises and group companies scattered in different regions, and prepares carbon emission reports to ensure the authenticity, accuracy, and completeness of the report content. At the same time, qualified third-party certification bodies can be entrusted to verify and certify the carbon emission reports, issue verification reports, and empower enterprises to improve the reliability and traceability of carbon information.",
          features: {
            simplified: "Simplified",
            intelligent: "Intelligent",
            efficient: "Efficient"
          }
        },
        procard3: {
          title: "The system integrates the internationally recognized authoritative lifecycle database Ecoinvent and multi-source data factor libraries. The database has powerful search capabilities and convenient user experience, laying a solid foundation for accurate carbon footprint calculation and carbon emission quantification.",
          features: {
            powerful: "Powerful",
            convenient: "Convenient",
            accurate: "Accurate"
          }
        }
      }
    },
    carbonTreasure: {
      title: "Join Us",
      mobileTitle: "Join Us",
      whatIs: {
        carbonTechDirector: {
          title: "Carbon Technology Director",
          coreObjectives: {
            title: "【Responsibilities】",
            items: [
              "Responsible for interpreting and analyzing various policies, collecting information and data on industry-related and innovative projects, and regularly producing analytical reports.",
              "Assist the marketing department in interviewing clients and provide necessary technical support for service proposals.",
              "Execute projects (carbon inventory, product life cycle assessment, engineering project carbon emission assessment, carbon management training, ESG support, etc.), and compile and review related technical outcomes.",
              "Participate in the development and management of company system platforms, regularly update company resources, and refine company advantages to enhance competitiveness."
            ]
          },
          productScope: {
            title: "【Requirements】",
            items: [
              "Passionate about the dual carbon mission, with an understanding of carbon asset trading, carbon emission verification, and carbon reduction management. Preference for candidates with experience in the carbon industry or with intermediate/senior engineering or other professional certifications.",
              "Bachelor’s degree or above; proficient in Microsoft Office; some understanding of information and digital products.",
              "Preferred majors: Engineering, Science (Environmental, Energy, Power, Financial Management, etc.).",
              "Strong logical thinking, verbal and written communication, team coordination. Preference for candidates with excellent English reading and writing skills. Able to travel and work under pressure."
            ]
          }
        },
        projectManager: {
          title: "Project Manager",
          coreObjectives: {
            title: "【Responsibilities】",
            items: [
              "Independently lead consulting projects in areas such as corporate strategy, marketing, R&D, supply chain, process, digitalization, finance, HR, operational excellence, or leadership. Responsible for project quality, schedule, payments, and client satisfaction.",
              "Lead project team members to implement and deliver consulting projects.",
              "Responsible for consulting team building and member development, fostering a harmonious team atmosphere and continuously improving team capabilities.",
              "Participate in pre-sales communications and business activities such as client follow-ups, proposal preparation, bidding, and presentations.",
              "Develop, design, and implement professional topics or training courses for the company.",
              "Lead the optimization of consulting modules, tools, and methods in fields such as strategy, marketing, R&D, procurement, and processes to improve consulting delivery standards."
            ]
          },
          productScope: {
            title: "【Requirements】",
            items: [
              "Bachelor’s degree or above in management, economics, science, or engineering-related fields; Master’s degree preferred. Age: 35–40, with a professional appearance.",
              "Experience in middle or senior management roles or as a consultant in business areas such as strategy, marketing, R&D, supply chain, or process management.",
              "Experience managing or operating large enterprises, with familiarity in corporate strategy and organizational structure.",
              "Strong dedication, responsibility, learning and innovation abilities, and teamwork spirit. Excellent verbal and written communication and presentation skills.",
              "Able to handle high work intensity and travel."
            ]
          }
        },
        partner: {
          title: "Partner",
          coreObjectives: {
            title: "【Responsibilities】",
            items: [
              "Consulting project development: identify client resources or respond to company-provided leads, research client needs, draft or review proposals, present plans, and secure contracts.",
              "Client relationship maintenance: maintain strong relationships with existing clients, monitor their development, and offer management improvement suggestions.",
              "Project implementation: apply effective methodologies and technical approaches to guide project execution and monitor project progress, quality, and payments.",
              "Team building and management: provide training and development for company or department team members."
            ]
          },
          productScope: {
            title: "【Requirements】",
            items: [
              "Age 35 or above.",
              "Bachelor’s degree or above from a well-known domestic or international university; Master’s degree preferred.",
              "Over 10 years of experience in middle or senior management roles in medium or large-sized enterprises.",
              "Extensive experience in management consulting with successful implementation of projects in areas such as strategy, marketing, internal operations, HR, or process management.",
              "Expertise in 1–2 business areas of enterprise management; broader knowledge across multiple areas is a plus.",
              "Ability to understand client needs and independently handle pre-sales, training, project delivery, and client services.",
              "Strong verbal communication, interpersonal, analytical, and presentation skills.",
              "Priority given to those with the ability to develop new projects and a wide network of clients and social contacts."
            ]
          }
        }
      },
      evolutionTitle: "CBAM Implementation Evolution",
      impactTitle: "Impact of CBAM on China’s Export Trade",
      impacts: {
        cost: {
          title: "Cost and Pricing",
          items: [
            "Direct cost increase: From 2026, exports of products covered by CBAM (steel, cement, aluminum, fertilizer, electricity, hydrogen, etc.) from China to the EU will require the purchase of carbon certificates or payment of carbon taxes, increasing export costs.",
            "Indirect cost increase: To meet CBAM requirements, enterprises must invest in carbon emission data monitoring, collection, and reporting, raising data management costs. Adjustments to the supply chain, such as sourcing low-carbon suppliers and optimizing logistics, may also bring additional management and operational costs.",
            "Reduced price competitiveness: Higher costs will raise export product prices, making them less competitive in the EU market, especially for price-sensitive products, potentially reducing market share."
          ]
        },
        industry: {
          title: "Industry and Supply Chain",
          items: [
            "High impact on high-carbon industries: Traditional high-carbon industries such as steel and cement will face significant cost pressure and export restrictions under CBAM, likely reducing export volumes and affecting industry development.",
            "Supply chain restructuring: Enterprises may reassess and adjust their supply chain strategies to mitigate CBAM impacts, favoring low-carbon material suppliers and production processes, driving a green transformation. Some production may shift to regions with lower carbon costs.",
            "Increased pressure for industrial upgrading: To meet CBAM standards, enterprises must invest in technological innovation, improve production processes and energy efficiency, and accelerate the shift toward low- and zero-carbon production, promoting industry-wide upgrading."
          ]
        },
        market: {
          title: "Market and Trade Patterns",
          items: [
            "Restricted access to the EU market: If CBAM expands in scope and tightens standards, more Chinese exports will be affected, making it harder to enter the EU market and potentially reducing trade volume.",
            "Trade diversion effects: Products restricted by CBAM in the EU may shift to other international markets, increasing trade with other countries and altering global trade dynamics.",
            "Rising green trade barriers: CBAM may inspire other regions to implement similar carbon border measures, creating a global green trade barrier and posing greater challenges for China’s exports."
          ]
        },
        data: {
          title: "Data and Certification",
          items: [
            "Heavier data burden: Enterprises must accurately collect, organize, and report carbon emissions data throughout the product lifecycle, which can be challenging for those lacking data management capacity and may require significant investment in personnel and systems.",
            "Stricter certification requirements: With CBAM in place, carbon footprint certifications and other related standards will become more stringent. Chinese companies must obtain relevant certifications to access the EU market, increasing both certification and time costs."
          ]
        }
      },
      serviceTitle: "Carbon-TC One-Stop Full-Process CBAM Service",
      reportTitle: "CBAM Usage & One-Click Report Generation"
    },    
    contactUs: {
      title: 'Contact Us',
      desc: 'If you are interested in the above low-carbon services or have related business needs, feel free to contact us through the following methods:',
      phone: 'Phone: 021-3143 0179',
      phone2: 'Mobile: 158 0092 1098',
      email: 'Email: info@hongly-sh.com',
      address: 'Address: Room 2020A, T3 Building, Gaoshang Lingyu, No. 1518 Caoyang Road, Putuo District, Shanghai',
      title2: 'Follow Us',
      desc2: 'Scan the QR code below to follow our official account and stay informed with the latest insights, industry trends, and professional interpretations in the low-carbon field.'
    },    
    dtl: {
      title: 'Low Carbon Services',
      items: [
        'Against the backdrop of global focus on low-carbon development, we offer a range of professional low-carbon services to help enterprises steadily progress on the path to green transformation:',
        '1. ISO14064 Carbon Accounting: Follow the ISO14064 standard to accurately quantify enterprise greenhouse gas emissions and provide data support for carbon management.',
        '2. ISO14067 Carbon Footprint: Based on the ISO14067 standard, comprehensively assess carbon emissions throughout the full lifecycle of a product, from raw material acquisition to production, transportation, use, and disposal, helping enterprises optimize product carbon performance.',
        '3. ISO14068 Carbon Neutrality: Guided by the ISO14068 standard, help enterprises scientifically develop and implement carbon neutrality strategies to offset their greenhouse gas emissions and move toward carbon neutrality goals.',
        '4. LCA Life Cycle Assessment: Use lifecycle assessment methods to comprehensively analyze the environmental impact of products or services throughout their lifecycle, identifying key areas for environmental improvement.',
        '5. ISCC PLUS/EU: Comply with ISCC PLUS/EU certification requirements to ensure the sustainability of biomass materials and related products, covering environmental, social, and economic standards.',
        '6. CBAM EU Carbon Border Tax: In response to the EU Carbon Border Adjustment Mechanism (CBAM), provide strategies to help enterprises adapt to EU carbon tax policies and reduce trade risks.'
      ]
    },
    nyl: {
      title: 'Energy Services',
      items: [
        'In the critical period of energy transition and the promotion of the "dual carbon" goals, efficient energy management and rational utilization have become key to sustainable development. We offer professional energy services to help enterprises improve energy efficiency, reduce energy costs, and achieve green low-carbon development:',
        '1. ISO50001 Energy Management System: Based on the ISO50001 standard, assist enterprises in establishing a complete energy management framework, standardizing processes, and continuously improving energy performance.',
        '2. Energy Audit/Diagnosis: Conduct comprehensive assessments of enterprise energy usage to identify waste and conservation potential, providing a basis for tailored energy-saving solutions.',
        '3. Targeted Energy Efficiency Testing: Perform efficiency tests on specific equipment, processes, or systems to precisely measure consumption and performance, supporting optimization.',
        '4. Electricity/Water/Heat Balance Testing: Analyze the input, output, and losses of energy mediums (electricity, water, heat) to support efficient distribution and use.',
        '5. Energy-Saving Evaluation Services: Evaluate the energy rationality and feasibility of energy-saving measures in project planning to provide scientific support for decision-making.'
      ]
    },
    ljl: {
      title: 'Green Building Services',
      items: [
        'Amid the global green development trend, green buildings have become a key direction for transformation in the construction industry. We offer professional green building services to help achieve environmental friendliness, resource conservation, and healthy comfort:',
        '1. EPD Environmental Product Declaration: Quantitatively assess the environmental impact of construction products throughout their lifecycle to provide scientific support for green material selection.',
        '2. ISO14046 Water Footprint: Assess water use in construction projects according to international standards to identify water-saving opportunities and strategies.',
        '3. LEED Green Building: Follow the globally recognized LEED certification system to evaluate and certify buildings from multiple dimensions such as site sustainability, water efficiency, energy and atmosphere, materials and resources, and indoor environmental quality.',
        '4. WELL Healthy Building: Focus on the impact of buildings on human health and well-being, optimizing factors like air, water, nutrition, light, movement, thermal comfort, sound, materials, mind, and community.',
        '5. China Green Building: Based on China’s green building evaluation standards, comprehensively evaluate buildings in terms of land use, energy and water efficiency, materials, indoor environment, and operations to promote domestic green development.'
      ]
    },
    hgscl: {
      title: 'Compliance Production Services',
      items: [
        'With increasingly stringent environmental regulations, compliant production has become the cornerstone of sustainable enterprise development. We offer comprehensive compliance production services to help enterprises achieve greener and more standardized production processes:',
        '1. ISO14001 Environmental Management System: Assist enterprises in establishing a complete environmental management framework and processes according to ISO14001, ensuring ongoing improvement and regulatory compliance.',
        '2. Green Factory: Evaluate and build green factories based on criteria including infrastructure, management systems, resource input, products, and emissions to reduce environmental impact.',
        '3. Zero-Carbon Factory: Help factories reduce carbon emissions through energy optimization, process improvements, and efficiency upgrades to eventually achieve zero-carbon production.',
        '4. Green Supply Chain: Promote green practices in procurement, production, and logistics through green supplier evaluations, building a sustainable supply chain system.'
      ]
    },
    zsgll: {
      title: 'Traceability Management Services',
      items: [
        'In the context of increasingly complex global supply chains, traceability management is key to ensuring compliance, transparency, and sustainability. We provide professional traceability services to help enterprises achieve full-chain traceability and sustainable growth:',
        '1. Supply Chain EHS Audit: Conduct comprehensive audits on environmental, health, and safety aspects within the supply chain to reduce risks and enhance corporate social responsibility.',
        '2. FSC Forest Certification: Assist enterprises in obtaining FSC certification to ensure wood and forest products come from sustainably managed forests.',
        '3. EUDR EU Deforestation Regulation: Help enterprises comply with the EU’s corporate due diligence regulation to ensure no deforestation occurs in their supply chains.',
        '4. GRS Global Recycled Standard: Provide GRS certification to ensure recycled materials meet environmental and performance standards.',
        '5. Zero Landfill Waste Management: Help enterprises minimize and harmlessly treat waste through system optimization and improved recycling rates.',
        '6. EU Battery Directive Guidance: Offer compliance guidance for the new EU battery regulation to ensure products meet legal requirements.',
        '7. ISO20400 Sustainable Procurement: Assist in establishing sustainable procurement systems according to ISO20400 to promote environmentally and socially responsible supply chains.'
      ]
    },
    shzrl: {
      title: 'Social Responsibility Services',
      items: [
        'Fulfilling social responsibility has become an important way for enterprises to enhance their image and competitiveness. We offer professional services to help enterprises improve their social responsibility management:',
        '1. ESG Reporting: Tailored ESG reports based on international standards to showcase performance in environment, social, and governance areas and enhance transparency.',
        '2. ESG Assessment and Gap Analysis: Evaluate the current ESG status, identify gaps, and develop strategies to improve ESG performance.',
        '3. CDP Environmental Disclosure: Assist with CDP submissions to improve environmental transparency and investor confidence.',
        '4. EcoVadis Rating Improvement: Provide guidance to enhance performance under EcoVadis evaluation and increase supply chain competitiveness.',
        '5. Employee Satisfaction Survey: Conduct surveys to understand satisfaction levels, analyze influencing factors, and support employee retention strategies.',
        '6. SA8000 Social Accountability: Help enterprises build systems that comply with international labor, health, and ethical standards based on SA8000.'
      ]
    },
    jkhaql: {
      title: 'Health and Safety Services',
      items: [
        'Ensuring employee health and safety is a critical foundation of sustainable development. We offer professional services to enhance workplace safety management:',
        '1. ISO45001: Assist in establishing occupational health and safety systems under ISO45001 to improve performance and reduce risks.',
        '2. Electrical Safety Assessment: Evaluate electrical equipment and systems to identify safety hazards and recommend improvements.',
        '3. Fire Safety Assessment: Assess fire risks, facility readiness, and emergency planning to improve fire prevention capacity.',
        '4. Construction Site Safety Guidance: Provide training and on-site safety guidance to prevent construction accidents and improve safety management.',
        '5. HS Legal Compliance List: Deliver up-to-date health and safety legal requirements for regulatory compliance.',
        '6. HS Compliance Assessment: Evaluate the compliance of health and safety systems and provide corrective guidance.'
      ]
    },
    hgfxl: {
      title: 'Compliance Risk Services',
      items: [
        'In a complex and dynamic business environment, compliance and risk control are key to stable development. We offer professional compliance risk services to help enterprises manage challenges effectively:',
        '1. ISO27001 Information Security: Help establish systems to protect information assets and reduce security risks under ISO27001.',
        '2. ISO22301 Business Continuity: Develop continuity plans based on ISO22301 to maintain operations during crises and reduce losses.',
        '3. ISO37301 Compliance Management: Build a compliance management framework to clarify responsibilities and reduce compliance risks.',
        '4. ISO31000 Risk Management: Establish enterprise-wide risk management systems under ISO31000 to enhance control capabilities.'
      ]
    },
    nljsl: {
      title: 'Capacity Building Services',
      items: [
        'In the context of green and low-carbon development, enhancing enterprise capabilities is key to seizing opportunities. We offer professional capacity-building services to cultivate talent and prepare for future challenges:',
        '1. EU Battery Regulation: Interpret EU battery rules and provide compliance guidance for market entry.',
        '2. CBAM EU Carbon Border Tax: Explain CBAM policies and help enterprises assess cost impact and develop response strategies.',
        '3. Dual Carbon Policy Interpretation: Analyze China’s carbon peaking and neutrality policies and industry implications.',
        '4. Energy Auditor Training: Provide professional training to develop energy efficiency evaluation talent.',
        '5. Customized Training Camps: Tailor programs to corporate needs in green development, carbon tech, and compliance management.'
      ]
    },    
    carbonTreasure2: {
      title: "CBAM Carbon Border Adjustment Mechanism",
      mobileTitle: "CBAM Carbon Border Adjustment Mechanism",
      whatIs: {
        title: "What is CBAM",
        description: "CBAM (Carbon Border Adjustment Mechanism) is a policy tool introduced by the EU to address climate change and prevent carbon leakage.",
        coreObjectives: {
          title: "Core Objectives",
          items: [
            "Address climate change challenges and promote global emission reduction actions. Through adjusting carbon emissions of imported products, encourage enterprises worldwide to reduce greenhouse gas emissions to achieve global climate goals set in the Paris Agreement.",
            "Prevent carbon leakage and protect EU internal industry competitiveness. Avoid high-energy-consuming and high-emission industries from relocating to countries and regions with loose carbon emission regulations due to strict EU internal carbon emission policies, ensuring EU industries are not disadvantaged in the global market due to emission reduction policies."
          ]
        },
        productScope: {
          title: "Product Scope",
          items: [
            "Currently covers products in multiple high-carbon emission industries including steel, cement, aluminum, fertilizer, electricity, and hydrogen. Coverage may expand based on policy adjustments and actual conditions."
          ]
        },
        geographicScope: {
          title: "Geographic Scope",
          items: [
            "Mainly targets products imported into EU customs territory. Any relevant products imported from countries and regions outside the EU may be affected by CBAM."
          ]
        },
        dataCollection: {
          title: "Carbon Emission Data Collection and Reporting",
          items: [
            "Requires importers to report carbon emission data during product production to EU authorities, including carbon emissions from raw material procurement, production processing, transportation, and other stages."
          ]
        },
        carbonPrice: {
          title: "Carbon Price Calculation and Adjustment",
          items: [
            "Calculate carbon costs to be adjusted based on EU Emissions Trading System (EU ETS) carbon prices and imported product carbon emissions. If imported products' carbon emissions during production are higher than average EU similar product emissions, importers need to pay carbon tax or purchase carbon reduction certificates to compensate for emission differences."
          ]
        },
        policyNature: {
          title: "Policy Nature",
          items: [
            "A carbon pricing-based trade measure combining environmental and trade policies. By adjusting carbon emissions of imported products at the border, incorporate carbon emission costs into product prices to influence trade flows and enterprise production decisions."
          ]
        }
      },
      evolutionTitle: "CBAM Evolution and Implementation Process",
      impactTitle: "CBAM Impact on China's Export Trade",
      impacts: {
        cost: {
          title: "Costs and Pricing",
          items: [
            "Increase in Direct Costs: Starting from 2026,Chinese exportsto the EU that fall under CBAMcoveredsectors-such assteel,cement.aluminum,fertilizers.electricity, and hydrogen will require enterprises to purchase carboncertificates or pay carbon taxes, thereby increasing export costs.",
            "Rise in Indirect Costs: To comply with CBAM requirements, enterprises will need to invest incarbon emission monitoring, data collection, and reporting systems. CBAMmay also drive supply chain adjustments such as finding low-carbonsuppliers oroptimizing transport:routes-leading toadditionaladministrative and operational costs.",
            "Weakened Price Competitiveness: The increase in costs will likely raise export product prices. Comparedwith other suppliers in the EU market, Chinese products may lose pricecompetitiveness-especiallyprice-sensitivegoods-potentiallyforresulting in a decline in market share."
          ]
        },
        industry: {
          title: "Industry and Supply Chain",
          items: [
            "Significant Impact on High-Carbon Industries: Traditional high-carbon industriesas steel andsuchcement haverelatively high emission intensity.After the implementation of CBAM,these sectors may face greater cost pressure and export restrictions.potentially resulting in reduced export volumes and industrial slowdown.",
            "Supply Chain Restructuring: To mitigate the impact of CBAM, enterprises may reassess and adjust theirsupply chain strategies by opting for suppliers and production stageswith lower carbon emissions, driving green and low-carbon transformation.Some companies may even relocate production to regions with lower carboncosts to reduce tax burdens.",
            "Increased Industrial Upgrade Pressure: To meet CBAM standards, enterprises must invest more in technologicalinnovation, improve production processes, and enhance resource and energyefficiency,thereby accelerating the transition toward lowcarbon andzero-carbon production models and promoting overall industrial upgrading."
          ]
        },
        market: {
          title: "Market and Trade Landscape",
          items: [
            "Restricted Access to the EU Market: If the scope of CBAM expands and standards are raised, more Chineseexports will be affected. Entry into the EU market will become moredifficult, and the scale of exports to the EU may face limitations.",
            "Trade Diversion Effects: Due to the impact of CBAM, products restricted from entering the EU maybe redirected to other international markets, leading to increased tradebetween China and other countries and regions. This may result in changesto the global trade landscape.",
            "Heightened Green Trade Barriers: CBAM may inspire similar carbon border adjustment policies in othercountries and regions. As a result, global green trade barriers couldemerge, placing greater pressure on China’s export trade environment."
          ]
        },
        data: {
          title: "Data and Certification",
          items: [
            "Heavier Burden on Data Management: Enterprises are required to accurately collect, organize, and report carbonemission data throughout the product manufacturing process. For companieswith limiteddata management capabilities, this poses a significantchallenge and may require considerable investment in manpower, resources,and time to establish and improve a robust data statistics system.",
            "Higher Certification Requirements: With the implementation of CBAM,certification requirements forproduct carbon footprint compliance are becoming increasinglystringent. Chinese companies must obtain relevant certifications togain smooth access to the EU market,thereby increasing both thecost and time associated with certification."
          ]
        }
      },
      serviceTitle: "Carbon Trust Foundation One-Stop CBAM Full Process Service",
      reportTitle: "CBAM Usage and One-Click Report Generation"
    },
    SupplyChainAudit2: {
      title: 'Supply Chain Risk Assessment Tool',
      items: [
        'Environmental Compliance Risk Audit for Supply Chains',
        'Service Highlights:',
        'Provides assessment tools covering environmental, greenhouse gas emissions, occupational health and safety, and social responsibility dimensions to meet the needs of compliance and continuous improvement in sustainable supply chain management.',
        'Builds an interactive audit platform based on the PDCA (Plan-Do-Check-Act) logic and adopts an online rapid risk assessment model to help enterprises effectively screen and manage their supply chains.'
      ]
    },
    esgEvaluation2: {
      title: 'ESG Status Evaluation Tool',
      desc: 'What is ESG?',
      desc2: 'The ESG Status Evaluation Tool effectively measures the ESG practices and performance of enterprises, supply chains, and investors, providing a scoring-based assessment of current ESG management. By combining online and offline assessment methods, authorized users can access the reporting system to submit relevant information, streamlining communication, optimizing human resources, and improving evaluation efficiency.'
    },    
    toolCloudPage: {
      title: "Tool Cloud",
      time: "Cooperation Time",
      viewContent: "View Content",
      tools: {
        cbam: {
          title: "CBAM Tool",
          description: "What is CBAM? CBAM, or the Carbon Border Adjustment Mechanism, is a policy tool introduced by the European Union to address climate change and prevent carbon leakage."
        },
        carbonPlatform: {
          title: "Carbon Calculation Platform",
          description: "An intelligent carbon emission management platform, based on AI large models, providing one-stop product services such as carbon accounting, carbon emission reduction, and carbon neutrality. It makes corporate carbon management more compliant, transparent, and efficient."
        },
        supplyChainAudit: {
          title: "Supply Chain Audit",
          description: "Provide evaluation tools in dimensions such as environment, greenhouse gases, occupational health and safety, and social responsibility according to the needs of sustainable supply chain management compliance and continuous improvement. Build an interactive audit platform composed of PDCA logic and adopt an online rapid risk assessment model to keep a good 'check' for enterprise supply chain screening and management."
        },
        esgEvaluation: {
          title: "ESG Evaluation",
          description: "The ESG status evaluation tool can effectively measure the ESG practices and performance of enterprises, supply chains, and investors, and evaluate the current status of ESG management in the form of scoring. The ESG status evaluation tool combines online and offline evaluation methods, and personnel with accounts can enter the reporting system to complete information reporting, simplifying communication processes, freeing up human resources, and improving evaluation efficiency."
        }
      }
    },
    newsCenterInfo: {
      carbonTariff: {
        title: "Explained: Carbon Tariff is Coming! How Should Enterprises Respond?",
        background: {
          title: "Background of Carbon Tariff",
          content: "The background of the carbon tariff mainly stems from the global need to address climate change, and the concept originated from EU countries. As climate change becomes more severe globally, countries have taken measures to reduce greenhouse gas emissions. However, due to differences in climate policies, energy structures, and industrial layouts, emission reduction progress varies among nations. To ensure fair global carbon reduction, some countries have proposed and implemented carbon tariffs to prevent products and services from carbon-lax countries from squeezing out green industries in domestic markets. The EU’s Carbon Border Adjustment Mechanism (CBAM) is a typical example."
        },
        cbamIntro: {
          title: "Basic Introduction to CBAM",
          whatIs: {
            title: "What is CBAM",
            content: "CBAM stands for Carbon Border Adjustment Mechanism, also known as the carbon tariff or carbon border tax. It is a mechanism involving carbon-intensive imported products, where the EU imposes a fee based on the carbon emissions associated with certain imports."
          },
          industries: {
            title: "Which Industries Are Covered",
            content: "Currently, CBAM covers six major industries: cement, aluminum, fertilizers, power generation, hydrogen, and steel. The European Commission will consider including other carbon-intensive industries in the future."
          },
          reporting: {
            title: "Who is Responsible for Reporting",
            content: "The declarant will be the importer or an indirect customs representative, depending on who files the customs declaration. Customs authorities will notify the declarant of their obligation to report information during the transition period."
          },
          exporterObligations: {
            title: "Obligations for Domestic Exporters",
            content: "Although CBAM reporting is handled by the authorized declarant (typically the importer), the declarant will require product carbon emission data from the supplier (i.e., the exporter) to complete the report. Therefore, exporters must prepare and submit embedded carbon data and cooperate with the importer accordingly."
          }
        },
        implementation: {
          title: "CBAM Implementation Timeline and Key Points",
          content: "The CBAM regulation came into effect on October 1, 2023, and is divided into a transitional period and a charging period:",
          periods: [
            "Transitional Period (Oct 1, 2023 ~ Dec 31, 2025): CBAM reports are required, but no carbon fees are calculated;",
            "Charging Period (From Jan 1, 2026): CBAM declarations must be submitted, and carbon fees will apply."
          ]
        },
        reportingMethod: {
          title: "CBAM Information Submission Method",
          content: "Exporters can use the official EU reporting template (CBAM Communication template for installations) to exchange information with importers. After accurately completing the file, the exporter can submit the entire document or the last worksheet (Summary_Communication) to the EU client."
        },
        certificates: {
          title: "About CBAM Certificates",
          details: [
            "Each CBAM certificate: assigned a unique ID number; priced based on the average weekly EU ETS auction price; represents one ton of CO₂ emissions; valid for two years;",
            "CBAM Certificate Surrender: By May 31 each year, the authorized declarant must surrender certificates based on the previous calendar year's embedded emissions. The declarant must ensure the certificate stock covers at least 80% of imported emissions since the beginning of the year at the end of each quarter;",
            "CBAM Certificate Buyback: By June 30 each year, the declarant may apply to buy back unused certificates. The EU Commission will repurchase up to one-third of the total certificates purchased in the previous calendar year at the original purchase price;",
            "CBAM Certificate Cancellation: On July 1 each year, the EU Commission will cancel any remaining certificates from the previous year without compensation."
          ]
        },
        services: {
          title: "Struggling to Prepare a Compliant Carbon Emissions Report?",
          subtitle: "Let Professionals Handle Professional Work",
          ourServices: {
            title: "Our Services Include",
            items: [
              "CBAM compliance training/guidance for enterprises",
              "CBAM product carbon emission accounting",
              "Filling out the CBAM communication form for importers",
              "CBAM system registration and declaration operations",
              "Corporate carbon inventory/carbon accounting"
            ]
          },
          ourAdvantages: {
            title: "Our Advantages",
            technical: {
              title: "Technical Advantage",
              content: "Honglvyuan owns a digital carbon management system and database to automatically generate compliant product carbon emissions reports."
            },
            team: {
              title: "Team Advantage",
              content: "Honglvyuan has multiple senior experts who fully understand the declaration process and interpret international carbon tariff policies, offering comprehensive dual-carbon planning for enterprises."
            }
          }
        }
      },
      cdpDisclosure: {
        title: "In-Depth Explanation of CDP Environmental Disclosure Program",
        background: {
          title: "About CDP",
          content: "CDP is a global nonprofit organization running the world's environmental disclosure system for companies, cities, states, and regions. Established in 2000, CDP works with over 590 investors holding more than $110 trillion in assets. It pioneered the use of capital markets and corporate procurement to encourage environmental disclosure, reduce greenhouse gas emissions, and protect water and forest resources. With the rapid growth of the low-carbon industry, the Carbon Disclosure Project (CDP) has gained increasing attention and support from businesses in China and globally."
        },
        businessBackground: {
          title: "Business Background",
          content: "More investors and buyers are closely monitoring their partners' sustainability performance in addressing climate change, water management, and deforestation risks. Sustainable and vibrant economic development is seen as a prerequisite for partnerships. Based on investor and buyer requirements, CDP sends climate, water, and forest questionnaires to their investees and suppliers and evaluates their environmental management performance based on the responses. Many organizations struggle to provide complete, objective, and accurate disclosures, affecting their scores and influencing investor and buyer decisions."
        },
        standardOverview: {
          title: "Overview of the Standards",
          content: "CDP is a London-based nonprofit organization founded in 2000, dedicated to reducing greenhouse gas emissions and protecting water and forest resources. CDP questionnaires include climate change, forest, and water security. Frequency of reporting: Climate > Water > Forest. A company may be invited to fill out one or more themes. If not invited, a company can voluntarily apply to disclose."
        },
        benefits: {
          title: "Benefits of CDP Disclosure",
          items: [
            "Protect and enhance company reputation—build trust through transparency and address growing public concern for the environment;",
            "Gain competitive advantage—in stock market performance, access to capital, and winning bids;",
            "Track and benchmark progress—compare environmental performance with industry peers and receive internationally recognized scores and feedback based on climate goals;",
            "Identify risks and opportunities—recognize previously overlooked environmental risks and opportunities, supporting data-driven strategies;",
            "Stay ahead of regulation—in a world moving toward mandatory disclosure, reporting via CDP helps companies meet multi-region reporting requirements and align with best practices such as TCFD recommendations."
          ]
        },
        implementationProcess: {
          title: "CDP Questionnaire Submission Process",
          items: [
            "Introduction to CDP questionnaire completion",
            "Sign agreement",
            "Greenhouse gas inventory (Scope 1, 2, 3) (optional)",
            "Gap analysis before questionnaire submission",
            "Complete CDP questionnaires during the disclosure period (April–July annually)",
            "Pay CDP disclosure fee if required by investors",
            "Submit questionnaire and await rating",
            "CDP announces scoring results",
            "Service ends with summary analysis"
          ]
        },
        ratingResults: {
          title: "CDP Scoring System",
          content: "Ratings range from A, A-, B, B-, C, C-, D, D-, to F (for non-disclosure or insufficient information). Companies scoring C or below do not receive scores for management or leadership performance."
        },
        ratingCycle: {
          title: "CDP Rating Cycle",
          content: "CDP questionnaires are submitted once per year. Submission starts in April and ends by the end of July."
        },
        serviceBenefits: {
          title: "Benefits of CDP Questionnaire Guidance",
          items: [
            "Reduce time costs and avoid detours with third-party expert guidance, improving environmental disclosure efficiency;",
            "Gain deep insight into investor/buyer expectations, improve environmental performance, raise CDP scores, and enhance stakeholder satisfaction;",
            "Benchmark against industry environmental practices to improve sustainability management."
          ]
        }
      }
    },    
    ssccpPage: {
      carousel: {
        line1: "Sustainable Supply Chain Cloud",
        line2: ""
      },
      dataPlatform: "Digital Tool Solutions",
      dataLeft: "Digital Tool Solutions",
      dataRight: [
        ["CBAM Tool", "Carbon Calculation Platform", "Supply Chain Audit", "ESG Assessment"]
        // ["Data Labeling", "Dimension Enhancement", "Data Modeling", "Data Services"]
      ],
      industries: [
        "Electronics", "Food", "Pharmaceutical", "Daily Chemicals", "4S Shops", "Project Manufacturing", "Modern Agriculture", "Steel", "…"
      ],
      groupTitle1: "Environment",
      groupTitle2: "Compliance & Sustainability",
      purchaseCategories: [
        {
          title: "Low Carbon",
          items: [
            "ISO14064 Carbon Accounting",
            "ISO14067 Carbon Footprint",
            "ISO14068 Carbon Neutrality",
            "LCA Life Cycle Assessment",
            "ISCC PLUS/EU",
            "ETANS Carbon Management System",
            "CBAM EU Carbon Border Tax"
          ]
        },
        {
          title: "Energy",
          items: [
            "ISO50001 Energy Management System",
            "Energy Audit/Diagnosis",
            "Specialized Energy Efficiency Testing",
            "Electricity/Water/Heat Balance Testing",
            "Energy Subsidy Application",
            "Energy Efficiency Evaluation Services"
          ]
        },
        {
          title: "Green Building",
          items: [
            "EPD Environmental Product Declaration",
            "ISO14046 Water Footprint",
            "LEED Green Building",
            "WELL Healthy Building",
            "China Green Building"
          ]
        },
        {
          title: "Compliant Production",
          items: [
            "ISO14001 Environmental Management System",
            "Governance Structure Design & Optimization",
            "Green Factory",
            "Zero-Carbon Factory",
            "Green Supply Chain"
          ]
        },
        {
          title: "Traceability Management",
          items: [
            "Supply Chain EHS Audit",
            "FSC Forest Certification",
            "EUDR EU Deforestation-Free Regulation",
            "GRS Global Recycled Standard",
            "Zero Landfill Waste System",
            "EU Battery Regulation Guidance",
            "ISO20400 Sustainable Procurement"
          ]
        },
        {
          title: "Social Responsibility",
          items: [
            "ESG Report Preparation",
            "ESG Status Assessment & Analysis",
            "CDP Environmental Disclosure",
            "EcoVadis Score Improvement",
            "Employee Satisfaction Survey",
            "SA8000 Social Responsibility",
            "HIGG/SEDEX Reporting Guidance"
          ]
        },
        {
          title: "Health & Safety",
          items: [
            "ISO45001",
            "Electrical Safety Assessment",
            "Fire Safety Assessment",
            "Construction Safety Coaching",
            "HS Legal & Regulatory Checklist",
            "HS Compliance Evaluation"
          ]
        },
        {
          title: "Compliance Risk",
          items: [
            "ISO27001 Information Security",
            "ISO22301 Business Continuity",
            "ISO37301 Compliance Management System",
            "ISO31000 Risk Management"
          ]
        },
        {
          title: "Capacity Building",
          items: [
            "EU Battery Regulation",
            "CBAM EU Carbon Border Tax",
            "Dual Carbon Policy Interpretation",
            "Energy Efficiency Evaluator",
            "Customized Training Camps"
          ]
        }
      ]
    },

    esgPage: {
      title: "ESG Due Diligence",
      try: "Try ESG >",
      whatIs: {
        title: "What is ESG Due Diligence",
        description1: "ESG (Environmental, Social, and Governance) is an investment philosophy and corporate evaluation standard that focuses on a company's environmental, social, and governance performance rather than its financial performance. It is typically used to assess corporate behavior and predict future financial performance. Based on ESG ratings, investors can evaluate their investment behavior and the contribution of the investee company in promoting sustainable economic development and fulfilling social responsibilities by observing its ESG performance.",
        description2: "In 2023, the International Sustainability Standards Board (ISSB) officially released the 'International Financial Reporting Sustainability Disclosure Standard No. 1 - General Requirements for Sustainability-Related Financial Information Disclosure' and 'International Financial Reporting Sustainability Disclosure Standard No. 2 - Climate-Related Disclosures.' This marks the first-ever set of global ESG reporting standards, providing international benchmarks for companies worldwide to disclose unified climate and sustainability information, thereby improving comparability among companies.",
        description3: "On April 12, 2024, with the official release of the Shanghai Stock Exchange’s guidelines for listed companies’ sustainability reports, listed companies are required to integrate sustainable development concepts into their corporate development strategies and operational management activities, continuously strengthen ecological and environmental protection, fulfill social responsibilities, improve corporate governance, and enhance corporate governance capabilities, competitiveness, and innovation capacity."
      },
      assessment: {
        title: "ESG Due Diligence Completes Relevant Information from Three Aspects: Environment, Social, and Governance",
        environment: {
          title: "Environmental (E) Aspect",
          resourceUtilizationEfficiency: "Resource Utilization Efficiency",
          energyConsumption: "Energy consumption, including the usage of various types of energy, energy intensity, and comparisons with industry benchmarks.",
          waterUsage: "Water resource utilization data, such as total water intake, reuse rate, and water consumption per unit of product.",
          materialUsageEfficiency: "Efficiency of raw material usage, including raw material procurement volume, loss rate, and recycling rate.",
          pollutantDischargeAndControl: "Pollutant Discharge and Management",
          greenhouseGasEmissions: "Greenhouse gas emissions data covering Scope 1, 2, and 3 emissions, including total emissions and specific sources.",
          wasteEmission: "Discharge types, quantities, and concentrations of pollutants such as wastewater, waste gas, and solid waste, as well as related treatment facilities and effectiveness.",
          hazardousWaste: "Generation, storage, transportation, and disposal of hazardous waste, and whether it complies with relevant regulatory requirements.",
          environmentalManagementSystem: "Environmental Management System",
          environmentalCertification: "Whether a comprehensive environmental management system is in place, such as ISO 14001 certification.",
          managementEffectiveness: "Effectiveness of the environmental management system, including results of internal audits, management reviews, and completion of environmental goals and targets.",
          emergencyPlan: "Development and execution of environmental emergency plans to respond to sudden environmental incidents.",
          ecologicalProtection: "Ecological Protection and Biodiversity",
          ecosystemImpact: "The impact of corporate production and operations on surrounding ecosystems, such as land occupation, vegetation destruction, and loss of biological habitats.",
          protectionMeasures: "Implemented ecological protection measures, such as ecological restoration projects and biodiversity conservation plans."
        },
        social: {
          title: "Social (S) Aspect",
          employeeRightsAndBenefits: "Employee Rights and Benefits",
          employeeStructure: "Number and structure of employees (age, gender, education, etc.) and employee turnover rate.",
          employeeCompensation: "Employee compensation and benefits, including wage levels, benefits, bonus systems, and comparisons with industry averages.",
          trainingOpportunities: "Employee training and development opportunities, including training investment, implementation of training programs, and promotion mechanisms.",
          healthAndSafety: "Employee health and safety management, including workplace safety, occupational health checks, and accident rates.",
          supplyChainManagement: "Supply Chain Management",
          supplierList: "List of major suppliers, including their scale, industry status, and regional distribution.",
          supplierESGRequirements: "ESG requirements and management measures for suppliers, such as supplier codes of conduct and regular evaluation mechanisms.",
          socialRisks: "Social risks in the supply chain, such as labor rights issues and human rights concerns among suppliers.",
          customerRelationshipManagement: "Customer Relationship Management",
          customerSatisfaction: "Customer satisfaction survey results, assessing feedback on product or service quality and after-sales service.",
          complaintHandling: "Customer complaint handling mechanism, including accessibility of complaint channels and timeliness and effectiveness of complaint resolution.",
          productQuality: "Product quality and safety management, such as product quality certification, quality control systems, and product recall procedures.",
          communityEngagement: "Community Engagement and Social Contribution",
          socialProjects: "Corporate public welfare activities and social responsibility projects in local communities, such as educational support, poverty alleviation, and cultural development.",
          communityFeedback: "Communication and collaboration mechanisms with community residents and the community’s recognition and satisfaction with the company."
        },
        governance: {
          title: "Corporate Governance (G) Aspect",
          governanceStructure: "Governance Structure",
          equityStructure: "Company’s equity structure, including shareholder holdings and shareholder types.",
          boardOperations: "Composition and operations of the board of directors, including members’ professional backgrounds, the proportion of independent directors, frequency of board meetings, and decision-making mechanisms.",
          supervisoryBoard: "Duties and oversight effectiveness of the supervisory board, including supervision of corporate finances and operational activities.",
          internalControlAndRiskManagement: "Internal Control and Risk Management",
          controlEffectiveness: "Integrity and effectiveness of internal control systems, including financial control, operational control, and compliance control.",
          riskManagementSystem: "Construction and operation of the risk management system, including risk identification, assessment, response strategies, and monitoring and management of major risks.",
          informationDisclosure: "Information Disclosure and Transparency",
          disclosurePolicy: "Company's information disclosure policies and processes, ensuring timely, accurate, and complete disclosure of financial and non-financial information.",
          disclosureChannels: "Information disclosure channels and methods, such as company websites, stock exchange announcements, and annual reports, as well as ease of access for investors and stakeholders.",
          complianceAndAntiCorruption: "Compliance and Anti-Corruption",
          complianceManagement: "Corporate compliance management system, including adherence to laws, regulations, and industry standards, as well as compliance training and monitoring mechanisms.",
          antiCorruptionMeasures: "Anti-corruption and anti-bribery measures, such as the establishment of integrity systems, effectiveness of whistleblower mechanisms, and severity of penalties for violations."
        }
      },
    },
    ecoVadisPage: {
      title: "EcoVadis",
      whatIs: {
        title: "What is EcoVadis",
        description: "EcoVadis evaluates corporate social responsibility performance using a rigorous methodology and awards different levels of medals to recognize various levels of achievement."
      },
      scoringMethodology: {
        title: "Scoring Methodology",
        assessmentDimensions: {
          title: "Assessment Dimensions",
          description: "Evaluates corporate social responsibility sustainability across four main themes—Environment, Labor & Human Rights, Ethics, and Sustainable Procurement—covering 21 indicators."
        },
        scoringBasis: {
          title: "Scoring Basis",
          description: "Follows the PDCA (Plan-Do-Check-Act) sustainability management logic, forming a scoring system guided by 'Policy - Action - Results.' Each indicator is assessed across three dimensions, with weightings of 25% for policy level, 35% for action level, and 40% for results level."
        },
        specificScoring: {
          title: "Specific Scoring",
          description: "Each management indicator within a module receives a score ranging from 0 to 100, with increments of 25 (0, 25, 50, 75, 100). The weighted average of these indicator scores determines the module’s final score. The overall EcoVadis rating has a maximum score of 100. Additionally, a 360° assessment is conducted, incorporating information from internal and external stakeholders."
        }
      }
    },
    ccerPage: {
      title: "CCER",
      whatIs: {
        title: "What is CCER",
        description: "CCER stands for China Certified Emission Reduction, which refers to the quantification and certification of greenhouse gas emission reduction effects from renewable energy, forestry carbon sequestration, methane utilization, and other projects within China. These reductions are registered in the National Voluntary Greenhouse Gas Emission Reduction Trading Registration System."
      },
      projectTypes: {
        title: "Project Types",
        renewableEnergyProjects: {
          title: "Renewable Energy Projects",
          description: "These include wind power, photovoltaic, hydropower, biomass energy, etc. These projects reduce reliance on traditional fossil fuels by utilizing renewable energy for power generation, thereby achieving greenhouse gas emission reductions."
        },
        forestryCarbonSequestrationProjects: {
          title: "Forestry Carbon Sequestration Projects",
          description: "These projects mainly involve afforestation and forest management activities to increase forest area and carbon stock, thereby absorbing carbon dioxide from the atmosphere and achieving carbon sequestration."
        },
        methaneUtilizationProjects: {
          title: "Methane Utilization Projects",
          description: "Projects such as landfill gas recovery and biogas power generation that collect and utilize methane, a potent greenhouse gas, which would otherwise be released into the atmosphere, reducing methane emissions."
        }
      },
      tradingProcess: {
        title: "Trading Process",
        projectFiling: {
          title: "Project Filing",
          description: "Project owners need to file voluntary emission reduction projects with the relevant national authorities, submitting project design documents, monitoring plans, and other materials."
        },
        emissionReductionCertification: {
          title: "Emission Reduction Certification",
          description: "After a certain period of implementation, certified institutions monitor, calculate, and verify the emission reductions of the project to ensure their authenticity and accuracy."
        },
        registration: {
          title: "Registration",
          description: "The certified emission reductions are registered in the National Voluntary Greenhouse Gas Emission Reduction Trading Registration System, becoming tradable CCERs."
        },
        tradingStage: {
          title: "Trading Stage",
          description: "Key emitting enterprises or other institutions and individuals in need can purchase CCERs through the national carbon emission trading market or other legitimate trading platforms to offset their greenhouse gas emissions."
        }
      },
      roleAndSignificance: {
        title: "Role and Significance",
        carbonPeakAndNeutralityGoals: {
          title: "Contributing to Carbon Peak and Carbon Neutrality Goals",
          description: "CCER provides a market-based incentive mechanism for various emission reduction projects, encouraging enterprises and social capital to invest in greenhouse gas reduction actions, helping to drive China's energy structure transformation, ecological protection, and restoration efforts, accelerating the achievement of carbon peak and carbon neutrality goals."
        },
        carbonMarketImprovement: {
          title: "Improving the Carbon Emission Trading Market",
          description: "As a supplement to the national carbon emission trading market, CCER enriches market transaction types, increases market flexibility and liquidity, helps reduce emission reduction costs for key emitting enterprises, and improves the efficiency of the carbon market."
        },
        sustainableDevelopmentPromotion: {
          title: "Promoting Sustainable Development",
          description: "CCER drives the development of renewable energy industries, forestry, and other related fields, promotes ecological environment protection and improvement, while providing new growth points for local economic development, and advancing the implementation of sustainable development strategies."
        }
      }
    },   
    lcaPage: {
      title: "Training",
      recentCourses: "Training Course List",
      recentTip: "Welcome enterprises to call us for customized in-house training",
      courseCategories: "Course categories",
      courseSubcategory: "Subcategory of courses",
      seriesCourseName: "Series course name",
      courseDesc: "Course Introduction",
      courseInfo: "Course Details",
      course: {
        hoursLabel: "Hours:",
        foodProvided: "Meals Provided",
        startTimeLabel: "Start Date",
        signup: "Sign Up",
        notOpen: "Registration for this course is currently not available"
      },
      categories: {
        carbonManagement: "Carbon Management",
        greenManufacturing: "Green Manufacturing",
        basicCourse: "Basic Course",
        practicalCourse: "Practical Course",
        managementCourse: "Management Course"
      },
      courseList: [
        {
          name: "Introduction to ESG (Environment, Social, and Governance)",
          hours: "12 Hours",
          startTime: "August 10, 2025",
          category: "ESG",
          subCategory: "ESG",
          desc: `What is the concept of ESG?
What are the benefits of improving ESG performance for companies?
How can companies achieve long-term social value and sustainable development?
How can companies attract more ESG-conscious investors?
How can companies improve management efficiency?

Course Benefits:
● Understand the background and development trends of ESG
● Learn about ESG-related guidelines and policies
● Prepare for corporate ESG response strategies

Recommended for:
● Corporate executives/managers
● ESG/Sustainability departments
● EHS department heads
● Companies going public or already listed
● Individuals interested in ESG`
        },
        {
          name: "Introduction to Mainstream ESG Requirements and Guidelines in Mainland China",
          hours: "12 Hours",
          startTime: "August 10, 2025",
          category: "ESG",
          subCategory: "ESG",
          desc: `Course Outline:
● Introduction to ESG and its history
● Increasingly strict ESG disclosure requirements
● Overview of mainstream ESG requirements and guidelines in Mainland China

Highlights:
● Global ESG regulatory trends (e.g., U.S., U.K., Hong Kong)
● How companies can improve financial institution risk ratings
● Introduction to Mainland China's ESG standards

Target Audience:
● ESG officers or dedicated ESG managers
● Experienced ESG technical professionals
● Individuals interested in ESG

Course Benefits:
● Understand ESG concepts and history
● Understand the tightening trend of ESG regulations
● Learn about China’s major ESG standards`
        },
        {
          name: "Comprehensive Overview of ESG Ratings",
          hours: "12 Hours",
          startTime: "August 10, 2025",
          category: "ESG",
          subCategory: "ESG",
          desc: `ESG ratings are an essential component of the ESG ecosystem, helping to reduce information asymmetry between investors and listed companies, lower decision-making costs, and enhance ESG awareness and implementation.
ESG ratings have become a key indicator of corporate performance. More investment institutions are factoring ESG ratings into investment decisions, affecting corporate financing:

● Understand mainstream ESG rating systems, indicators, processes, and response strategies to enhance ESG ratings
● Identify key points for improving ESG management through rating overviews and case studies`
        },
        {
          name: "Climate Risk Management and Information Disclosure",
          hours: "12 Hours",
          startTime: "August 10, 2025",
          category: "ESG",
          subCategory: "ESG",
          desc: `● What is climate risk?
● What are the international regulatory requirements for climate disclosure?
● How should companies disclose climate information?`
        },
        {
          name: "Corporate Human Rights Compliance",
          hours: "12 Hours",
          startTime: "August 10, 2025",
          category: "ESG",
          subCategory: "ESG",
          desc: `In the context of global supply chains, corporate human rights compliance is a crucial part of lawful operations:
● Companies, especially multinationals, need to understand the importance of human rights protection
● Master key aspects and methods of human rights compliance to ensure effective compliance management
● What are the main areas of corporate human rights compliance?
● How to manage corporate human rights compliance?`
        },
        {
          name: "Policy Focus: Responding to EU ESG Regulations for Internationalizing Enterprises",
          hours: "12 Hours",
          startTime: "August 10, 2025",
          category: "ESG",
          subCategory: "ESG",
          desc: `Chinese companies expanding globally face ESG regulatory and legislative challenges, especially in the EU:
● Establish ESG awareness, focus on key issues, and embed sustainability principles
● Track EU ESG regulatory trends to identify and assess compliance risks

Target Audience:
● Executives of internationalizing companies
● Corporate boards
● ESG committees/working groups
● Individuals interested in international ESG regulations`
        },
        {
          name: "Applying ISO 26000 for Corporate Sustainability",
          hours: "12 Hours",
          startTime: "August 10, 2025",
          category: "ESG",
          subCategory: "ESG",
          desc: `1. Introduction to ISO 26000:
※ What is ISO 26000?
※ Why was ISO 26000 developed?
※ ISO 26000 positioning and contents

2. Key Concepts of ISO 26000:
※ Social responsibility and its practices
※ Seven principles and seven core subjects

3. How to Apply ISO 26000:
ESG is a key concept for sustainable corporate development. ISO 26000 is an international standard:

● Understand ISO 26000 to identify critical sustainability topics
● Use ISO 26000 to promote sustainable thinking and integrate ESG into company management

Recommended for:
● Corporate executives
● ESG committees or workgroups
● CSR professionals
● Individuals interested in ESG guidelines`
        },
        {
          name: "EcoVadis Sustainability Assessment Sharing",
          hours: "12 Hours",
          startTime: "August 10, 2025",
          category: "ESG",
          subCategory: "ESG",
          desc: `Highlights:
1. ESG/CSR managers
2. Supply chain managers
3. Senior ESG/CSR technical personnel
4. Individuals interested in EcoVadis

Course Outline:
1. What is EcoVadis assessment?
2. EcoVadis methodology
3. Assessment process

Audience:
1. ESG/CSR managers
2. Supply chain professionals
3. ESG/CSR specialists
4. Anyone interested in EcoVadis

Benefits:
1. Understand EcoVadis methodology
2. Learn how to complete the questionnaire and key considerations`
        },
        {
          name: "Introduction to EcoVadis Sustainability Assessment",
          hours: "12 Hours",
          startTime: "August 10, 2025",
          category: "ESG",
          subCategory: "ESG",
          desc: `Course Outline:
1. What is EcoVadis?
2. Methodology overview
3. Assessment process
4. Case analysis

Target Audience:
● ESG/CSR professionals
● Supply chain managers
● ESG/CSR technicians
● Individuals interested in supply chain sustainability and EcoVadis

Benefits:
● Understand EcoVadis assessment methodology
● Learn how to fill in the questionnaire and avoid common pitfalls`
        },
        {
          name: "New Era of Sustainability Disclosure: ISSB Standards and China's Progress",
          hours: "12 Hours",
          startTime: "August 10, 2025",
          category: "ESG",
          subCategory: "ESG",
          desc: `Course Outline:
1. Sustainability Disclosure Overview
※ Introduction and current domestic practices

2. ISSB Standards
※ Background, development, key contents, and international acceptance

3. China’s Progress
※ Guidelines for listed companies being developed
※ SASAC accelerating ESG supervision

Course Benefits:
● Build ESG awareness
● Understand ISSB standards
● Stay updated on China's ESG disclosure progress
● Learn how to address disclosure challenges`
        },
        {
          name: "Interpreting the Latest ESG Policy Trends",
          hours: "12 Hours",
          startTime: "August 10, 2025",
          category: "ESG",
          subCategory: "ESG",
          desc: `1. Latest International ESG Policies:
ISSB Sustainability Disclosure Standards  
EU Corporate Sustainability Reporting Directive (CSRD)  
European Sustainability Reporting Standards (ESRS)  

2. ESG Policy in China:
SASAC’s ESG report for central SOEs  
SZSE industry disclosure guidelines  

3. Business Impact and Response Strategies`
        },
        {
          name: "ESG Navigator – An Effective Tool for ESG Risk and Response",
          hours: "12 Hours",
          startTime: "August 10, 2025",
          category: "ESG",
          subCategory: "ESG",
          desc: `Course Outline:
1. ESG development trends and challenges
2. How to tackle the ESG acceleration race
3. Start your ESG Navigator journey

Target Audience:
● ESG managers
● Supply chain personnel
● Sustainable finance professionals
● ESG stakeholders
● Individuals interested in ESG

Benefits:
● Understand ESG trends and challenges
● Learn practical ESG risk response strategies
● Get insights into ESG Navigator tools`
        },
        {
          name: "Exploring Green Finance: Transition Finance",
          hours: "12 Hours",
          startTime: "August 10, 2025",
          category: "ESG",
          subCategory: "ESG",
          desc: `Course Outline:
1. Definition and standards of transition finance
2. Relationship with green finance
3. Global developments:
※ G20 framework
※ EU sustainable taxonomy
※ China’s exploration of transition finance

4. Action Recommendations:
※ Corporate implementation paths
※ International and domestic case studies

Target Audience:
● Green finance professionals and managers
● Corporate boards
● Individuals interested in transition finance

Benefits:
● Learn about latest green finance developments
● Understand transition finance foundations
● Receive actionable transition finance guidance`
        },
        {
          name: "Introduction to ISO 20400 Sustainable Procurement",
          hours: "12 Hours",
          startTime: "August 10, 2025",
          category: "ESG",
          subCategory: "ESG",
          desc: `Target Audience:
● Senior management
● Procurement officers/managers
● Individuals interested in sustainability

Course Benefits:
● What is ISO 20400?
● Core components of ISO 20400
● How to apply ISO 20400 in corporate procurement`
        },
        {
          name: "Social Responsibility in Supply Chains: Key Topics",
          hours: "12 Hours",
          startTime: "August 10, 2025",
          category: "ESG",
          subCategory: "ESG",
          desc: `Course Outline:
1. Basic concepts of supply chain social responsibility
2. Regulatory trends
3. Interpretation of key topics

Target Audience:
● Senior executives
● Supply chain managers
● Stakeholders interested in CSR

Benefits:
● Understand supply chain CSR regulatory landscape
● Learn core topics in supply chain CSR`
        },
        // 16
        {
          name: "The 'Second Financial Report' for Enterprises: China's Sustainable Disclosure Standards Begin",
          hours: "12 Hours",
          startTime: "August 10, 2025",
          category: "ESG",
          subCategory: "ESG",
          desc: `Course Outline:
1. Progress on sustainable disclosure in China
2. Interpretation of Ministry of Finance's draft basic standards
3. Comparison with ISSB international standards
4. Recommendations for corporate action

Target Audience:
● Board members and senior management
● ESG committees/workgroup members
● Sustainability officers
● Individuals interested in China’s ESG development

Course Benefits:
● Understand sustainable disclosure concepts
● Track China’s latest developments
● Learn key points of the MoF standard
● Prepare for sustainable information disclosure`
        },
        {
          name: "Understanding CSDDD: Corporate Sustainability Due Diligence Directive",
          hours: "12 Hours",
          startTime: "August 10, 2025",
          category: "ESG",
          subCategory: "Sustainability",
          desc: `Course Outline:
1. Overview of CSDDD
2. Core requirements and interpretation
3. How enterprises should respond to potential challenges

Target Audience:
● Senior executives
● Supply chain managers
● Individuals interested in sustainability regulations

Course Benefits:
● Understand the scope and core requirements of CSDDD
● Identify risks and challenges brought by CSDDD`
        },
        {
          name: "Decoding ESG Topics: Biodiversity",
          hours: "12 Hours",
          startTime: "August 10, 2025",
          category: "ESG",
          subCategory: "ESG",
          desc: `Course Outline:
1. ESG topics & biodiversity:
※ ESG topic concepts and cases
※ Biodiversity significance

2. Why biodiversity matters:
※ Global actions
※ Regulations
※ Ratings impact

3. How to embed biodiversity in ESG management:
※ Disclosure standards
※ Risk assessment
※ Supply chain integration

4. Case studies

Target Audience:
● Senior executives
● ESG committees/workgroup members
● Environmental, supply chain, and sustainability managers
● Anyone interested in sustainability guidance

Course Benefits:
● Understand major ESG issues
● Learn biodiversity topic background
● Integrate biodiversity into ESG management
● Master key disclosure frameworks`
        },
        {
          name: "Carbon Neutrality Lecture Series",
          hours: "12 Hours",
          startTime: "August 10, 2025",
          category: "Low Carbon Energy",
          subCategory: "Low Carbon",
          desc: `Course Benefits:
● Understand carbon neutrality background and definitions
● Learn about relevant policies and standards
● Master steps for corporate/personal carbon neutrality preparation

Recommended Audience:
● Environmental managers in enterprises/institutions
● Energy monitoring or carbon audit professionals
● Operations staff or enterprise leaders`
        },
        {
          name: "Policy Focus: GB/T 2589-2020 General Principles for Comprehensive Energy Consumption",
          hours: "12 Hours",
          startTime: "August 10, 2025",
          category: "Low Carbon Energy",
          subCategory: "Energy",
          desc: `New regulation highlights:
What are the updates and differences from the old standard?
How to interpret technical terms?
How is comprehensive energy consumption calculated?

Course Benefits:
● Understand key changes between new and old standards
● Clarify technical terms
● Master energy consumption calculation methods

Target Audience:
● Business managers
● Energy technicians
● Individuals aiming to become energy-saving experts in industry`
        },
        {
          name: "Policy Focus: How Key Energy-Using Units Should Manage Energy Efficiency",
          hours: "12 Hours",
          startTime: "August 10, 2025",
          category: "Low Carbon Energy",
          subCategory: "Energy",
          desc: `How is comprehensive energy consumption calculated?
What energy-saving measures must key energy users adopt?
What incentives or penalties are provided by the state?

Course Benefits:
● Understand key energy user selection criteria
● Learn management requirements for energy savings
● Provide guidance for energy management strategies

Target Audience:
● Energy-saving leaders in key energy-consuming units
● Energy management officers/team members
● Anyone aiming to improve energy efficiency`
        },
        {
          name: "Industrial Energy Saving and Operation Management",
          hours: "12 Hours",
          startTime: "August 10, 2025",
          category: "Low Carbon Energy",
          subCategory: "Energy",
          desc: `Why is industrial energy saving necessary?

What are the strategies and paths for industrial energy efficiency?

What does a three-level metering system mean?`
        },
        {
          name: "Policy Focus: Interpreting Green Building Evaluation Standards GB/T 50378-2019",
          hours: "12 Hours",
          startTime: "August 10, 2025",
          category: "Low Carbon Energy",
          subCategory: "Energy",
          desc: `What's new in the revised green building standards?
What technical clauses have changed?

Course Benefits:
● Understand background and contents of the green building evaluation standard
● Master the comparison between old and new standards
● Support future green building projects

Target Audience:
● Aspiring green building professionals
● Green building engineers
● Construction company managers`
        },
        {
          name: "Responding to the Dual Carbon Goals under Dual Control and Dual Limitation Policies",
          hours: "12 Hours",
          startTime: "August 10, 2025",
          category: "Low Carbon Energy",
          subCategory: "Low Carbon",
          desc: `With the launch of the national “2030 Carbon Peak Action Plan”, large enterprises must address:
Why should companies pursue carbon neutrality?
How to respond to dual carbon goals under dual control policies?`
        },
        {
          name: "Interpretation of the 14th Five-Year National Cleaner Production Promotion Plan",
          hours: "12 Hours",
          startTime: "August 10, 2025",
          category: "Low Carbon Energy",
          subCategory: "Energy",
          desc: `Do you have these questions?
What are the laws and regulations on cleaner production?
What is a cleaner production audit?
What are the key takeaways from this plan?

Course Benefits:
● Understand relevant laws and audits
● Learn key points of the 14th Five-Year plan

Target Audience:
● Corporate environmental managers
● Cleaner production auditors
● Individuals seeking to develop related skills`
        },
        {
          name: "Training on Voluntary Emission Reduction Projects (CCER)",
          hours: "12 Hours",
          startTime: "August 10, 2025",
          category: "Low Carbon Energy",
          subCategory: "Low Carbon",
          desc: `What are the features of China's Certified Voluntary Emission Reduction (CCER)?

What conditions must a project meet to apply?

What is the CCER trading process?`
        },
        {
          name: "ISCC Certification for Sustainability and Carbon",
          hours: "12 Hours",
          startTime: "August 10, 2025",
          category: "Low Carbon Energy",
          subCategory: "Low Carbon",
          desc: `ISCC certification helps companies demonstrate responsibility in:
Reducing GHG emissions
Sustainable land use
Biodiversity conservation
Social sustainability

Common questions:
What is ISCC?
Why is ISCC certification important?
How to get ISCC certified?`
        },
        {
          name: "Green Finance and Sustainable Development",
          hours: "12 Hours",
          startTime: "August 10, 2025",
          category: "Low Carbon Energy",
          subCategory: "Low Carbon",
          desc: `What is green finance?
What are the five pillars of green finance?
What are the latest policies in China?
How should green finance be practiced?

Course Benefits:
● Understand the concept and evolution of green finance
● Learn the five pillars and China's policies
● Study practical green finance case studies

Recommended Audience:
● Banking, securities, and finance professionals
● Corporate green financing officers
● Government and institutional green finance managers
● Anyone interested in green finance`
        },
        {
          name: "Policy Focus #30: Enterprise Power Balance Testing and Evaluation",
          hours: "12 Hours",
          startTime: "August 10, 2025",
          category: "Low Carbon Energy",
          subCategory: "Energy",
          desc: `What is the status of enterprise power systems?
What is the status of major energy-consuming equipment?
Where can companies find energy-saving potential?

All these questions will be answered in this course!`
        },
        {
          name: "Green Building Certification and Sustainable Development in Real Estate",
          hours: "12 Hours",
          startTime: "August 10, 2025",
          category: "Low Carbon Energy",
          subCategory: "Low Carbon",
          desc: `With China's “30·60 Dual Carbon Goals”, green building and sustainability have become hot topics, attracting increasing attention from real estate companies.`
        },
        // 31
        {
          name: "Guidelines for Energy-Saving Review Applications for New Projects",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "Low Carbon Energy",
          subCategory: "Energy",
          desc: `What is an energy-saving review?
Why is it necessary?
How should the application be done?
What are the consequences of violating the regulations?

Course Benefits:
● Understand the importance of applying for an energy-saving review
● Learn which projects require a review
● Master the application process
● Understand the documentation and specific requirements

Target Audience:
● EHS system engineers
● Corporate energy managers
● Legal representatives/managers
● Heads of compliance departments`
        },
        {
          name: "Life Cycle Assessment and Product Carbon Footprint",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "Low Carbon Energy",
          subCategory: "Low Carbon",
          desc: `What are the standards related to LCA and PCF?
What are the advantages of LCA/PCF?
What are the limitations?
What are the steps to calculate a product's carbon footprint?
What are the procedures of the LCA method?`
        },
        {
          name: "Introduction to Life Cycle Assessment",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "Low Carbon Energy",
          subCategory: "Low Carbon",
          desc: `Contents:
● Introductory discussion
● Basic introduction to LCA
● LCA implementation process
● Introduction to product carbon footprint
● Calculations
● Case studies

Target Audience:
● Sustainability and product responsibility staff at manufacturing companies
● Enterprises seeking certification in green products/factories/zero carbon

Course Benefits:
● Understand the relationship between LCA and PCF
● Learn how to calculate PCF`
        },
        {
          name: "Comprehensive Analysis of Green Supply Chain",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "Low Carbon Energy",
          subCategory: "Energy",
          desc: `Course Outline:
1. Background and policies
2. Work content, goals, and processes
3. Progress of green manufacturing systems
4. Requirements for green supply chains
5. Evaluation of green supply chain management
6. Required materials list for enterprises

Course Highlights:
The “14th Five-Year Plan” for Industrial Green Development (2021–2025) emphasizes building green supply chain management enterprises.

● A green supply chain integrates environmental protection and resource conservation throughout the full product lifecycle.
● It aims to promote both internal and upstream/downstream energy efficiency and environmental performance.

This course provides a comprehensive analysis across six key areas.`
        },
        {
          name: "Green Finance Empowering Corporate Low-Carbon Development",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "Low Carbon Energy",
          subCategory: "Low Carbon",
          desc: `Course Outline:
● Overview
● Development of green credit and product cases
● Significance of green credit to corporate low-carbon transition

Course Highlights:
With the national carbon neutrality target, green finance is becoming a crucial tool for achieving low-carbon transformation.

Target Audience:
● Corporate executives
● Financial institution staff in green finance

Course Benefits:
● Understand the concept and development of green finance
● Learn directions for corporate low-carbon development
● Learn how to leverage finance to support sustainability`
        },
        {
          name: "Implementation of China's Energy Conservation Law",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "Low Carbon Energy",
          subCategory: "Energy",
          desc: `Course Outline:
1. Overview of the Energy Conservation Law
2. China's current energy-saving status
3. Energy-saving systems
4. Importance of energy conservation
5. Industrial energy-saving technologies

Target Audience:
● Corporate energy managers
● Professionals in energy-saving fields

Course Benefits:
● Gain insight into China’s current energy-saving efforts
● Promote industrial and energy structural upgrades
● Accelerate corporate energy conservation through industrial technologies`
        },
        {
          name: "Introduction to Carbon Management Systems",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "Low Carbon Energy",
          subCategory: "Low Carbon",
          desc: `Course Highlights:
With the 3060 target, carbon knowledge demand has surged. Carbon management systems help organizations effectively manage their emissions.

Course Outline:
1. What is carbon?
2. What is a carbon management system?
3. Scope of application
4. Implementation timeline

Target Audience:
● Corporate executives
● Carbon managers
● Branding departments
● Environmental managers
● Customer relationship staff

Course Benefits:
● Understand relevant carbon knowledge
● Understand system functions
● Enhance corporate management`
        },
        {
          name: "China's Dual Carbon Policy Development",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "Low Carbon Energy",
          subCategory: "Low Carbon",
          desc: `Course Outline:
1. Evolution of dual carbon policies and goals
2. Carbon reduction policy framework
3. Policy support and corporate challenges

Key Questions:
● What are the relevant regulations?
● What are the requirements for emission management?
● How will these policies impact enterprises?

Course Benefits:
● Understand government targets and requirements
● Track policy trends and dynamics
● Support companies in building emission reduction strategies`
        },
        {
          name: "Policy Interpretation: EU Carbon Border Adjustment Mechanism (CBAM)",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "Low Carbon Energy",
          subCategory: "Low Carbon",
          desc: `Course Outline:
1. CBAM background
● EU climate policies
● Development history
2. CBAM mechanism
● Scope, operation, calculation methods
● Transition period operations
3. Corporate response
● Challenges and countermeasures

Target Audience:
● Executives and board members
● ESG/EHS staff
● GHG/Carbon teams
● Sustainability managers

Course Benefits:
● Understand CBAM content and focus areas
● Analyze challenges and response strategies`
        },
        {
          name: "Energy Saving Practices in Enterprises",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "Low Carbon Energy",
          subCategory: "Energy",
          desc: `Course Outline:
1. HVAC system energy saving
2. Air compressor system efficiency
3. Pumps and motor system energy saving
4. Waste heat and pressure recovery
5. Energy management systems

Target Audience:
● Energy audit and energy-saving personnel
● Energy planners, auditors, consultants

Course Benefits:
● Understand practical energy-saving techniques
● Learn cutting-edge domestic and international energy-saving technologies`
        },
        {
          name: "Policy Interpretation: EU New Battery Regulation",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "Low Carbon Energy",
          subCategory: "Low Carbon",
          desc: `Course Outline:
1. Overview of the EU Battery Regulation
● Key provisions and analysis
2. Response strategies for Chinese enterprises
● Challenges for battery companies
● How enterprises should respond

Target Audience:
● Battery companies and supply chain stakeholders
● ESG/EHS professionals
● GHG/Carbon working groups
● Sustainability managers

Course Benefits:
● Understand policy content and key points
● Learn how to address regulatory challenges`
        },
        {
          name: "Bilingual: EU New Battery Regulation Interpretation",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "Low Carbon Energy",
          subCategory: "Low Carbon",
          desc: `Course Outline:
1. Overview of the new EU Battery Regulation
2. Sustainability and safety requirements
3. Labeling, QR codes, and battery passport
4. Waste battery management requirements
5. Challenges and responses

Target Audience:
● Battery supply chain professionals
● Battery industry staff
● Anyone interested in the new regulation

Course Benefits:
● Understand new regulation provisions and timelines
● Identify challenges and solutions
● Learn impacts on different roles in the supply chain`
        },
        {
          name: "Introduction to Environmental Product Declarations (EPD)",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "Low Carbon Energy",
          subCategory: "Low Carbon",
          desc: `Course Outline:
1. Terminology explanations
2. Introduction to EPD
3. EPD, LCA, and PCF – differences and connections
4. Key features of EPD

Target Audience:
● Environmental managers
● LCA engineers

Course Benefits:
● Understand what EPD is
● Clarify differences among EPD, LCA, and carbon footprint
● Interpret key EPD documents
● Learn the publishing steps for EPDs`
        },
        {
          name: "Introduction to New Energy Vehicle (NEV) Access Regulations",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "Low Carbon Energy",
          subCategory: "Energy",
          desc: `Course Outline:
1. Automotive industry investment regulations (NDRC 2018-22)
2. NEV enterprise/product access regulations (MIIT 2017-39, 2020-54)
3. Vehicle production enterprise/product access regulations (MIIT 2018-50)

Target Audience:
● Auto parts developers/producers
● Whole vehicle manufacturers

Course Benefits:
● Understand why these regulations matter
● Learn what standards must be met for sales/production
● Grasp key regulatory points`
        },
        {
          name: "Product Carbon Footprint to Support Green Development",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "Low Carbon Energy",
          subCategory: "Low Carbon",
          desc: `Course Outline:
1. Policy background
2. Introduction to carbon footprint concepts
3. Overview of carbon footprint standards
4. Enterprise carbon footprint assessment process
5. Case studies

Target Audience:
● Executives and board members
● ESG/EHS personnel
● GHG/Carbon teams
● Sustainability professionals

Course Benefits:
● Understand policy context
● Analyze key policy points
● Master challenges and strategies for response`
        },
        // 46
        {
          name: "Basic Introduction to Carbon Management System",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "Energy & Low Carbon",
          subCategory: "Low Carbon",
          desc: `Course Outline:
1. What is carbon
2. What is a carbon management system
3. Scope of application
4. System establishment cycle

Target Audience:
● Company executives/managers
● Carbon management personnel
● Corporate branding departments
● Environmental management personnel
● Customer relations support staff

Course Benefits:
● Understand relevant knowledge
● Understand the role of the system
● Improve corporate management`
        },
        {
          name: "Decoding Carbon Management System for a Low-Carbon Future",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "Energy & Low Carbon",
          subCategory: "Low Carbon",
          desc: `Course Outline:
1. What are government and customer requirements for corporate carbon management?
2. Detailed explanation of carbon management system establishment and evaluation process
3. How to plan from carbon emissions to carbon neutrality
4. Risks and opportunities under the new circumstances`
        },
        {
          name: "Science-Based Targets and Scope 3 Accounting for Enterprises",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "Energy & Low Carbon",
          subCategory: "Low Carbon",
          desc: `Course Outline:
1. Climate science and human responses
※ Latest findings in climate science
※ Summary of COP28
2. Introduction and interpretation of SBTi
※ How to join SBTi
※ How to set emission reduction targets that meet SBTi standards
3. Scope 3 accounting for enterprises
※ ISO14064 vs. GHG Protocol
※ How companies collect activity data

Target Audience:
● Company executives/managers
● ESG/EHS professionals
● GHG/carbon task force members
● Low-carbon and sustainability managers

Course Benefits:
● Understand the latest in climate science
● Learn the requirements of SBTi
● Grasp the essentials of Scope 3 accounting`
        },
        {
          name: "CCER Mechanism and Carbon Asset Development",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "Energy & Low Carbon",
          subCategory: "Low Carbon",
          desc: `Course Outline:
1. Background of carbon market development
2. Mechanism of carbon offsetting
3. Requirements for China's voluntary emission reduction projects
4. Practice of CCER project development and trading
5. Analysis of the CCER trading market

Target Audience:
● Clean energy and emission reduction company managers and technicians
● Technical consultants
● Individuals interested in CCER project development

Course Benefits:
● Learn about domestic and international carbon markets and offsetting mechanisms
● Improve carbon project development and trading capabilities
● Seize market opportunities and actively participate in national carbon trading`
        },
        {
          name: "Sustainable Development and Energy Transition",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "Energy & Low Carbon",
          subCategory: "Energy",
          desc: `Course Outline:
1. CBAM background and mechanism
※ EU carbon border adjustment mechanism
※ Key operational mechanisms
※ Corporate response strategies
2. Global sustainability and energy transition
※ Progress in global sustainability policies
※ Global clean energy development status
※ Challenges in energy transition
3. Future outlook and global impact

Target Audience:
● Corporate executives/managers
● ESG/EHS professionals
● Carbon task force members
● Sustainability managers

Course Benefits:
● Understand policy content
● Analyze key policy points
● Learn to address challenges`
        },
        {
          name: "Introduction to Product Carbon and Water Footprint",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "Energy & Low Carbon",
          subCategory: "Energy",
          desc: `Course Outline:
1. Overview
2. Introduction to relevant standards
3. Execution process and requirements for companies
4. Importance of carbon and water footprint assessment

Target Audience:
● Company executives/managers
● Production/EHS staff

Course Benefits:
● Understand carbon and water footprint concepts and trends
● Understand corporate directions in low-carbon development`
        },
        {
          name: "Interpretation of Solar Stewardship Initiative (SSI) Standards",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "Energy & Low Carbon",
          subCategory: "Energy",
          desc: `Course Outline:
1. Background
2. SSI standard introduction
3. Scope and key issues
4. Detailed content of the standard
5. Effective date and future developments
6. Impacts on enterprises

Target Audience:
● PV industry executives
● EHS directors
● Dedicated EHS management staff
● ESG officers

Course Benefits:
● Understand core topics of the SSI standard
● Know audit focus areas
● Stay up to date with trends`
        },
        {
          name: "Green Supply Chain: Past and Present",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "Energy & Low Carbon",
          subCategory: "Energy",
          desc: `Course Outline:
1. Background and policies
2. Concepts and standards of green supply chain
3. Implementation and evaluation of green supply chain

Target Audience:
● Corporate environmental staff
● Sustainability department managers
● Procurement and supply chain managers

Course Benefits:
● Understand the importance and benefits of green supply chains
● Learn scientific design of evaluation indicators
● Understand the goals of zero-waste certification`
        },
        {
          name: "Interpretation of Carbon Inclusive Policies and Methodologies",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "Energy & Low Carbon",
          subCategory: "Low Carbon",
          desc: `Course Outline:
1. Concept, background, and role of carbon inclusion
2. Case studies
3. Methodology basics
4. Framework and process of methodology submission

Target Audience:
● Corporate emission reduction officers
● Community environmental officers
● Anyone interested in improving environmental management

Course Benefits:
● Learn carbon inclusion knowledge
● Understand relevant case studies
● Learn the methodology application process`
        },
        {
          name: "Organizational Scope 3 Carbon Accounting",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "Energy & Low Carbon",
          subCategory: "Low Carbon",
          desc: `Course Outline:
1. Importance of Scope 3 accounting
2. How to calculate Scope 3 emissions
3. How to plan enterprise Scope 3 accounting

Target Audience:
● Corporate carbon managers
● Procurement staff
● Individuals interested in carbon management

Course Benefits:
● Understand the importance of Scope 3
● Learn accounting methodologies for Scope 3
● Prepare your enterprise for Scope 3 reporting`
        },
        // 70
        {
          name: "Regulation Focus: Interpretation of Discharge Standards for Water Pollutants in the Electronics Industry (GB 39731-2020)",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "Environment",
          desc: `Do you have these questions before the class?
- Do electronics companies still need to follow electroplating discharge standards?
- What changes have been made to the pollutant discharge limits?
- What is the newly added comprehensive toxicity control item?
- What is the benchmark drainage per unit product? How to calculate the actual drainage?

Course Benefits:
- Understand the relevant content specified in the standard
- Learn key technical requirements for wastewater discharge in electronics companies
- Gain insight into monitoring requirements and standardization of outlets

Target Audience:
- Managers of centralized wastewater treatment facilities in electronics companies
- Environmental protection managers in electronics companies
- Supervisors or leaders in electronics companies`
        },
        {
          name: "Interpretation of the Biosafety Law of the People's Republic of China",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "Safety",
          desc: `As a milestone in biosafety governance by law, what connections does this law have with you and what security guarantees does it provide?

- What is the national security legal framework?
- What is the legislative background of the Biosafety Law?
- What are the key contents of the Biosafety Law?
- What are the key points to pay attention to in this regulation?

Course Benefits:
- Gain a systematic understanding of national security laws and regulations
- Learn about the legislative background of the Biosafety Law
- Master the key contents and precautions of the regulation

Recommended Audience:
- Biosafety management officers
- Lab EHS managers in all departments
- Company executives, general managers, and safety supervisors`
        },
        {
          name: "Regulation Focus: Interpretation of the Production Safety Law of the People's Republic of China (2021 Revision)",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "Safety",
          desc: `- What are the safety production responsibilities for enterprises?
- How are the responsibilities of company leaders defined?
- What are the obligations of safety management personnel?
- What are the new penalty provisions in the revised law?
- How should companies respond?

Course Benefits:
- Guide companies to implement the new law
- Understand the legal requirements for companies
- Improve corporate safety management

Target Audience:
- Company executives
- EHS department heads
- Safety personnel and those seeking to enhance safety capabilities`
        },
        {
          name: "Overview of Enterprise Safety Management Documentation",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "Safety",
          desc: `Do you have the following questions?
- Too many safety documents — where to begin?
- How to ensure compliance of safety documents with regulations?

Course Benefits:
- Understand what safety documents companies need
- Learn the legal basis for each safety document

Target Audience:
- Safety engineers
- Safety managers
- Personnel aiming to improve safety management`
        },
        {
          name: "Key Points of Environmental Compliance and Case Analysis of Violations",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "Environment",
          desc: `- What should companies do in daily environmental protection?
- What key points should be checked for compliance?
- What are the common environmental violation cases?

Course Benefits:
- Understand current trends and practices in corporate environmental management
- Master key compliance points and build management ledgers
- Avoid violations through typical case analysis

Target Audience:
- EHS managers and specialists
- Personnel seeking to build environmental management skills`
        },
        {
          name: "Regulation Focus #29: Interpretation of Measures for the Administration of Legal Disclosure of Corporate Environmental Information",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "Environment",
          desc: `- What is the scope of application of the Measures?
- Which enterprises are required to disclose environmental information?
- What are the key contents, formats, and deadlines?
- What are the penalties for non-compliance?

Course Benefits:
- Learn the background and key provisions of the Measures
- Understand disclosure requirements and how to comply
- Gain practical suggestions for enterprises

Target Audience:
- Legal representatives
- EHS leaders and technical staff`
        },
        {
          name: "EHS Regulation Update Course Vol.8: Interpretation of 2021 Annual EHS Regulation Updates",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "Regulations",
          desc: `In 2021, over 1,094 national-level EHS regulations and 276 drafts were published.

Topics include:
- China’s dual-carbon “1+N” policy system
- New emission permit management regulations
- Mandatory environmental info disclosure
- Noise pollution control
- Full-process hazardous waste management
- Occupational health system reform
- New safety production law updates`
        },
        {
          name: "Regulation Focus: Electrical Risk Prevention and Safety Management",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "Safety",
          desc: `This course provides comprehensive knowledge of electrical safety management, with real accident cases, legal interpretations, and risk analysis.

- What are the key electrical safety concerns?
- What legal references apply to hidden hazards?`
        },
        {
          name: "Public Fire Safety Knowledge",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "Safety",
          desc: `Fire safety concerns everyone. Learn how to prevent fires and respond properly in emergencies.

Course Benefits:
- Understand fire theory and prevention
- Learn correct fire extinguishing methods
- Master scientific escape techniques`
        },
        {
          name: "General Industrial Solid Waste Management",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "Environment",
          desc: `This course explains the new Solid Waste Law requirements and how to build internal waste management systems.

Target Audience:
- Company executives
- EHS managers and specialists

Course Benefits:
- Accurate interpretation of EHS laws
- Understand audit focus points
- Stay current with regulations`
        },
        {
          name: "Regulation Focus: General Specification for Fire Protection Facilities (GB55036-2022) — Fire Extinguishers",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "Safety",
          desc: `The new national standard came into force on March 1, 2023.

Course Benefits:
- Understand the updated fire extinguisher standards
- Learn about obsolete regulations

Key Questions:
- What are the new fire extinguisher selection rules?
- Are the disposal criteria updated?
- Has the maximum service life changed?`
        },
        {
          name: "How to Improve Safety Leadership",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "Safety",
          desc: `1. What is safety? What is safety leadership?
2. What is the purpose of safety management?
3. Tools to enhance safety leadership
4. Best practices from leading companies
5. Safety management curve

Highlights:
- Simplified understanding of safety challenges
- Efficient regulation interpretation
- Practical safety leadership tools
- Case-based learning

Target Audience:
- Executives and line managers
- Safety professionals
- Team leaders

Course Benefits:
- Understand and enhance safety leadership
- Adopt new mindsets and strategies in safety`
        },
        {
          name: "Regulation Focus: Measures for the Administration of Safety Production Expenses (2022 Revision)",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "Safety",
          desc: `Course Content:
1. Scope of the Measures
2. Standards for safety expense allocation and use
3. Management and supervision

Highlights:
- Applicable to 12 types of industries
- Specific standards and rules provided

Target Audience:
- EHS managers and professionals

Course Benefits:
- Understand the scope, allocation, and management requirements of the new Measures`
        },
        {
          name: "Recent Environmental Penalty Case Studies",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "Environment",
          desc: `Course Content:
1. China’s environmental landscape
2. Analysis of recent penalty cases
3. Current status and future outlook for companies

Highlights:
- Learn from typical cases
- Understand legal trends
- Improve environmental awareness and compliance

Target Audience:
- Corporate managers
- EHS professionals
- Environmental supervisors

Course Benefits:
- Understand trends in penalties
- Learn from case studies to strengthen compliance`
        },
        {
          name: "Regulation Focus: Interpretation of Latest Policies on New Pollutants",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "Environment",
          desc: `Course Content:
1. Definition of new pollutants
2. Latest policies
3. Regional summaries

Highlights:
- Understand new pollutant definitions and their relation to chemical substance registration
- Learn how to respond to new policy requirements

Target Audience:
- Environmental/EHS managers
- Chemical procurement officers
- Toxic substance control staff

Course Benefits:
- Understand current permitting practices
- Solve common application issues
- Master post-permit monitoring execution`
        },
        {
          name: "Regulation Focus: Interpretation of the Latest General Specifications for Building Fire Protection and Fire Facilities",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "Safety",
          desc: `Course Content:
1. Background and objectives of the specification
2. Overview of new GB55036 and GB55037 standards
3. Comparison with existing technical standards
4. Importance of reliable fire safety
5. Fire safety assessments and inspections

Highlights:
- Understand new codes GB55036 and GB55037
- Ensure legal compliance
- Prevent fire risks from outdated facilities

Target Audience:
- EHS engineers
- Fire safety managers and inspectors
- Maintenance and assessment personnel

Course Benefits:
- Understand fire facility compliance
- Prevent regulatory penalties`
        },
        // 86
        {
          name: "Responsibilities of Employees for Achieving Safe Production in Enterprises",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "Safety",
          desc: `Course Outline:
1. The significance of employees in achieving safe production in enterprises
2. What safety production responsibilities employees have and how enterprises implement employees' safety responsibilities
3. Legal liabilities of enterprises related to employees' failure to perform duties
Target Audience:
● Enterprise principals & BU leaders
● EHS safety managers
● Enterprise employees
● Individuals intending to improve safety management capabilities
Course Benefits:
● Enterprise managers understand employees' safety production responsibilities and the legal liabilities enterprises bear if employees fail to perform duties
● Employees understand the safety responsibilities they must assume and legal penalties for failing to perform duties`
        },
        // 87
        {
          name: "Regulation Focus – Occupational Health Management",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "Occupational Health",
          desc: `Course Highlights:
Against the background of Occupational Disease Prevention Law Promotion Week, this course interprets important regulations on occupational health management, comprehensively covering the requirements of enterprises' occupational health management and common compliance considerations.
Course Outline:
1. Basics of occupational disease prevention
2. Common regulations for occupational disease protection management
3. Interpretation of "Workplace Occupational Health Management Regulations"
Target Audience:
● EHS managers and engineers
● Occupational health management personnel
● Employees and managers exposed to occupational hazards
Course Benefits:
● Understand basics of occupational diseases and prevention
● Master the list of regulations related to occupational health management
● Focus on employer workplace perspective, elements and compliance considerations of occupational health management`
        },
        // 88
        {
          name: "Zero Landfill Waste Management System",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "Environment",
          desc: `Course Highlights:
The development of “Zero Waste Cities” is an important measure to promote synergistic effects of pollution reduction and carbon abatement, and an intrinsic requirement for achieving the Beautiful China goals. The “14th Five-Year Plan for Zero Waste City Construction” clearly aims to promote about 100 prefecture-level and above cities to implement zero waste city construction by 2025, with significant reduction in solid waste generation intensity, enhanced comprehensive utilization, effective harmless disposal capacity, full synergistic effect of pollution reduction and carbon abatement, basically achieving a unified solid waste management information network, wide recognition of the “zero waste” concept, and marked improvement in the solid waste governance system and capability.
Target Audience:
1. Enterprise managers
2. EHS system engineers
3. Enterprise environmental protection leaders
4. Individuals intending to improve environmental management capabilities
Course Outline:
1. “Zero landfill” system and China’s “Zero Waste”
2. Waste zero landfill management system
3. How enterprises respond to “Zero Waste” and zero landfill
Course Benefits:
1. Understand relevant policies of “Zero Waste” and zero landfill in China
2. Understand core content of “Waste Zero Landfill Management System”
3. Stay at the forefront of environmental management, turn risks into opportunities, and establish industry environmental benchmarks`
        },
        // 89
        {
          name: "Regulation Focus – Building Fire Prevention and Safe Evacuation",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "Safety",
          desc: `Course Outline:
1. Fire accidents caused by evacuation issues
2. Administrative penalties for evacuation problems
3. Legal requirements for safe evacuation
4. Proper setup of evacuation exits, evacuation doors, and safety exits
5. Specific requirements for evacuation door standards
Target Audience:
● EHS system engineers
● Fire safety responsible persons and fire safety managers
● Fire maintenance, inspection, and safety assessment personnel
Course Benefits:
● Understand the importance of safe evacuation
● Correctly set evacuation exits, doors, and safety exits
● Learn principles for setting evacuation routes
● The quality of evacuation setups plays a crucial role in fire rescue`
        },
        // 90
        {
          name: "Environmental Emergency Plan Compliance Management",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "Environment",
          desc: `Course Outline:
1. Why compile environmental emergency plans
2. How to compile environmental emergency plans
3. Key points of compliance management
Target Audience:
● Environmental/EHS managers
● Environmental emergency plan team members
● Individuals interested in understanding environmental emergency plans
Course Benefits:
● Understand regulations and policies on environmental emergency plans
● Learn how to formulate your organization's environmental emergency plans
● Review key compliance management points for emergency plans`
        },
        // 91
        {
          name: "Supply Chain Traceability Services",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "Supply Chain",
          desc: `Course Outline:
01 Background 
02 Supply chain mapping
03 Traceability Management System Audit
04 Audit Steps 
Course Highlights:
1. Countermeasures for enterprises regarding the implementation of the Uyghur Forced Labor Prevention Act;
2. Traceability audit considerations using the photovoltaic industry as an example;
3. Traceability audit steps using the photovoltaic industry as an example.
Target Audience:
● Legal persons/managers of related enterprises
● Quality (traceability) managers of related enterprises
● Dedicated traceability management personnel
● Traceability technical personnel of related enterprises
Course Benefits:
● Detailed explanation of relevant laws and regulations
● Understand audit focus points`
        },
        // 92
        {
          name: "Interpretation of Accident Emergency Response Regulations",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "Safety",
          desc: `Course Outline:
I. General Provisions
Overview and basic information about the regulations
II. Discussion of recently promulgated accident emergency regulations
Coverage of regulatory scope and related laws
National and local responses to new laws
III. Criminal law provisions on penalties for production safety accidents
Target Audience:
● Enterprise principals
● Enterprise safety management personnel
● Frontline employees
Course Benefits:
● Help safety-related personnel understand regulatory trends and enhance professional literacy
● Assist safety personnel in implementing new regulatory requirements and improving professional ability
● Identify gaps and supplement by discussing new laws and standards`
        },
        // 93
        {
          name: "Twenty Questions on Emission Rights",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "Environment",
          desc: `Course Outline:
1. Definition and overview of emission rights
2. Overview of emission rights trading
3. Development and pilot status of emission rights trading in China
4. Interpretation of relevant laws and regulations on emission rights trading
5. Processes and challenges of enterprises engaging in emission rights trading
Target Audience:
● Management personnel of enterprises involved in emission rights trading
● Personnel in industries related to emission rights
● Individuals interested in emission rights management and trading
Course Benefits:
● Understand the connotation of emission rights and the trading process
● Understand the positioning and roles of enterprises in emission rights trading
● Understand relevant laws and regulations related to emission rights and trading`
        },
        // 94
        {
          name: "Product Export: How Enterprises Respond to International Labor Concerns",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "Labor",
          desc: `Course Outline:
1. Background overview
2. Related laws and guidelines
3. Labor audit focus points
4. Labor work environment and health (OHS) audit points
5. Preparations enterprises can make
Course Highlights:
With increasing attention and restrictions from the EU and US on "forced labor" issues in Chinese export products, this course helps enterprises and related suppliers understand the "human rights" issues overseas clients focus on during audits, enabling them to prepare in advance and reduce potential risks.
Target Audience:
● Legal persons/managers of enterprises
● Human resources and system leaders of enterprises
Course Benefits:
● Learn different audit focus points
● Understand involved laws and relevant international treaties`
        },
        // 95
        {
          name: "Regulation Focus – Criteria for Major Accident Hazards in Industrial and Trade Enterprises (Management and Special Categories)",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "Safety",
          desc: `Course Outline:
1. Scope of application of the "Criteria"
2. Management category major accident hazard criteria
3. Special category major accident hazard criteria
Target Audience:
● EHS leaders
● Dedicated EHS management personnel
● Senior EHS technical personnel
Course Benefits:
● Understand the criteria for management category major accident hazards in industrial and trade enterprises
● Understand the criteria for special category major accident hazards`
        },
        // 96
        {
          name: "Safety Management: Gas Safety",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "Safety",
          desc: `Course Outline:
1. Analysis of gas safety accident cases
2. Key components of household gas
3. Common safety hazards and legal basis in gas management processes
Target Audience:
● Residents and commercial users
● Safety managers of commercial and industrial users
● Gas company managers
Course Benefits:
● Learn lessons from accidents
● Understand key safety components in gas usage
● Recognize commonly overlooked hazards in management and correctly understand gas safety regulations and standards`
        },
        // 97
        {
          name: "Interpretation of Key Polluting Units",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "Environment",
          desc: `Course Outline:
1. Process for identifying key polluting units
2. Classification and requirements of key polluting units
3. Obligations key polluting units must fulfill
Target Audience:
● Legal persons/managers of enterprises
● Environmental managers of enterprises
● Environmental technical personnel of enterprises
Course Benefits:
● Understand the process and timing of identifying key polluting units
● Understand the requirements for various key polluting units
● Understand obligations key polluting units must fulfill`
        },
        // 98
        {
          name: "How Enterprises Conduct Post-Holiday Fire Inspections",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "Safety",
          desc: `Course Outline:
1. Methods of enterprise fire inspection
2. Content of enterprise fire inspections
3. Cases of fire safety hazards
Target Audience:
● Enterprise fire safety leaders
● Enterprise fire management personnel and managers of key fire areas
● Fire service agency personnel
Course Benefits:
● Content of post-holiday fire inspections
● Methods of post-holiday fire inspections
● Promote enterprises to implement fire safety responsibility systems through fire cases`
        },
        // 99
        {
          name: "Interpretation of Safety Risks and Prevention Regulations in Confined Spaces",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "Regulations",
          desc: `Target Audience:
● EHS personnel in industrial and trade enterprises
● Confined space operators and supervisors in industrial and trade enterprises
Course Benefits:
● Analyze key requirements of "Safety Regulations for Confined Space Operations in Industrial and Trade Enterprises"
● Recognize safety risks of confined spaces
● Master responsibilities of confined space operators and supervisors`
        },
        // 100
        {
          name: "Environmental Compliance Series: Setting of Hazardous Waste Identification Labels",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "Environment/Safety",
          desc: `Course Outline:
1. Legal basis and standards for setting hazardous waste identification labels
2. Content, production, and setting requirements of three types of hazardous waste identification labels
3. Practical issues and suggestions in enterprise implementation
Target Audience:
● Environmental protection leaders of enterprises
● Dedicated environmental management personnel in EHS departments
● EHS consultants
Course Benefits:
● Detailed interpretation of hazardous waste identification label requirements
● Improve enterprise hazardous waste environmental management levels
● Enhance enterprise environmental management performance`
        },
        // 101
        {
          name: "Together We Build a 'Zero Waste City'",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "Environment",
          desc: `Course Outline:
1. Background and related policies of "Zero Waste City" implementation
2. Evaluation index system of "Zero Waste Factory"
3. "Zero Landfill" management system
Target Audience:
● Enterprise legal persons/sustainable development leaders
● Heads of EHS and ESG departments
● Enterprise environmental protection leaders
● Environmental management personnel
Course Benefits:
● Understand policies related to "Zero Waste City" construction
● Based on China's current waste treatment and disposal status, seek entry points for "reduction, reuse, harmless disposal" of solid waste
● Requirements related to management systems
● Learn to create "Zero Waste Factories" and "Zero Landfill" systems`
        },
        // 102
        {
          name: "Discussing How Enterprises Can Do Fire Prevention and Control Through Fire Cases",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "Safety",
          desc: `Course Outline:
1. Typical fire case analysis
2. Current situation of enterprise fire management
3. How to do a good job in fire management
4. Fire safety assessment system
Target audience:
● Fire safety responsible persons
● Fire safety management personnel and fire facility maintenance technicians
● General personnel
Course benefits:
● Correctly understand the statutory requirements for fire maintenance and testing work
● Learn methods to prevent fires
● Learn methods to extinguish initial fires`
        },
        // 103
        {
          name: "Sustainable Due Diligence in Supply Chain",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "Supply Chain",
          desc: `Course Outline:
1. Introduction — concept and attributes of supply chain
2. Supply chain responsibility initiatives and standards
3. Supply chain social responsibility management
4. Supply chain due diligence legislation and development trends
Target audience:
● Enterprise environmental protection staff
● HR management personnel
● Sustainable development department managers
● Procurement and supply chain leaders
Course benefits:
● Understand supply chain concepts and social attributes
● Understand related standards and norms for supply chain social responsibility
● Learn how to manage supply chain due diligence`
        },
        // 104
        {
          name: "Enterprise Supply Chain Traceability Management",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "Supply Chain",
          desc: `Course Outline:
1. Concept of traceability
2. Traceability management
3. How to implement traceability management
4. Enterprises’ proactive response
Target audience:
● Senior enterprise managers
● Supply chain managers
● Personnel interested in enterprise sustainable development topics
Course benefits:
● Establish enterprise sustainable development concepts
● Understand the importance of traceability management in sustainable development
● Learn to integrate traceability management into enterprise management practices`
        },
        // 105
        {
          name: "Safety Management of Keeping Life Channels Clear",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "Safety",
          desc: `Course Outline:
1. Fire accident case analysis
2. Correct understanding of "keeping life channels clear"
3. Legal requirements for "keeping life channels clear"
Target audience:
● Safety management personnel in enterprises, institutions, and commercial complexes
● Fire safety responsible persons and fire safety managers
● Fire maintenance testing and safety assessment personnel
Course benefits:
● Learn from fire accident lessons
● Correctly understand the meaning of "life channel"
● How to inspect and ensure the "life channel" is clear`
        },
        // 106
        {
          name: "Focusing on the Four Categories of Special Equipment Personnel, Discuss How Special Equipment Using Units Implement Main Safety Responsibilities",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "Regulation",
          desc: `Course Outline:
Part 1: Accident Types Related to Special Equipment
√ Pressure vessel explosion accidents
√ Forklift overturn injury accidents
√ Elevator fall accidents
√ Lifting machinery accidents
Part 2: How special equipment using units implement main responsibilities
√ Types of special equipment
√ Organizational structure
√ Content of main responsibilities
√ How to implement
Part 3: Summary of special equipment related regulations
Target audience:
● Enterprise safety management personnel (safety directors, engineers, safety officers, etc.)
● Enterprise key personnel
● Special equipment management and operation personnel
● Personnel aiming to improve safety management capability
Course benefits:
● Understand accident types related to special equipment to avoid risks
● Find applicable solutions for difficult issues in special equipment use and management
● Understand key points of main responsibility implementation for special equipment using units`
        },
        // 107
        {
          name: "Review of EHS Regulations in the First Half of 2024",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "Regulation",
          desc: `Course Outline:
1. Overview of 2024 H1 EHS regulation and policy updates
2. Key regulation and standard content review for H1
—— Pollution discharge permit management measures
—— Water saving regulations
—— Three-year action plan for tackling fundamental safety production
—— Emergency response plan management measures
—— Notice on direct reporting of enterprise safety production costs
Target audience:
● Enterprise legal persons/managers
● EHS leaders
● Dedicated EHS management personnel
● Senior EHS technical staff
● Personnel interested in EHS regulatory policies
Course benefits:
● Real-time updates on EHS regulations and standards
● Learn key new EHS regulations and standards
● Master changes in EHS regulations
● Understand latest EHS policy trends`
        },
        // 108
        {
          name: "Environmental Compliance Series: Waste Zero Landfill Management System",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "Environment",
          desc: `Course Outline:
1. What is waste zero landfill
2. Establishment of waste zero landfill management system
3. Certification of waste zero landfill management system
Target audience:
● Enterprise environmental protection leaders
● Dedicated EHS environment management personnel
● EHS consultants
Course benefits:
● Detailed interpretation of hazardous waste identification label setting requirements
● Improve hazardous waste environmental management in enterprises
● Enhance enterprise environmental management performance`
        },
        // 109
        {
          name: "How Enterprises Can Do Effective Electrical Safety Management",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "Safety",
          desc: `Course Outline:
1. Typical electrical fire case analysis
2. Current state of enterprise electrical management
3. How to do electrical management well
4. Electrical safety assessment system
Target audience:
● Electrical safety responsible persons
● Electrical safety engineers and technicians
● Electrical designers
Course benefits:
● Correctly identify electrical safety hazards
● Understand electrical design principles
● Master methods to rectify electrical safety hazards`
        },
        // 110
        {
          name: "Discussion on Global Automotive Market Access and Regulations Under the 'Going Global' Trend",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "Automotive",
          desc: `Course Outline:
1. Analysis of the rapidly growing automotive export market
2. Introduction to global vehicle certification and regulations
3. One-stop automotive regulation services by Honglv Yuan
4. Q&A
Target audience:
● Parts manufacturers
● Vehicle manufacturers
● Testing and certification agencies
Course benefits:
● Establish a basic knowledge framework for automotive export
● Understand EU E-MARK certification system
● Improve product regulatory compliance`
        },
        // 111
        {
          name: "Discussion on EU Type Approval and GSR II Key Points",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "Automotive",
          desc: `Course Outline:
1. Focus on EU type approval
2. GSR update content
3. Regulation interpretation services
Target audience:
● Enterprises intending to export whole vehicles and parts to the EU
● Regulation interpretation personnel
● Those interested in automotive regulation status and looking to purchase regulation services
Course benefits:
● Establish basic knowledge framework for automotive export
● Deep interpretation of GSR II update points
● Regulatory interpretation and compliance`
        },
        // 112
        {
          name: "Pollution Discharge Permit Management Regulation Requirements and Compliance Management",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "Environment",
          desc: `Course Outline:
1. Review of new pollution discharge permit system implementation
2. Preparation for applying pollution discharge permit declaration system
3. How the electronics industry applies for pollution discharge permits
4. Main content of post-approval supervision
Target audience:
● Environmental engineers
● Enterprise environmental protection leaders
● Personnel aiming to improve environmental management capability
Course benefits:
● Understand the framework of pollution discharge permit regulations
● Learn the latest pollution discharge permit management requirements
● Master compliance management key points for pollution discharge permits`
        },
        // 113
        {
          name: "How Enterprise Environmental Management Personnel Read Environmental Impact Assessment Reports",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "Environment",
          desc: `Course Outline:
1. What is an Environmental Impact Assessment (EIA)
2. Why perform an EIA
3. How to conduct an EIA
4. Quick Q&A on EIA knowledge
Target audience:
● Enterprise environmental management personnel
● EHS department leaders
● Enterprise environmental protection engineers
Course benefits:
● Understand basic knowledge related to EIAs
● Understand the structure framework of EIAs
● Learn to incorporate EIA reports into daily environmental management`
        },
        // 114
        {
          name: "Key Interpretation and Admission Discussion of UN ECE R10 Regulation",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "Automotive",
          desc: `Course Outline:
1. Global regulatory background
2. Detailed explanation of UN ECE R10 terminology
3. Introduction to EU admission
4. Technical details of UN ECE R10
5. Key comparisons between Chinese and EU regulations
Target audience:
● Enterprises intending to export whole vehicles and parts to the EU
● Enterprise standardization staff
● Those interested in automotive regulation status and regulation service purchase needs
Course benefits:
● Deep interpretation of UN ECE R10 key points
● Technical comparison of GB 34660-2017 and UN ECE R10
● Regulatory interpretation and compliance`
        },
        // 115
        {
          name: "Laboratory Safety Management Training",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "Safety",
          desc: `Course Outline:
1. Background of laboratory safety management
2. Content and reference standards of laboratory safety management
3. Laboratory safety management cases
4. Summary and insights
Target audience:
● Enterprise EHS management personnel
● Laboratory management personnel
● Company key responsible persons
Course benefits:
● Understand tools and standards for laboratory safety management
● Master key points and difficulties in laboratory safety management`
        },
        // 116
        {
          name: "How Enterprises Build Product Traceability Systems",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "Supply Chain",
          desc: `Course Outline:
1. International requirements for traceability
2. Product traceability focus modules
3. What effective traceability is
4. How enterprises respond
Target audience:
● Senior enterprise managers
● Quality management personnel
● Supply chain managers
● Production management personnel
● Personnel interested in traceability systems
Course benefits:
● Understand international requirements for product traceability
● Learn the establishment, implementation, and improvement of traceability systems`
        },
        // 117
        {
          name: "Quick Description of EHS Status — Where We Are?",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "EHS",
          desc: `Course Outline:
1. Difficulties in describing the unit's EHS status
2. Difficulties in communicating EHS status with senior management
3. Solutions
4. Communication examples in several scenarios
5. Summary
Target audience:
● EHS system engineers
● Enterprise EHS leaders
● Personnel aiming to improve management capability
Course benefits:
● Understand unit EHS difficulties
● Understand EHS communication challenges
● Reference methods to solve issues`
        },
        // 118
        {
          name: "Regulation Focus: Technical Specification for Testing of Building Fire Protection Facilities (GB/T 44481-2024)",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "Regulation",
          desc: `Course Outline:
1. Scope and definitions of the standard
2. Contents of testing building fire protection facilities
3. Technical requirements for testing building fire protection facilities
Target audience:
● EHS management personnel
● Fire safety management personnel
● Building fire protection facility testing personnel
Course benefits:
● Understand the contents of testing building fire protection facilities
● Understand the technical requirements of testing building fire protection facilities`
        },
        // 119
        {
          name: "Sharing on Full Implementation of Pollution Discharge Permit System",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "Regulation",
          desc: `Course Outline:
1. Background and purpose of reform
2. Key tasks
3. Local government regulations
4. Enterprise response measures
Target audience:
● Relevant enterprise managers
● Relevant enterprise environmental management personnel
● Personnel interested in pollution discharge permit reform
Course benefits:
● Understand the current key reform tasks of full implementation of pollution discharge permit system
● Learn related fixed pollution source systems and management measures
● Help enterprises build environmental management systems based on pollution discharge permits`
        },
        // 120
        {
          name: "Interpretation of 'Liquefied Petroleum Gas Cylinders' (GB5842-2023)",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "Regulation",
          desc: `Course Outline:
1. Preface
2. Analysis of main changes
3. Detailed interpretation of the standard
Target audience:
● Managers, safety personnel, and operators in LPG cylinder manufacturing units
● Managers, safety personnel, and operators in LPG cylinder filling units
● Managers, safety personnel, and operators in LPG cylinder using units
Course benefits:
● Enterprises manufacturing cylinders can correctly understand manufacturing requirements through this interpretation.
● Filling and transportation units can better recognize qualified cylinders and improve transportation safety.
● Using units can manage cylinders more safely and effectively through this interpretation.`
        },
        // 121
        {
          name: "Electricity-Carbon Synergy Promoting Green Energy Transition & Carbon Reduction",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "Low Carbon",
          desc: `Course Outline:
1. Basic concepts of electricity-carbon synergy
2. Status of China's electricity-carbon market
3. Market mechanisms and cases of electricity-carbon synergy
Target audience:
● Personnel related to power companies
● Participants in the carbon trading market
● Researchers and academic scholars
● Government departments and policymakers
Course benefits:
● Deeply understand the market mechanisms and technical pathways of electricity-carbon synergy
● Master practical operation methods of green electricity trading and carbon reduction
● Enhance competitiveness and innovation ability in green energy transition`
        },
        // 122
        {
          name: "Special Topic on Working at Heights",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "Safety",
          desc: `Course Outline:
1. Understanding working at heights
2. Relevant laws, regulations and standards summary
3. Operations and protections for working at heights
Target audience:
● Safety engineers
● Operators, supervisors, and production managers for working at heights
● Personnel aiming to improve safety management ability
Course benefits:
● Understand hazards and consequences of falls from height; raise awareness
● Help related personnel better identify and prevent risks in working at heights
● Reduce probability of fall accidents from height`
        },
        // 123
        {
          name: "Key Contents and Changes in the 2025 Edition of Hazardous Waste Catalogue",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "EHS",
          desc: `Course Outline:
1. Interpretation of key contents of 2025 national hazardous waste catalogue
2. Interpretation of changes in the 2025 national hazardous waste catalogue
3. What enterprises should do regarding these changes
Target audience:
● EHS leaders
● Dedicated EHS management personnel
● Senior EHS technical staff
Course benefits:
● Fully master relevant contents of 2025 national hazardous waste catalogue
● Clarify necessary adjustments in hazardous waste management work
● Obtain practical suggestions for hazardous waste management`
        },
        // 124
        {
          name: "Interpretation of New 'Occupational Disease Classification and Catalogue'",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "EHS",
          desc: `Course Outline:
1. Definition and four elements of occupational diseases
2. Detailed explanation of 'Occupational Disease Classification and Catalogue'
3. Legal protections for occupational disease patients
4. Enterprise occupational disease prevention and management
Target audience:
● Enterprise occupational health leaders
● Occupational health management personnel
● Employees in high-risk occupational disease posts
● Personnel aiming to improve occupational health management capability
Course benefits:
● Understand latest changes in occupational disease classification and catalogue
● Learn about various occupational diseases and occupational hazards
● Master occupational disease management strategies`
        },
        // 125
        {
          name: "Interpretation of Due Diligence Compliance Requirements",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "EHS",
          desc: `Course Outline:
1. Background of EU due diligence
2. Main requirements of EU due diligence
3. Due diligence execution steps
4. Common challenges in due diligence
Target audience:
● Enterprise supply chain managers
● Enterprise quality management personnel
● Enterprise EHS managers
Course benefits:
● Understand EU requirements on due diligence compliance
● Explain due diligence execution steps from preparation to operation
● Understand common problems in due diligence`
        },
        // 126
        {
          name: "How to Respond to EU Green Trade Barriers Product Environmental Footprint (PEF)",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "EHS",
          desc: `Course Outline:
1. EU regulations and policies related to environmental footprint methods
2. Basic concepts and key points of environmental footprint methods
3. Main differences between environmental footprint methods and ISO 14040 series LCA standards
4. How enterprises respond (focus on textile industry)
Target audience:
● EHS system engineers
● Enterprise environmental protection leaders
● Personnel aiming to improve environmental management capabilities
Course benefits:
● Understand what EU environmental footprint is
● Learn basic concepts and methods of PEF
● Understand how enterprises respond to EU green trade barriers
● Learn how enterprises better manage low carbon`
        },
        // 127
        {
          name: "Regulation Focus — 'Dust Explosion Pressure Relief Specification (GB 15605-2024)'",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "EHS",
          desc: `Course Outline:
1. Scope
2. Terms and definitions
3. Technical requirements
4. Installation, use, and maintenance
5. Verification methods
Target audience:
● EHS management personnel
● Fire safety management personnel
● Equipment management personnel
Course benefits:
● Understand technical requirements for dust explosion pressure relief
● Understand installation, use, and maintenance requirements of explosion relief devices
● Understand corresponding verification methods`
        },
        // 128
        {
          name: "Supply Chain Traceability Practice",
          hours: "12 hours",
          startTime: "August 10, 2025",
          category: "EHS",
          subCategory: "ESG",
          desc: `Course Outline:
1. Basic concepts
2. Purpose of supply chain traceability evaluation
3. Technical elements of traceability
4. Traceability evaluation process and content
Target audience:
● Supply chain management and procurement
● Quality management personnel
● Production, manufacturing, and warehousing logistics
● Overseas sales personnel
Course benefits:
● Understand sources and purposes of supply chain traceability
● Understand technical elements of supply chain traceability
● Understand evaluation process and content of supply chain traceability`
        },

      ]
    },
    serviceSupport: {
      welcome: 'Welcome to RedC Center',
      tryRedC: 'Try RedC >',
      business: {
        title: 'Business Consultation',
        phone: 'Business Phone',
        email: 'Business Email',
        wechat: 'Business WeChat'
      },
      technical: {
        title: 'Technical Support',
        phone: 'Technical Phone',
        email: 'Technical Email',
        wechat: 'Technical WeChat'
      }
    },
    understandRedC: {
      title: 'About Us',
      desc: 'Hong Lv Yuan Supply Chain Management (Shanghai) Co., Ltd. is a strategic management service provider dedicated to building green and sustainable supply chains for enterprises. We have extensive hands-on experience in areas such as energy conservation, low carbon, environmental protection, ESG, and digital transformation, supported by a team of seasoned industry experts who ensure the successful implementation of our projects.',
      features: 'Our vision is to provide our clients with professional and efficient one-stop solutions, working hand in hand toward a new era of sustainable development.',
      freeUse: 'Free Use >',
      AdvantagesRedC: 'Advantages of RedC',
      advantages: {
        title: 'Integrated Carbon Management Solution',
        desc: ['RedC covers the entire process from data collection, carbon emission calculation, and report generation to emission reduction planning, monitoring, and project management.', 'Helps enterprises efficiently manage carbon emissions and reduce the cost of switching between different tools.'],
      },
      SaaS: { 
        title: 'SaaS Model',
        desc: ['Enterprises can quickly go live and use the platform, reducing IT maintenance costs.', 'Ensures continuous updates and optimization of the software.'],
      },
      dataCollection: {
        title: 'Data Collection and Factor Matching Capabilities',
        desc: ['Supports multiple data sources and can match factors based on industry standards.', 'Ensures the accuracy of carbon emission calculations and compliance with international carbon accounting methodologies.'],
      },
      automation: {
        title: 'Automated Carbon Emission Calculation and Report Generation',
        desc: ['Supports one-click generation of carbon emission reports that meet regulatory and market requirements.', 'Reduces manual calculations and compliance risks.'],
      },
      moduleDesign: {
        title: 'Modular Design',
        desc: ['RedC provides multiple modules such as organizational carbon, product carbon, and CBAM.', 'Enterprises can choose as needed to meet carbon management requirements for different scales and industries.'],
      },
      dataAnalysis: {
        title: 'Intelligent Analysis and Emission Reduction Strategy Optimization',
        desc: ['Built-in intelligent analysis tools provide carbon emission trend forecasting, emission reduction recommendations, and visualized insights.', 'Helps enterprises formulate sustainable development strategies and improve the scientific basis of carbon management decisions.'],
      },
      operationDemoVideo: 'Operation demonstration video',
    },
    bookDemo: {
      title: 'Consultation Now',
      desc: 'Please complete the following information. Our consultant will contact you within one working day',
      name: 'Name',
      inputName: 'Please enter your name',
      phone: 'Phone',
      inputPhone: 'Please enter your phone number',
      email: 'Email',
      inputEmail: 'Please enter your email',
      company: 'Company',
      inputCompany: 'Please enter your company name',
      position: 'Position',
      inputPosition: 'Please enter your position',
      from: 'about us',
      inputFrom: 'Please enter how you heard about us',
      ConfirmClause: 'Agreed to the HongLvYuan Privacy Policy.',
      submit: 'Submit',
      privacyPolicy: {
        title: 'Trial Account Privacy Policy',
        intro: 'Welcome to our trial service! This privacy policy aims to explain how we collect, use, store, and protect your personal information when you apply for and use a trial account. Please read this privacy policy carefully to understand how we handle your personal information. If you have any questions or suggestions, please feel free to contact us.',
        
        section1: '1. Information Collection',
        registrationInfo: 'Registration Information: When you apply for a trial account, we collect key registration details, including:',
        item1: '1. Name: To identify your identity and facilitate communication.',
        item2: '2. Phone Number: Used for identity verification, receiving verification codes, or emergency contact.',
        item3: '3. Email: Used for sending trial account-related information. Please ensure the email is accurate and can receive messages.',
        item4: '4. Company Name: Helps establish your usage scenario.',
        item5: '5. Position (Optional): To provide services more suited to your work needs.',
        
        section2: '2. Information Storage & Security',
        storageLocation: '(1) Storage Location: We store your personal information within the People’s Republic of China.',
        securityMeasures: '(2) Security Measures: We adopt various technical and management measures to protect your personal information, such as data encryption, access control, and security detection.',
        
        section3: '3. User Rights',
        accessRight: '1. Access Right: You can access your personal information at any time.',
        correctionRight: '2. Correction Right: If your information is incorrect, you can request corrections.',
        deletionRight: '3. Deletion Right: You have the right to request the deletion of your personal information, except where legally required to retain it.',
        consentWithdrawal: '4. Withdrawal of Consent: You can withdraw authorization for personal information usage at any time.',
        accountDeletion: '5. Account Deletion: You can request to delete your website account. Once deleted, it cannot be recovered.',
        
        section4: '4. Changes to the Terms',
        changesInfo: 'We may update this privacy policy based on legal updates, business development, or other needs. We will notify you of changes through announcements or emails.',
        
        section5: '5. Contact Us',
        contactInfo: 'If you have any questions about the privacy policy, you can contact us:',
        email: '📧 Email: info@hongly-sh.com',
        address: '📍 J, Building 1, No. 2222 Huancheng Road, Jiading District, Shanghai',
        phone: '📞 Customer Service: 15800921098',
        haveRead: 'I have read'
      },
    },
    shopping: {
      title: 'Shopping Cart',
    },
    callMeBottom: {
      item1: 'product',
      item1_1: 'product carbon',
      item1_2: 'organization carbon',
      item1_3: 'CBAM',
      item2: 'Contact Us',
      item2_1: 'shanghai',
      item2_2: 'Phone: 021-3143 6179',
      item2_3: 'Email: info@hongly-sh.com',
      item2_4: 'Address: J, Building 1, No. 2222 Huancheng Road, Jiading District, Shanghai',
      item3: 'tianjin',
      item3_1: 'No. 14 Guiyuan Road, Xiqing District, Tianjin City',
      item4: 'Follow Us',
      item5: 'Website'
    }
  },
  zh: {
    welcome: "欢迎",
    hello: "你好，世界！",
    logout: "退出登录",
    nav: {
      aboutus: "关于我们",
      aboutusInfo: "关于我们",
      newsCenter: "资讯中心",
      joinus: "加入我们",
      consultnow: "立即咨询",
      ecoVadis: "EcoVadis评估",
      puroEarth: "Puro.earth评估",
      SBTi: "SBTi科学碳目标申报",
      // carbonDisclosure: "碳环境数据披露",
      // lifecycleAssessment: "生命周期评估",
      cdpDep: "CDP环境信息披露",
      epdDep: "EPD环境产品声明申报",
      supplyChain: "供应链碳管理",
      apiIntegration: "API集成系统",
      aiRedC: "AI RedC知识库",
      lca: "LCA全生命周期评估",
      ccer: "CCER核证",
      // carbonPrediction: "碳排放预警",
      pas: "PAS2060产品碳中和审核",
      redcPlus: {
        title: "RedC+",
        try: "试用RedC2.0 >",
        login: "登录RedC >",
        loginMobile: "登录RedC",
        whatIs: {
          title: "什么是RedC+",
          description1: "RedC+是碳信基石在RedC碳管理软件的基础上增加了咨询核查的企业管理流程。过去，咨询公司凭借在碳排放核算与减排策略方面的专业能力，曾短暂占据市场制高点。然而，随着大模型和生成式人工智能（AIGC）的迅猛发展，整个行业正经历前所未有的变革。如今，数据处理速度飞跃、成本大幅下降以及智能化水平全面提升，这些技术进步正悄然重构产业生态。RedC+助力咨询服务业突破转型瓶颈，实现业务升级。",
          description2: "随着全球对气候变化问题的日益关注，碳排放管理已成为各国政府和企业的重要议题。碳核查作为确保碳排放数据准确性和透明度的重要手段，其工作流程和方法的规范性显得尤为重要。"
        },
        workflow: {
          title: "盘查核查工作流程",
          items: [
            "产业链数据中心",
            "产业链监测",
            "产业评价",
            "产业地图",
            "智能招商系统及服务"
          ],
          description: "碳核查是指对企业、组织或个人的碳排放情况进行检测、测量和评估的过程。其目的在于确保相关实体遵守国家和地方的碳排放标准和法规，推动其实现低碳发展。通过核查，可以全面了解碳排放的实际情况，为制定有效的减排策略提供科学依据，同时也有助于提高碳排放数据的准确性和透明度，促进政府、企业和公众对减排行动的监督与参与。碳核查工作对于推动低碳经济发展、促进企业减排行动具有重要意义。通过核查，可以全面了解企业的碳排放情况，为制定有效的减排策略提供科学依据。然而，碳核查工作也面临着诸多挑战。例如，不同行业和企业的碳排放情况存在差异，需要制定针对性的核查方法和标准；核查数据信息量巨大，数据采集困难，核查人员的专业水平和经验参差不齐等。因此，需要不断加强碳核查工作的规范化、标准化和信息化建设，提高核查工作的效率和质量。Red+系统帮助核查认证公司解决了这些问题和困难。"
        },
        roadmap: {
          title: "转型路线图和项目目标",
          items: [
            "产业链数据中心",
            "产业链监测",
            "产业评价",
            "产业地图",
            "智能招商系统及服务"
          ]
        },
        verificationSteps: {
          title: "碳核查的主要步骤",
          preparation: {
            title: "前期准备阶段",
            items: [
              "签订核查协议，明确核查范围、应用标准和方法、核查流程、预计完成时间、双方责任和义务、保密条款等内容",
              "组建核查团队，由具备相关专业知识和技能的核查员组成，确保核查工作的专业性和准确性，并制定详细的核查计划"
            ]
          },
          documentReview: {
            title: "文件评审阶段",
            items: [
              "对核查对象提交的温室气体排放报告及相关支持性材料进行评审。评审内容包括排放设施清单、排放源清单、活动数据和排放因子的相关信息等"
            ]
          },
          onSiteVerification: {
            title: "现场核查阶段",
            items: [
              "制定现场核查计划：核查团队需根据文件评审结果，制定详细的现场核查计划，明确核查目的、范围、方法和时间安排等",
              "实施现场核查：核查团队需深入核查对象的现场，通过实地考察、数据采集和问题发现等方式，对碳排放情况进行全面评估"
            ]
          },
          reportPreparation: {
            title: "报告编制与评审阶段",
            items: [
              "编制核查报告：核查团队需根据现场核查的结果，编制详细的核查报告。报告内容包括核查目的、范围、方法、结果、结论和建议等。核查报告的撰写需遵循相关的碳核查指南和准则，确保报告的准确性和可比性",
              "内部技术评审：核查报告经过核查机构内部的技术评审，确保报告内容完整、数据准确、方法科学"
            ]
          },
          resultNotification: {
            title: "结果告知与记录保存阶段",
            items: [
              "告知核查结果",
              "记录保存：核查机构将以安全和保密的方式保管核查过程中的全部书面和电子文件，包括核查协议、沟通记录、证明文件、核查报告等"
            ]
          }
        }
      },
      ssccp: "可持续供应链云",
      toolCloud: "工具云",
      aboutUsHLY: "关于我们",
      aiKnowledge: "AI知识库",
      news: "资讯中心",
      readMore: "阅读全文",
      pricing: "报价",
      startTrial: "立即咨询",
      shopping: '购物车',
      onlineTraining: "培训",
      ociit: "组织碳盘查类培训",
      pcft: "产品碳足迹类培训",
      ESGmtapt: "ESG管理理论与实践培训",
      eat: "能源审计培训",
      emsiat: "环境管理体系内审员培训",
      iatfems: "能源管理体系内审员培训",
      ISCC: "ISCC体系内审员培训",
      ecovadisTraining: "Ecovadis申报培训",
      cbamTraining: "CBAM申报培训",
      euBatteryTraining: "欧盟电池法案培训",
      ctc: "定制化培训训练营"
    },
    auth: {
      login: "登录",
      register: "立即注册",
      useDemo: "立即体验",
    },
    home: {
      title: "可持续供应链云平台",
      description: "我们是一家致力于为企业打造绿色、可持续供应链的战略管理服务机构。我们在节能、低碳、环保、ESG、数字化转型等领域拥有丰富的实战经验，并拥有多名资深的行业技术专家为项目落地保驾护航。",
      privacyNote: "我们的愿景是为我们的用户提供专业、高效的一站式解决方案，并与其携手共进，迈向可持续发展的新纪元。",
      trialCBAM: "申请免费体验CBAM",
      trialName: "姓名",
      trialName2: "请输入姓名",
      trialPhone: "手机号",
      trialPhone2: "请输入手机号",
      trialEmail: "邮箱",
      trialEmail2: "请输入邮箱",
      trialUse: "免费体验",
      startTrial: "开始免费试用",
      featuredApps: "精选应用",
      apps: {
        redc: {
          title: "RedC2.0",
          description: "新版组织碳/产品碳足迹"
        },
        cbam: {
          title: "CBAM",
          description: "碳税宝"
        },
        goldTrade: {
          title: "国际绿色贸易服务平台",
          description: "国际绿色贸易服务平台"
        },
        greenEnergy: {
          title: "电子纸联盟服务平台",
          description: "电子纸联盟服务平台"
        },
        industryChain: {
          title: "产业链服务平台",
          description: "产业链服务平台"
        },
        viewAll: "浏览所有产品"
      },
      contact: {
        wechat: "微信咨询",
        phone: "电话联系",
        demo: "预约演示"
      }
    },
    redc: {
      title: "一体化套件",
      subtitle: "RedC - 碳管理应用系统",
      description: "RedC (Risk Evaluation Dimension Carbon)从设计，实施，运营到维护的全生命周期，帮助咨询服务业优化咨询服务过程，帮助企业客户优化碳管理流程，提高效率，降低成本并确保合规。",
      tryFree: "免费试用 >",
      toolDescription: "简单，易用，高效",
      techTitle: "RedC2.0"
    },
    todo: {
      title: "我们的服务",
      description: "数智赋能、高效协同，碳信基石提供多样的产品服务",
      learnMore: "了解详情 >>",
      services: {
        SustainableSupplyChainCloud: {
          title: "低碳类",
          desc: "",
          items: ["ISO14064碳核算", "ISO14067碳足迹", "ISO14068碳中和", "LCA生命周期评价", "ISCC PLUS/EU","ETANS碳管理体系", "CBAM欧盟碳关税"]
        },
        toolCloud: {
          title: "能源类",
          desc: "",
          items: ["ISO50001能源体系", "能源审计/诊断", "专项能效测试", "电/水/热平衡测试", "节能补贴申报", "节能评估服务"]
        },
        OrganizeCarbonInventoryInspectionTraining: {
          title: "绿建类",
          desc: "",
          items: ["EPD环境产品声明", "ISO14046水足迹", "LEED绿色建筑", "WELL健康建筑", "中国绿建"]
        },
        ProductCarbonFootprintTraining: {
          title: "合规生产类",
          desc: "",
          items: ["ISO14001环境体系","治理架构设计与优化", "绿色工厂", "零碳工厂", "绿色供应链"]
        },
        ESGManagementTheoryandPracticeTraining: {
          title: "追溯管理类",
          desc: "",
          items: ["供应链EHS审核", "FSC森林认证", "EUDR欧盟零毁林", "GRS全球回收标准", "废弃物零填埋体系", "欧盟电池法案辅导", "ISO20400可持续采购"]
        },
        EnergyAuditTraining: {
          title: "社会责任类",
          desc: "",
          items: ["ESG报告编制", "ESG现状评估分析", "CDP环境信息披露", "EcoVadis评分提升", "员工满意度调查", "SA8000社会责任", "HIGG/SEDEX填报辅导"]
        },
        EnvironmentalManagementSystemInternalAuditorTraining: {
          title: '健康和安全类',
          desc: "",
          items: ["ISO45001", "电气安全评估", "消防安全评估", "建筑施工安全辅导", "HS法律法规清单", "HS合规评价"]
        },
        InternalAuditorTrainingForEnergyManagementSystem: {
          title: "合规风险类",
          desc: "",
          items: ["ISO27001信息安全", "ISO22301业务连续性", "ISO37301合规管理体系", "ISO31000风险管理"]
        },
        ISCCsystemInternalAuditorTraining: {
          title: "能力建设类",
          desc: "",
          items: ["欧盟电池法规", "CBAM欧盟碳关税", "双碳法规政策解读", "节能评估师", "定制化培训训练营"]
        },
        // EcovadisDeclarationTraining: {
        //   title: "Ecovadis申报培训",
        //   desc: ""
        // },
        // CBAMapplicationTraining: {
        //   title: "CBAM申报培训",
        //   desc: ""
        // },
        // EUBatteryActTraining: {
        //   title: "欧盟电池法案培训",
        //   desc: ""
        // },
        // CustomizedTrainingCamp: {
        //   title: "定制化培训训练营",
        //   desc: ""
        // },
        more: {
          title: "更多。。",
          desc: "敬请期待。。"
        }
      },
    },
    company: {
      quote: "RedC 的碳操作系统凭借其专业的服务、灵活的架构、支持体系以及安全保障，简化复杂的碳处理流程和程序，并与客户建立稳固的合作关系。",
      quote_2: "携手迈向净零排放之路",
      coreTech: {
        title: "核心技术",
        description: "碳信的核心技术包括碳核算，模型搭建，碳减排分析，过程优化，供应链管理和实时操作支持等。碳信软件的解决方案可广泛应用于各个行业和领域。"
      },
      enterprise: {
        title: "中大型企业解决方案",
        description: "碳信不断提升产品的智能化水平和客户服务质量，帮助客户实现高效，可靠的应用系统；提高数据的安全性，合规性，可追溯性。"
      },
      customers: {
        title: "合作客户"
      },
      learnMore: "了解更多"
    },
    core: {
      title1: "用科技推动环保与绿色转型，",
      title2: "让生活更加美好!",
      tryFree: "免费试用 >"
    },
    privacy: {
      title: "隐私安全为先",
      description: "我们将每一位用户的隐私安全放在首位，我们不会在任何时间以任何方式占有或出售您的数据，也绝不会在我们的产品里售卖广告。",
      learnMore: "了解详情 >"
    },
    values: {
      title: "我们的核心价值观和原则",
      commitment: {
        title: "创新",
        desc: "我们热情地追求新技术、新能力和新方法，致力于环境保护。"
      },
      development: {
        title: "合作",
        desc: "我们与个人、团体或组织密切合作，以实现我们的共同目标。我们强烈支持合作伙伴和合作伙伴。"
      },
      customer: {
        title: "客户至上",
        desc: "我们积极听取客户的意见，深入了解客户的需求，并提供独特的解决方案，确保碳中和和可持续发展。"
      }
    },
    productionBrain: {
      title: "产品碳",
      whatIs: "什么是产品碳足迹",
      description: "产品碳足迹，全称为产品碳足迹(Product Carbon Footprint), 是指产品在其整个生命周期内所释放的温室气体总量，通常以二氧化碳当量(CO2e)为单位进行衡量。",
      explanation: "通常以其内涵和外延两个维度进行深入解释：",
      connotation: {
        title: "内涵",
        lifecycle: {
          title: "生命周期视角",
          desc: "产品碳的计算涵盖了产品从'摇篮到坟墓'的全部阶段，包括原材料的获取和加工、产品的生产制造、产品的运输与分销、产品的使用以及产品废弃后的处理或回收。"
        },
        emissions: {
          title: "温室气体排放总和",
          desc: "在产品的各个生命周期阶段，会因各种活动和过程产生多种温室气体，如二氧化碳（CO₂）、甲烷（CH₄）、氧化亚氮（N₂O）等。产品碳将这些不同种类的温室气体按照其全球变暖潜能值（GWP）换算成二氧化碳当量，然后进行累加，以此来全面衡量产品对气候变化的潜在影响。"
        }
      },
      extension: {
        title: "外延",
        quantitative: {
          title: "量化指标",
          desc: "产品碳是一个量化的指标，它能够以具体的数值来反映产品在整个生命周期中对环境的温室气体排放贡献。这使得不同产品之间在碳排放方面具有可比性，企业可以通过比较不同产品的碳足迹，识别出高碳排放的环节和产品，从而有针对性地采取减排措施。"
        },
        environmental: {
          title: "环境影响标识",
          desc: "产品碳是产品环境影响的一个重要标识，它直观地展示了产品在气候变化方面的环境代价。在全球应对气候变化的大背景下，产品碳信息对于消费者、企业和政策制定者都具有重要意义。消费者可以根据产品碳信息做出更环保的购买决策，企业可以将其作为环境管理的重要工具，政策制定者可以据此制定相关的环境政策和法规。"
        }
      },
      flowchart: "产品碳流程图",
      database: "Ecoinvent权威因子库搜索",
      report: "产品碳足迹报告一键生成",
      allocation: "分配方式",
      procard: {
        title: "产品碳足迹基础模型以软件程序和算法的形式嵌入到系统流程中，模型将自动调用相关数据及预设的碳排放因子计算碳排放量。企业也能够在产品设计、生产、销售等各个环节实时了解产品的碳足迹情况，从而做出更有利于环境和可持续发展的决策。通过系统流程中产品碳足迹模型的持续运行和数据积累，企业可以对产品的碳排放情况进行长期监测和分析，发现潜在的减排机会，制定针对性的减排措施，实现企业的可持续发展目标。",
        features: {
          simplified: "简化",
          intelligent: "智能",
          efficient: "高效"
        }
      },
      procard3: {
        title: "系统集成了国际公认的权威生命周期数据库Ecoinvent及多源数据因子库，数据库具有强大的搜索功能和便捷的用户体验，为精确计算碳足迹，量化碳排放值奠定了夯实的基础。",
        features: {
          powerful: "强大",
          convenient: "便捷",
          accurate: "精准"
        }
      },
      organizationCarbon: {
        title: "组织碳",
        whatIs: "什么是组织碳？",
        description: "组织碳通常是指组织碳足迹(Organizational Carbon Footprint)，是对一个组织在一定时间内所有活动所产生的温室气体排放的量化评估，从其涵盖范围、计算边界方面的详细解释如下：",
        scope: {
          title: "涵盖范围:",
          items: {
            energy: {
              title: "能源相关排放",
              desc: "组织运营过程中消耗的各种能源所产生的碳排放是组织碳的重要组成部分。包括建筑物的电力、热力消耗，如办公室的照明、空调使用所消耗的电力，工厂生产过程中使用的煤炭、天然气等化石燃料燃烧产生的二氧化碳排放。"
            },
            transport: {
              title: "交通运输排放",
              desc: "组织员工的商务出行、货物运输等交通活动产生的排放。例如，公司员工乘坐飞机出差、公司货车运输原材料或产品等过程中，交通工具燃烧燃料所释放的温室气体。"
            },
            production: {
              title: "生产过程排放",
              desc: "对于生产型企业，生产过程中的化学反应、物料处理等环节也会产生温室气体。比如，化工企业在生产化工产品时，化学反应会直接产生二氧化碳、甲烷等温室气体；水泥生产过程中，石灰石分解等工艺也会释放大量的二氧化碳。"
            },
            waste: {
              title: "废弃物处理排放",
              desc: "组织产生的废弃物在处理过程中也可能产生温室气体。如垃圾填埋场中有机物分解会产生甲烷，垃圾焚烧会产生二氧化碳等。"
            }
          }
        },
        boundary: {
          title: "计算边界:",
          items: {
            direct: {
              title: "直接排放",
              desc: "是指组织拥有或控制的排放源所产生的排放，如组织自有车辆的尾气排放、工厂自有锅炉燃烧燃料产生的排放。"
            },
            indirect: {
              title: "能源间接排放",
              desc: "主要来自组织所消耗的外购电力、热力等能源在生产过程中产生的排放。虽然这些排放不是组织直接产生，但与组织的能源使用密切相关。"
            },
            other: {
              title: "其他间接排放",
              desc: "包括组织上下游供应链中与组织活动相关的排放，如原材料采购、产品销售和使用阶段等产生的排放。比如，一家服装企业，其采购的棉花在种植过程中使用化肥产生的温室气体排放，以及消费者购买服装后在使用过程中洗涤、烘干等产生的排放，都属于该组织的其他间接排放。"
            }
          }
        },
        flowchart: "组织碳流程图",
        database: "Ecoinvent权威因子库搜索",
        report: "组织碳报告一键生成",
        allocation: "分配方式",
        procard: {
          title: "组织碳系统以可视化工具流程清晰展示组织内部涉及碳排放相关活动、流程以及数据流向的全貌，呈现从初始数据收集，到碳排放计算、分析，再到策略制定，帮助组织各层级人员理解组织碳管理的运作逻辑，为有效管理碳排放和企业战略决策提供指引。对于集团公司或企业下属多家工厂或公司，系统通过集成化架构，将分散在不同地区的企业集团公司按照统一的标准、规范和流程，确定核算边界，完成数据采集、核算方法、计算碳排放等，编制碳排放报告，确保报告内容的真实性、准确性和完整性。同时，可委托具有资质的第三方认证机构对碳排放报告进行核查认证，出具核查报告，赋能企业提高碳信息的可靠性和可追溯性。",
          features: {
            simplified: "简化",
            intelligent: "智能",
            efficient: "高效"
          }
        },
        procard3: {
          title: "系统集成了国际公认的权威生命周期数据库Ecoinvent及多源数据因子库，数据库具有强大的搜索功能和便捷的用户体验，为精确计算碳足迹，量化碳排放值奠定了夯实的基础。",
          features: {
            powerful: "强大",
            convenient: "便捷",
            accurate: "精准"
          }
        }
      }
    },
    carbonTreasure: {
      title: "加入我们",
      mobileTitle: "加入我们",
      whatIs: {
        carbonTechDirector: {
          title: "碳技术总监",
          coreObjectives: {
            title: "【工作内容】",
            items: [
              "负责各类政策的研判和解读，行业同类项目和创新项目的资料收集、数据分析，并定期形成分析报告。",
              "协助市场部访谈客户，给市场部服务提案给与必要的技术支持。",
              "负责项目（碳盘查、产品生命周期评价、工程项目碳排放评价、碳管理培训、ESG支撑等）的执行、相关技术成果的编制和审核。",
              "参与公司系统平台建设和管理，定期更新公司资源、梳理公司优势，提升公司竞争力。"
            ]
          },
          productScope: {
            title: "【岗位要求】",
            items: [
              "热心双碳事业，对碳资产交易、碳排放核查、碳减排管理等领域有一定了解，有碳行业工作经验者优先；有中高级工程师或其他职业资格证书者优先。",
              "本科及以上学历，熟练应用Office办公软件，对信息化、数字化产品有一定认识。",
              "专业要求：工学类、理学类（环境、能源、电力、金融管理等相关专业）。",
              "较强的逻辑思维能力、口头和文字表达能力和团队协调性，英文读写能力突出者优先。能接受出差，抗压能力强。"
            ]
          }
        },
        projectManager: {
          title: "项目经理",
          coreObjectives: {
            title: "【工作内容】",
            items: [
              "独立主持企业战略/市场营销/研发/供应链/流程/数字化/财经/人力资源/卓越运营/领导力等任一咨询模块项目工作,对项目的质量、进度、回款及客户满意度负责;",
              "带领项目团队成员完成咨询项目的实施及交付工作;",
              "负责咨询团队的建设与成员培养,营造和谐的咨询团队氛围,不断提升项目团队的专业能力;",
              "参与咨询售前沟通及项目商务,如客户深度跟进、组织开展投标、现场述标等商务活动;",
              "承担公司专业课题或者培训课程的开发、设计与实施;",
              "主持优化战略/市场营销/研发/采购供应链/流程等任一咨询模块产品、工具和方法,提高管理咨询生产技术及标准。"
            ]
          },
          productScope: {
            title: "【岗位要求】",
            items: [
              "本科及以上学历,管理学、经济学、理工科等相关专业优先,硕士优先;2、35-40岁,五官端正、形象职业;",
              "有企业战略/市场营销/研发/供应链/流程等任一业务领域中高层管理经验或咨询顾问经验;",
              "有大型企业运营与管理者经验,对企业战略、组织架构管理熟悉;",
              "有强烈的敬业精神、工作责任心,有优秀的学习能力、创新能力以及团队意识;良好的口头表达及书面表达能力,演讲演示水平高;",
              "能适应高强度工作,接受出差。"
            ]
          }
        },
        partner: {
          title: "合伙人",
          coreObjectives: {
            title: "【工作内容】",
            items: [
              "咨询项目的开发:寻找客户资源或根据公司提供的咨询项目机会点，调研与理解客户的深层需求,撰写或审查咨询项目建议书,并对方案进行讲解,完成与客户签约;",
              "维护客户关系:保持与老客户之间良好的合作关系,长期关注客户发展动态并为客户提出管理改善建议;",
              "咨询项目实施:以有效的咨询方法论与技术路线,指导咨询项目开展在项目实施过程中对项目进度、质量、回款进行有效监控:",
              "团队建设与管理:对公司和本部门团队人员开展培训培养工作。"
            ]
          },
          productScope: {
            title: "【岗位要求】",
            items: [
              "年龄35岁以上;",
              "国内外知名院校本科以上学历,硕士以上为佳;",
              "有10年以上中型以上企业中层以上管理岗位经历;",
              "有丰富的企业管理咨询经验,在战略管理/营销管理/内部运营/人力资源/流程建设等方向成功实施过多个咨询项目;",
              "精通企业管理的1~2个业务领域,了解多个领域更佳;",
              "能理解客户需求,并独立完成售前沟通、培训、项目实施、客户服务等工作;",
              "较强的语言表达能力、沟通能力、问题分析能力及演讲能力;",
              "具有独立开发新项目及拥有广泛社会关系与客户资源者优先。"
            ]
          }
        }
      },
      evolutionTitle: "CBAM演变实施过程",
      impactTitle: "CBAM 对我国出口贸易的影响",
      impacts: {
        cost: {
          title: "成本与价格方面",
          items: [
            "直接成本增加：自 2026 年起，我国出口到欧盟的钢铁、水泥、铝、化肥、电力、氢等 CBAM 覆盖行业的产品，企业需购买碳减排证书或缴纳碳税，这将增加出口成本。",
            "间接成本上升：企业为满足 CBAM 要求，需投入资金用于碳排放数据监测、收集和报告，增加数据管理成本。还可能因 CBAM 促使供应链调整，如寻找低碳供应商、优化运输路线等，带来额外的管理和运营成本。",
            "价格竞争力削弱：成本增加会使出口产品价格上升，在欧盟市场上与其他国家产品相比，价格竞争力可能降低，尤其对于价格敏感度高的产品，可能导致市场份额下降。"
          ]
        },
        industry: {
          title: "产业与供应链方面",
          items: [
            "高碳产业冲击较大：钢铁、水泥等传统高碳产业，碳排放强度相对较高，CBAM 实施后将面临较大成本压力和出口限制，可能导致出口量减少，产业发展受到一定冲击。",
            "供应链布局调整：企业可能会为降低 CBAM 影响，重新评估和调整供应链战略，倾向于选择低碳排放的原材料供应商和生产环节，推动供应链向绿色低碳方向转型。部分企业可能将生产环节转移到碳成本较低的地区，以减少碳税支出。",
            "产业升级压力增大：企业为符合 CBAM 标准，需加大技术创新投入，改进生产工艺，提高能源利用效率，加速向低碳、零碳生产方式转变，推动产业整体升级。"
          ]
        },
        market: {
          title: "市场与贸易格局方面",
          items: [
            "欧盟市场受限：若 CBAM 覆盖范围扩大、标准提高，我国更多出口产品将受影响，进入欧盟市场难度增加，对欧出口规模可能受到限制。",
            "贸易转移效应：受 CBAM 影响，我国对欧盟出口受限的产品可能会转向其他国际市场，促使我国与其他国家和地区的贸易往来增加，推动全球贸易格局发生一定变化。",
            "绿色贸易壁垒加剧：CBAM 可能引发其他国家和地区效仿，出台类似碳边境调节措施，形成全球性的绿色贸易壁垒，使我国出口贸易面临更严峻的国际环境。"
          ]
        },
        data: {
          title: "数据与认证方面",
          items: [
            "数据统计负担加重：企业需要准确收集、整理和报告产品生产过程中的碳排放数据，这对于数据管理能力薄弱的企业是一项挑战，可能需要投入更多人力、物力和时间来建立和完善数据统计体系。",
            "认证要求提高：随着 CBAM 实施，对产品的碳足迹认证等相关要求可能更加严格，我国企业需获得相关认证才能顺利进入欧盟市场，增加了企业的认证成本和时间成本。"
          ]
        }
      },
      serviceTitle: "碳信基石一站式CBAM全流程服务",
      reportTitle: "CBAM使用及一键生成报告"
    },
    contactUs: {
      title: '联系我们',
      desc: '若您对上述低碳类服务感兴趣或有相关业务需求，欢迎通过以下方式与我们取得联系：',
      phone: '电话：021-3143 0179',
      phone2: '手机：158 0092 1098',
      email: '邮箱：info@hongly-sh.com',
      address: '地址：上海市普陀区曹杨路1518号高尚领域T3 2020A',
      title2: '关注我们',
      desc2: '扫描下方二维码，关注我们的官方账号，获取更多低碳领域的前沿资讯、行业动态及专业解读。'
    },
    dtl: {
      title: '低碳类业务',
      items: [
        '在当下全球聚焦低碳发展的大背景下，我们提供一系列专业的低碳类服务，助力企业在绿色转型道路上稳步前行：',
        '1. ISO14064碳核算：遵循ISO14064标准，精准量化企业温室气体排放，为企业碳管理提供数据支撑。',
        '2. ISO14067碳足迹：依据ISO14067标准，全面评估产品从原材料获取到生产、运输、使用及废弃处理全生命周期的碳排放，助力企业优化产品碳表现。',
        '3. ISO14068碳中和：以ISO14068标准为指引，帮助企业科学制定并实施碳中和策略，抵消自身产生的温室气体排放，迈向碳中和目标。',
        '4. LCA生命周期评价：运用生命周期评价方法，对产品或服务在整个生命周期内的环境影响进行全面分析，识别环境改善的关键环节。',
        '5. ISCC PLUS/EU：符合ISCC PLUS/EU认证要求，确保生物质原料及相关产品的可持续性，涉及环境、社会和经济等多方面的可持续发展标准。',
        '6. CBAM欧盟碳关税：针对欧盟碳边境调节机制（CBAM），为企业提供应对策略，帮助企业适应欧盟碳关税政策，降低贸易风险。'
      ]
    },
    nyl: {
      title: '能源类业务',
      items: [
        '在能源转型与“双碳”目标推进的关键时期，高效管理与合理利用能源成为企业可持续发展的重要课题。我们提供专业的能源类服务，助力企业提升能源效率，降低能源成本，实现绿色低碳发展：',
        '1. ISO50001能源体系：依据ISO50001能源管理体系标准，协助企业建立完善的能源管理架构，规范能源管理流程，持续改进能源绩效。',
        '2. 能源审计/诊断：通过专业的能源审计与诊断方法，全面评估企业能源利用状况，识别能源浪费环节和节能潜力，为企业制定针对性的节能方案提供依据。',
        '3. 专项能效测试：针对特定设备、工艺或系统进行能效测试，精准测量其能源消耗水平和能效指标，为企业优化能源利用、提升能效提供数据支持。',
        '4. 电/水/热平衡测试：对企业的电、水、热等能源介质进行平衡测试，分析能源输入、输出及损耗情况，帮助企业实现能源的合理分配和高效利用。',
        '5. 节能评估服务：在项目前期对其能源利用合理性、节能措施可行性等进行全面评估，为项目决策提供科学依据，助力企业在项目规划阶段就融入节能理念。'
      ]
    },
    ljl: {
      title: '绿建类业务',
      items: [
        '在全球绿色发展浪潮下，绿色建筑已成为建筑行业转型的关键方向。我们提供专业的绿建类服务，助力建筑项目实现环境友好、资源节约与健康舒适的目标：',
        '1. EPD环境产品声明：通过量化评估建筑产品全生命周期的环境影响，为绿色建筑选材提供科学依据，促进可持续建筑材料的应用。',
        '2. ISO14046水足迹：依据国际标准，全面评估建筑项目水资源利用情况，识别节水潜力，助力企业制定节水策略，提升水资源利用效率。',
        '3. LEED绿色建筑：遵循全球认可的LEED认证体系，从可持续场地、水资源利用、能源与大气、材料与资源、室内环境质量等多维度对建筑进行评估与认证，打造高品质绿色建筑。',
        '4. WELL健康建筑：关注建筑对人体健康与福祉的影响，通过优化空气、水、营养、光、运动、热舒适、声环境、材料、精神和社区等要素，营造健康舒适的建筑环境。',
        '5.中国绿建：依据中国绿色建筑评价标准，从节地与室外环境、节能与能源利用、节水与水资源利用、节材与材料资源利用、室内环境质量、运营管理等方面对建筑进行综合评价与认证，推动国内绿色建筑发展。'
      ]
    },
    hgscl: {
      title: '合规生产类业务',
      items: [
        '在环保要求日益严格的当下，合规生产成为企业可持续发展的基石。我们提供全面的合规生产类服务，助力企业实现生产过程的绿色化、规范化：',
        '1. ISO14001环境体系：依据ISO14001环境管理体系标准，协助企业建立完善的环境管理架 构，规范环境管理流程，持续改进环境绩效，确保企业生产经营活动符合环保法规要求。',
        '2. 绿色工厂：按照绿色工厂评价标准，从基础设施、管理体系、能源与资源投入、产品、环境排放等方面对企业工厂进行评估与打造，助力企业工厂实现绿色化生产，降低环境影响。',
        '3. 零碳工厂：聚焦工厂碳排放管理，通过能源结构优化、生产工艺改进、能效提升等措施，帮助企业工厂逐步减少碳排放，最终实现零碳生产目标，引领行业绿色低碳发展。',
        '4.绿色供应链：从供应链的源头把控，对供应商进行绿色评估与管理，推动供应链上下游企业共同实施绿色采购、绿色生产、绿色物流等措施，打造绿色、可持续的供应链体系。'
      ]
    },
    zsgll: {
      title: '追溯管理类业务',
      items: [
        '在全球化供应链日益复杂的背景下，产品追溯管理成为企业确保合规性、提升透明度和可持续性的关键环节。我们提供专业的追溯管理类服务，助力企业实现全链条的可追溯性和可持续发展：',
        '1. 供应链EHS审核：对供应链中的环境（Environmental）、健康（Health）和安全（Safety）进行全面审核，确保供应商符合相关法规和标准，降低供应链风险，提升企业的社会责任形象。',
        '2. FSC森林认证：协助企业获得森林管理委员会（FSC）认证，确保其木材和林产品来自可持续管理的森林，促进森林资源的保护和可持续利用。',
        '3. EUDR欧盟零毁林：遵循欧盟《企业可持续发展尽职调查条例》（EUDR），帮助企业确保其供应链不涉及毁林行为，满足欧盟市场对零毁林产品的要求。',
        '4. GRS全球回收标准：为企业提供全球回收标准（GRS）认证服务，确保其产品中使用的回收材料符合相关要求，提升产品的环保属性和市场竞争力。',
        '5. 废弃物零填埋体系：协助企业建立废弃物零填埋管理体系，通过优化废弃物处理流程、提高资源回收利用率，实现废弃物的最小化和无害化处理。',
        '6. 欧盟电池法案辅导：针对欧盟新出台的电池法案，为企业提供专业的合规辅导，确保其电池产品符合法规要求，顺利进入欧盟市场。',
        '7.ISO20400可持续采购：依据ISO20400可持续采购标准，帮助企业建立可持续采购管理体系，优化采购流程，选择环保、社会责任表现良好的供应商，推动供应链的可持续发展。'
      ]
    },
    shzrl: {
      title: '社会责任类业务',
      items: [
        '在企业追求经济发展的同时，履行社会责任已成为提升企业形象、增强竞争力的重要途径。我们提供专业的社会责任类服务，助力企业全面提升社会责任管理水平：',
        '1. ESG报告编制：依据国际通用的ESG（环境、社会、治理）标准，为企业量身定制ESG报告，全面展示企业在环境、社会和治理方面的绩效与成果，提升企业透明度和公信力。',
        '2. ESG现状评估分析：对企业当前的ESG管理现状进行全面评估与分析，识别存在的问题与不足，为企业制定针对性的改进策略提供依据，助力企业提升ESG管理水平。',
        '3. CDP环境信息披露：协助企业参与CDP（全球环境信息研究中心）环境信息披露，按照CDP的要求整理和提交环境相关数据与信息，提升企业在环境方面的透明度和表现，增强投资者信心。',
        '4. EcoVadis评分提升：针对EcoVadis（全球领先的企业社会责任评估机构）评估体系，为企业提供专业的辅导与建议，帮助企业优化社会责任管理实践，提升EcoVadis评分，增强企业在供应链中的竞争力。',
        '5. 员工满意度调查：通过科学的调查方法，全面了解企业员工的满意度状况，分析影响员工满意度的因素，为企业制定员工关怀与激励政策提供依据，提升员工归属感和企业凝聚力。',
        '6. SA8000社会责任：依据SA8000社会责任标准，协助企业建立完善的社会责任管理体系，确保企业在劳工权益、健康安全、道德规范等方面符合国际标准，提升企业社会责任形象。'
      ]
    },
    jkhaql: {
      title: '健康和安全类业务',
      items: [
        '保障员工健康与安全是企业可持续发展的重要基础。我们提供专业的健康和安全类服务，助力企业提升安全管理水平，营造安全健康的工作环境：',
        '1. ISO45001：依据ISO45001职业健康安全管理体系标准，协助企业建立完善的职业健康安全管理架构，规范职业健康安全管理流程，持续改进职业健康安全绩效，降低企业安全风险。',
        '2. 电气安全评估：对企业电气设备、电气系统进行全面安全评估，识别潜在的电气安全隐患，提出针对性的整改建议，确保企业电气系统安全稳定运行，保障员工生命财产安全。',
        '3. 消防安全评估：从火灾风险识别、消防设施配备、应急预案制定等方面对企业进行消防安全评估，为企业制定科学合理的消防安全策略提供依据，提升企业火灾防控能力。',
        '4. 建筑施工安全辅导：针对建筑施工企业，提供专业的施工安全辅导服务，包括施工安全规范培训、施工现场安全管理指导、施工安全隐患排查等，助力建筑施工企业提升施工安全管理水平，预防施工安全事故。',
        '5. HS法律法规清单：为企业梳理和提供全面的健康安全（HS）相关法律法规清单，帮助企业及时了解和掌握最新的健康安全法规要求，确保企业经营活动符合法规规定。',
        '6.HS合规评价：对企业健康安全管理体系的合规性进行全面评价，识别企业在健康安全管理方面存在的合规风险，提出整改建议，助力企业提升健康安全合规管理水平。'
      ]
    },
    hgfxl: {
      title: '合规风险类业务',
      items: [
        '在复杂多变的商业环境中，合规经营与风险管控是企业稳健发展的重要保障。我们提供专业的合规风险类服务，助力企业有效应对各类合规与风险挑战：',
        '1. ISO27001信息安全：依据ISO27001信息安全管理体系标准，协助企业建立完善的信息安全管理架构，规范信息安全管理流程，保护企业信息资产安全，降低信息安全风险。',
        '2. ISO22301业务连续性：遵循ISO22301业务连续性管理体系标准，帮助企业制定业务连续性计划，提升企业应对突发事件的能力，确保企业在面临危机时能够持续运营，减少业务中断带来的损失。',
        '3. ISO37301合规管理体系：依据ISO37301合规管理体系标准，为企业搭建合规管理体系框架，明确合规管理职责与流程，提升企业合规管理水平，降低合规风险。',
        '4.ISO31000风险管理：运用ISO31000风险管理标准，协助企业建立全面的风险管理体系，识别、评估和应对各类风险，提高企业风险管控能力，保障企业可持续发展。'
      ]
    },
    nljsl: {
      title: '能力建设类业务',
      items: [
        '在绿色低碳发展的大趋势下，提升企业相关专业能力是把握发展机遇的关键。我们提供专业的能力建设类服务，助力企业培养专业人才，提升应对绿色发展挑战的能力：',
        '1. 欧盟电池法规：深入解读欧盟电池法规的具体要求和实施细则，帮助企业了解欧盟市场对电池产品的环保、安全等方面的规定，为企业产品进入欧盟市场提供合规指导。',
        '2. CBAM欧盟碳关税：详细讲解欧盟碳边境调节机制（CBAM）的政策背景、实施方式和影响，协助企业评估自身产品面临的碳关税成本，制定应对策略，降低贸易风险。',
        '3. 双碳法规政策解读：全面解读中国“双碳”目标相关的法规政策，包括碳达峰、碳中和的具体目标、政策措施和行业影响等，帮助企业把握政策方向，制定符合政策要求的发展战略。',
        '4. 节能评估师：提供节能评估师专业培训，培养具备节能评估专业知识和技能的人才，帮助企业开展节能评估工作，识别节能潜力，制定节能方案，提升能源利用效率。',
        '5.定制化培训训练营：根据企业的特定需求，量身定制培训课程和训练营，涵盖绿色发展、低碳技术、合规管理等多个领域，为企业提供个性化的能力提升解决方案。'
      ]
    },
    carbonTreasure2: {
      title: "CBAM欧盟碳边境调节机制",
      mobileTitle: "CBAM欧盟碳边境调节机制",
      whatIs: {
        title: "什么是CBAM",
        description: "CBAM 即碳边境调节机制（Carbon Border Adjustment Mechanism），是欧盟为应对气候变化、防止碳泄漏而推出的一项政策工具。",
        coreObjectives: {
          title: "核心目标",
          items: [
            "应对气候变化挑战，推动全球减排行动。通过对进口产品的碳排放进行调节，促使全球范围内的企业减少温室气体排放，以实现《巴黎协定》中设定的全球气候目标。",
            "防止碳泄漏，保护欧盟内部产业竞争力。避免因欧盟内部严格的碳排放政策导致高耗能、高排放产业转移至碳排放监管宽松的国家和地区，从而确保欧盟的产业在全球市场中不会因减排政策而处于劣势。"
          ]
        },
        productScope: {
          title: "产品范围",
          items: [
            "目前主要涵盖钢铁、水泥、铝、化肥、电力、氢等多个高碳排放行业的产品。未来可能会根据政策调整和实际情况进一步扩大覆盖范围。"
          ]
        },
        geographicScope: {
          title: "地理范围",
          items: [
            "主要针对进口至欧盟关境的产品。只要是从欧盟以外的国家和地区进口到欧盟的相关产品，都可能受到 CBAM 的影响。"
          ]
        },
        dataCollection: {
          title: "碳排放数据收集与报告",
          items: [
            "要求进口商向欧盟相关当局报告进口产品生产过程中的碳排放数据，包括原材料采购、生产加工、运输等各个环节的碳排放情况。"
          ]
        },
        carbonPrice: {
          title: "碳价计算与调整",
          items: [
            "根据欧盟碳排放交易体系（EU ETS）的碳价以及进口产品的碳排放量，计算出需要调整的碳费用。如果进口产品在生产过程中的碳排放水平高于欧盟同类产品的平均碳排放水平，进口商就需要缴纳相应的碳税或购买碳减排证书，以弥补碳排放差异。"
          ]
        },
        policyNature: {
          title: "政策性质",
          items: [
            "是一种基于碳定价的贸易措施，将环境政策与贸易政策相结合。通过在边境对进口产品的碳排放进行调节，将碳排放成本纳入产品价格，从而影响贸易流动和企业的生产决策。"
          ]
        }
      },
      evolutionTitle: "CBAM演变实施过程",
      impactTitle: "CBAM 对我国出口贸易的影响",
      impacts: {
        cost: {
          title: "成本与价格方面",
          items: [
            "直接成本增加：自 2026 年起，我国出口到欧盟的钢铁、水泥、铝、化肥、电力、氢等 CBAM 覆盖行业的产品，企业需购买碳减排证书或缴纳碳税，这将增加出口成本。",
            "间接成本上升：企业为满足 CBAM 要求，需投入资金用于碳排放数据监测、收集和报告，增加数据管理成本。还可能因 CBAM 促使供应链调整，如寻找低碳供应商、优化运输路线等，带来额外的管理和运营成本。",
            "价格竞争力削弱：成本增加会使出口产品价格上升，在欧盟市场上与其他国家产品相比，价格竞争力可能降低，尤其对于价格敏感度高的产品，可能导致市场份额下降。"
          ]
        },
        industry: {
          title: "产业与供应链方面",
          items: [
            "高碳产业冲击较大：钢铁、水泥等传统高碳产业，碳排放强度相对较高，CBAM 实施后将面临较大成本压力和出口限制，可能导致出口量减少，产业发展受到一定冲击。",
            "供应链布局调整：企业可能会为降低 CBAM 影响，重新评估和调整供应链战略，倾向于选择低碳排放的原材料供应商和生产环节，推动供应链向绿色低碳方向转型。部分企业可能将生产环节转移到碳成本较低的地区，以减少碳税支出。",
            "产业升级压力增大：企业为符合 CBAM 标准，需加大技术创新投入，改进生产工艺，提高能源利用效率，加速向低碳、零碳生产方式转变，推动产业整体升级。"
          ]
        },
        market: {
          title: "市场与贸易格局方面",
          items: [
            "欧盟市场受限：若 CBAM 覆盖范围扩大、标准提高，我国更多出口产品将受影响，进入欧盟市场难度增加，对欧出口规模可能受到限制。",
            "贸易转移效应：受 CBAM 影响，我国对欧盟出口受限的产品可能会转向其他国际市场，促使我国与其他国家和地区的贸易往来增加，推动全球贸易格局发生一定变化。",
            "绿色贸易壁垒加剧：CBAM 可能引发其他国家和地区效仿，出台类似碳边境调节措施，形成全球性的绿色贸易壁垒，使我国出口贸易面临更严峻的国际环境。"
          ]
        },
        data: {
          title: "数据与认证方面",
          items: [
            "数据统计负担加重：企业需要准确收集、整理和报告产品生产过程中的碳排放数据，这对于数据管理能力薄弱的企业是一项挑战，可能需要投入更多人力、物力和时间来建立和完善数据统计体系。",
            "认证要求提高：随着 CBAM 实施，对产品的碳足迹认证等相关要求可能更加严格，我国企业需获得相关认证才能顺利进入欧盟市场，增加了企业的认证成本和时间成本。"
          ]
        }
      },
      serviceTitle: "碳信基石一站式CBAM全流程服务",
      reportTitle: "CBAM使用及一键生成报告"
    },
    SupplyChainAudit2: {
      title: '供应链风险评估工具',
      items: [
        '供应链环境合规风险审核',
        '服务特色：',
        '根据可持续供应链管理合规及持续改善的需求提供环境、温室气体、职业健康安全、社会责任等维度评估工具。',
        '搭建由PDCA逻辑构成的交互模式审核平台且采用线上快速风险评估的模式，为企业供应链筛选及管理把好“关”。'
      ]
    },
    esgEvaluation2: {
      title: 'ESG现状评估工具',
      desc: '什么是ESG?',
      desc2: 'ESG现状评估工具可以有效地衡量企业、供应链和投资者的ESG实践与绩效，并以打分形式对ESG管理现状进行评估。ESG现状评估工具结合线上+线下形式评估，获得账号的人员均可进入填报系统完成信息填报，简化沟通流程，释放人力资源，提升评估效率。'
    },
    toolCloudPage: {
      title: "工具云",
      time: "合作时间",
      viewContent: "查看内容",
      tools: {
        cbam: {
          title: "CBAM工具",
          description: "什么是CBAM？CBAM 即碳边境调节机制 (Carbon Border Adjustment Mechanism),是欧盟为应对气候变化、防止碳泄漏而推出的一项政策工具。",
        },
        carbonPlatform: {
          title: "碳计算平台",
          description: "智能碳排放管理平台,基于AI大模型,为您提供碳核算、碳减排、碳中和等一站式产品服务。让企业碳管理更加合规、透明、高效。",
        },
        supplyChainAudit: {
          title: "供应链审核",
          description: "根据可持续供应链管理合规及持续改善的需求提供环境、温室气体、职业健康安全、社会责任等维度评估工具。搭建由PDCA逻辑构成的交互模式审核平台且采用线上快速风险评估的模式，为企业供应链筛选及管理把好“关”",
        },
        esgEvaluation: {
          title: "ESG评估",
          description: "ESG现状评估工具可以有效地衡量企业、供应链和投资者的ESG实践与绩效,并以打分形式对ESG管理现状进行评估。ESG现状评估工具结合线上+线下形式评估,获得账号的人员均可进入填报系统完成信息填报,简化沟通流程，释放人力资源，提升评估效率。",
        }
      }
    },
    newsCenterInfo: {
      carbonTariff: {
        title: "一文解答：碳关税来了！企业如何应对？",
        background: {
          title: "碳关税的背景",
          content: "碳关税的背景主要源于全球应对气候变化的需要，这个概念起源于欧盟国家。随着全球气候变化问题日益严峻，各国纷纷采取措施限制温室气体排放。然而，不同国家在气候政策、能源结构和产业布局方面存在差异，导致碳排放减排进程和力度不一。因此，为了实现全球碳排放的公平减少，便有国家提倡并实行碳关税制度，以防止碳排放政策宽松的国家通过对外贸，让高排放商品和服务挤占国内绿色产业，抑制绿色环保的市场发展趋势。其中，欧盟碳边界调整机制(CBAM)是一个典型的实例。"
        },
        cbamIntro: {
          title: "CBAM基本介绍",
          whatIs: {
            title: "什么是CBAM",
            content: "CBAM是碳边境调节机制(Carbon Border Adjustment Mechanism）的简称，也被称为碳关税或碳边境调节税，是一项涉及碳密集型行业产品进口的机制，即欧盟针对部分进口商品的碳排放所征收的税费。"
          },
          industries: {
            title: "涵盖哪些行业",
            content: "目前，涵盖六大行业——水泥、铝、化肥、发电、氢气、钢铁。后续，欧盟委员会将会考虑增加其他碳密集型行业。"
          },
          reporting: {
            title: "谁负责报告",
            content: "报关人将是进口商或间接海关代表，具体取决于谁提交报关单。海关当局将通知报关人，他们有义务在过渡期间报告信息。"
          },
          exporterObligations: {
            title: "国内出口商义务",
            content: "虽然CBAM报告工作由授权申报人（通常为进口商）负责，但授权申报人为了填写CBAM报告，会要求产品供应商（即出口企业）提供相应的内含碳排放数据，所以为了顺利出口，相关出口商需做好内含碳相关数据和信息报送的准备工作，配合进口方进行填报。"
          }
        },
        implementation: {
          title: "欧盟碳关税法规（CBAM）实施时间及要点",
          content: "CBAM法规于2023年10月1日开始实施，分为过渡期和征收期：",
          periods: [
            "过渡期（2023年10月1日 ~ 2025年12月31日）：提交CBAM报告，不计算碳排放费用；",
            "征收期（2026年1月1日起）：提交CBAM申报，须计算碳排放费用。"
          ]
        },
        reportingMethod: {
          title: "CBAM信息报送途径",
          content: "出口商可以使用欧盟官方信息报送模版（CBAM Communication template for installations）完成和进口商之间的信息交流。出口商把该文件准确无误填写完成后，将整份文件或者文件中最后一个子表（Summary_Communication）提交给欧盟客户即可。"
        },
        certificates: {
          title: "关于CBAM证书",
          details: [
            "每张CBAM证书：分配一个独立的识别号；价格为每日历周EUETS配额拍卖的平均值；对应1吨二氧化碳排放；有效期2年；",
            "CBAM证书清缴：每年5月31日前，授权申报商根据上一日历年的嵌入碳排放总量清缴相应的CBAM证书数量；授权申报商应确保每季度末其账户中CBAM证书总量为该日历年开始以来所有进口商品至少80%的嵌入碳排放；",
            "CBAM证书回购：授权申报商应在清缴CBAM证书的每年6月30日前提出回购申请，欧委会代表成员国回购多余的证书；回购数量以上一日历年购买总数的三分之一为限，每张证书回购价格为购买时的原价；",
            "CBAM证书注销：欧委会应于每年7月1日注销上一日历年的前一年购买并遗留在账户中的CBAM证书，不做任何补偿；"
          ]
        },
        services: {
          title: "还在苦恼怎么才能做出合规的碳排放报告",
          subtitle: "专业的工作交给专业的我们",
          ourServices: {
            title: "我们提供的服务",
            items: [
              "为企业提供CBAM合规应对培训/指导",
              "CBAM产品碳排放核算",
              "进口商CBAM沟通表格填报",
              "CBAM系统注册及填报操作",
              "企业碳盘查/碳核算"
            ]
          },
          ourAdvantages: {
            title: "我们的优势",
            technical: {
              title: "技术优势",
              content: "弘绿元拥有数字化碳管理系统和数据库，自动生成合规的产品碳排放报告"
            },
            team: {
              title: "团队优势",
              content: "弘绿元有多位资深老师，全方位掌握申报方法及国际碳关税政策解读，为企业提供全方位双碳规划。"
            }
          }
        }
      },
      cdpDisclosure: {
        title: "CDP环境信息披露项目详解",
        background: {
          title: "CDP组织背景",
          content: "CDP是一家全球性的非营利组织，为公司、城市、州和地区运行全球环境披露系统。CDP成立于2000年，与拥有超过110万亿美元资产的590多家投资商合作，率先通过资本市场和企业采购来激励公司披露其环境影响，并减少温室气体排放、保护水资源和保护森林。随着低碳行业的快速发展，碳信息披露项目（Carbon Disclosure Project，以下简称CDP）越来越受到中国乃至全球企业的关注与支持。"
        },
        businessBackground: {
          title: "业务背景",
          content: "越来越多投资者和采购者正在密切关注合作伙伴在应对气候变化、管理水利用与毁林风险等方面的可持续经营情况，可持续和有活力的经济发展被认为是合作的重要前提。CDP（全球环境信息研究中心）根据投资者和采购者的要求，向其被投资方和供应商发出气候、水、森林问卷，根据组织填报的问卷，对其环境管理表现做出评价。许多组织对可持续经营的状态难以做出一个全面、客观且准确的信息披露，从而影响得分评级，进而影响投资者和采购者做出决策。"
        },
        standardOverview: {
          title: "标准概述",
          content: "CDP是一家位于伦敦的非盈利组织，成立于2000年，并致力于推动减少温室气体排放、保护水和森林资源。CDP问卷调查，主要包括：气候变化问卷、森林问卷以及水安全问卷。三种问卷填写的频率：气候＞水＞森林；企业可能被邀请填写其中1个主题，或者同时被邀请其它主题；在企业没有被客户或者投资机构邀请填报时，企业可以以'自主申报'的方式申请批露。"
        },
        benefits: {
          title: "CDP信息批露企业好处",
          items: [
            "保护和提高公司的声誉-通过透明度建立信任，并应对公众日益关注的环境问题；",
            "提升您的竞争优势：在股票市场表现、获得资本和中标方面获得竞争优势；",
            "跟踪和基准测试进度，将您的环境绩效与行业进行比较，并根据您的气候目标获得国际公认的可持续性分数和反馈；",
            "发现风险和机遇：识别原本会被忽视的新环境风险和机遇，为数据驱动的战略提供信息；",
            "领先于监管，在强制批露势头日益增强的世界中，通过CDP进行批露使公司能够满足多个地区的报告规则，借助CDP您将完全符合最佳实践TCFD建议。"
          ]
        },
        implementationProcess: {
          title: "CDP问卷填报指导实施流程",
          items: [
            "组织CDP问卷填写情况介绍",
            "签署协议",
            "温室气体盘查（范围1、2、3）（可选）",
            "问卷填写前进行差距分析",
            "披露期内填写CDP三大主题问卷（每年4月~7月）",
            "组织交付CDP费用（投资者要求的问卷填写，组织需要支付填报费用给CDP）",
            "提交问卷等待评分",
            "CDP公布评分结果",
            "总结分析服务结束"
          ]
        },
        ratingResults: {
          title: "CDP评级结果",
          content: "评级结果：CDP等级从高到低划分为A、A-、B、B-、C、C-、D、D-共8个等级，未披露或信息不全为F等级。如果一家公司的分数是C或低于C，他们的管理或领导分数就不会得到分数。"
        },
        ratingCycle: {
          title: "CDP评级周期",
          content: "CDP问卷每年填报一次；填写时间：每年4月份开始；结束时间：每年7月底结止。"
        },
        serviceBenefits: {
          title: "CDP问卷填报指导带来的益处",
          items: [
            "通过第三方专业指导，减少时间成本少走弯路，提升环境信息披露效率；",
            "深入理解问卷邀请方的要求，改进环境管理绩效表现，提高CDP评级以及客户与投资机构的满意度；",
            "对比行业的环境表现与管理经验，改善可持续管理水平。"
          ]
        }
      }
    },
    ssccpPage: {
      carousel: {
        line1: "可持续供应链云",
        line2: ""
      },
      dataPlatform: "数字化工具解决方案",
      dataLeft: "数字化工具解决方案",
      dataRight: [
        ["CBAM工具", "碳计算平台", "供应链审核", "ESG评估"],
        // ["数据标签", "维度增强", "数据模型", "数据服务"]
      ],
      industries: [
        "电子", "食品", "医药", "日化", "4S", "项目制造", "现代农业", "钢铁", "…"
      ],
      groupTitle1: "环境",
      groupTitle2: "合规和可持续",
      purchaseCategories: [
        {
          title: "低碳类",
          items: ["ISO14064碳核算", "ISO14067碳足迹", "ISO14068碳中和", "LCA生命周期评价", "ISCC PLUS/EU","ETANS碳管理体系", "CBAM欧盟碳关税"]
        },
        {
          title: "能源类",
          items: ["ISO50001能源体系", "能源审计/诊断", "专项能效测试", "电/水/热平衡测试", "节能补贴申报", "节能评估服务"]
        },
        {
          title: "绿建类",
          items: ["EPD环境产品声明", "ISO14046水足迹", "LEED绿色建筑", "WELL健康建筑", "中国绿建"]
        },
        {
          title: "合规生产类",
          items: ["ISO14001环境体系","治理架构设计与优化", "绿色工厂", "零碳工厂", "绿色供应链"]
        },
        {
          title: "追溯管理类",
          items: ["供应链EHS审核", "FSC森林认证", "EUDR欧盟零毁林", "GRS全球回收标准", "废弃物零填埋体系", "欧盟电池法案辅导", "ISO20400可持续采购"]
        },
        {
          title: "社会责任类",
          items: ["ESG报告编制", "ESG现状评估分析", "CDP环境信息披露", "EcoVadis评分提升", "员工满意度调查", "SA8000社会责任", "HIGG/SEDEX填报辅导"]
        },
        {
          title: "健康和安全类",
          items: ["ISO45001", "电气安全评估", "消防安全评估", "建筑施工安全辅导", "HS法律法规清单", "HS合规评价"]
        },
        {
          title: "合规风险类",
          items: ["ISO27001信息安全", "ISO22301业务连续性", "ISO37301合规管理体系", "ISO31000风险管理"]
        },
        {
          title: "能力建设类",
          items: ["欧盟电池法规", "CBAM欧盟碳关税", "双碳法规政策解读", "节能评估师", "定制化培训训练营"]
        }
      ]
    },
    esgPage: {
      title: "ESG尽职调查",
      try: "试用 ESG >",
      whatIs: {
        title: "什么是ESG尽职调查",
        description1: "ESG（Environmental, Social and Governance）是一种关于企业环境、社会、治理绩效而非财务绩效的投资理念和企业评价标准，通常用来评估企业行为并预测企业未来的财务表现。基于ESG评级，投资者可以通过观测企业ESG绩效，评估其投资行为和企业（投资对象）在促进经济可持续发展、履行社会责任等方面的贡献。",
        description2: "2023年，国际可持续准则理事会（ISSB）正式发布《国际财务报告可持续披露准则第1号—可持续相关财务信息披露一般要求》和《国际财务报告可持续披露准则第2号—气候相关披露》，这是有史以来首套全球ESG报告标准，为各国公司披露统一的气候和可持续信息提供了国际标准，进一步提高了各国公司之间的可比性。",
        description3: "2024 年 4 月 12 日，随着上交所正式发布上市公司可持续发展报告指引，上市公司应当将可持续发展理念融入公司发展战略、经营管理活动中，持续加强生态环境保护、履行社会责任、健全公司治理，不断提升公司治理能力、竞争能力、创新能力等。"
      },
      assessment: {
        title: "ESG尽职调查从环境、社会和公司治理三个方面完善相关信息:",
        environment: {
          title: "环境（E）方面",
          resourceUtilizationEfficiency: "资源利用效率",
          energyConsumption: "能源消耗情况，包括各类能源的使用量、能源强度及与行业标杆的对比。",
          waterUsage: "水资源利用数据，如取水总量、重复利用率、单位产品用水量等。",
          materialUsageEfficiency: "原材料使用效率，如原材料采购量、损耗率、回收利用率等。",
          pollutantDischargeAndControl: "污染物排放与治理",
          greenhouseGasEmissions: "温室气体排放数据，涵盖范围 1、2、3 的排放总量及各排放源的具体情况。",
          wasteEmission: "废水、废气、废渣等污染物的排放种类、数量、浓度，以及相关的处理设施和处理效果。",
          hazardousWaste: "危险废物的产生、储存、运输和处置情况，是否符合相关法规要求。",
          environmentalManagementSystem: "环境管理体系",
          environmentalCertification: "是否建立了完善的环境管理体系，如 ISO 14001 认证等。",
          managementEffectiveness: "环境管理体系的运行效果，包括内部审核、管理评审的结果，以及环境目标和指标的完成情况。",
          emergencyPlan: "环境应急预案的制定和演练情况，以应对突发环境事件。",
          ecologicalProtection: "生态保护与生物多样性",
          ecosystemImpact: "企业生产经营活动对周边生态系统的影响，如土地占用、植被破坏、生物栖息地丧失等。",
          protectionMeasures: "采取的生态保护措施，如生态修复项目、生物多样性保护计划等。"
        },
        social: {
          title: "社会（S）方面",
          employeeRightsAndBenefits: "员工权益与福利",
          employeeStructure: "员工人数、结构（年龄、性别、学历等）及员工流动率。",
          employeeCompensation: "员工薪酬待遇，包括工资水平、福利待遇、奖金制度等，以及与行业平均水平的对比。",
          trainingOpportunities: "员工培训与发展机会，如培训投入、培训计划的实施情况、员工晋升机制等。",
          healthAndSafety: "员工健康与安全管理，包括工作环境的安全性、职业健康检查、安全事故发生率等。",
          supplyChainManagement: "供应链管理",
          supplierList: "主要供应商的清单，包括供应商的规模、行业地位、地域分布等。",
          supplierESGRequirements: "对供应商的 ESG 要求和管理措施，如供应商行为准则、定期评估机制等。",
          socialRisks: "供应链中存在的社会风险，如供应商的劳工权益问题、人权问题等。",
          customerRelationshipManagement: "客户关系管理",
          customerSatisfaction: "客户满意度调查结果，了解客户对产品或服务质量、售后服务等方面的评价。",
          complaintHandling: "客户投诉处理机制，包括投诉渠道的畅通性、投诉处理的及时性和有效性。",
          productQuality: "产品质量与安全管理，如产品质量认证、质量控制体系、产品召回制度等。",
          communityEngagement: "社区参与和社会贡献",
          socialProjects: "企业在当地社区的公益活动和社会责任项目，如教育支持、扶贫济困、文化建设等。",
          communityFeedback: "与社区居民的沟通与合作机制，以及社区对企业的认可度和满意度。"
        },
        governance: {
          title: "公司治理（G）方面",
          governanceStructure: "治理结构",
          equityStructure: "公司的股权结构，包括股东持股比例、股东性质等。",
          boardOperations: "董事会的组成和运作，如董事会成员的专业背景、独立董事的比例、董事会会议的召开频率和决策机制等。",
          supervisoryBoard: "监事会的职责和监督效果，以及监事会对公司财务和经营活动的监督情况。",
          internalControlAndRiskManagement: "内部控制与风险管理",
          controlEffectiveness: "内部控制制度的健全性和有效性，包括财务控制、运营控制、合规控制等方面。",
          riskManagementSystem: "风险管理体系的建设和运行情况，如风险识别、评估、应对策略等，以及对重大风险的监控和管理能力。",
          informationDisclosure: "信息披露与透明度",
          disclosurePolicy: "公司信息披露的制度和流程，是否及时、准确、完整地披露财务和非财务信息。",
          disclosureChannels: "信息披露的渠道和方式，如公司官网、证券交易所公告、年度报告等，以及投资者和其他利益相关者获取信息的便捷性。",
          complianceAndAntiCorruption: "合规与反腐败",
          complianceManagement: "公司的合规管理体系，包括对法律法规、行业规范的遵循情况，以及合规培训和监督机制。",
          antiCorruptionMeasures: "反腐败和反贿赂措施，如廉洁制度的建立、举报机制的有效性、对违规行为的处罚力度等。"
        }
      },
    },
    ecoVadisPage: {
      title: "EcoVadis问卷助企业一键披露",
      whatIs: {
        title: "什么是EcoVadis",
        description: "EcoVadis 通过一套严谨的方法进行评分，并设有多种奖牌以表彰不同水平的企业社会责任表现。"
      },
      scoringMethodology: {
        title: "评分方法",
        assessmentDimensions: {
          title: "评估维度",
          description: "从环境、劳工与人权、商业道德和可持续采购 4 大主题 21 项指标内容，对企业社会责任可持续性开展评级。"
        },
        scoringBasis: {
          title: "评分依据",
          description: "遵循 PDCA（计划、执行、检查、行动）的可持续发展管理逻辑，形成以 “政策 - 行动 - 结果” 为导向的评分体系，针对每项指标的三个维度进行打分，得分权重分别是政策层面 25%、行动层面 35%、结果层面 40%。"
        },
        specificScoring: {
          title: "具体评分",
          description: "每个模块的每个管理指标都将得到一个范围 0-100 的评分，该评分的递增幅度为 25，即 0、25、50、75、100，管理指标的加权平均分即为模块的得分。EcoVadis 评级总分为 100 分。同时，EcoVadis 评级还将对相关主题展开 360° 调查，参考内外部相关利益方信息。"
        }
      }
    },
    ccerPage: {
      title: "CCER助力企业迅速完成核证工作",
      whatIs: {
        title: "什么是CCER",
        description: "CCER是中国核证自愿减排量（Chinese Certified Emission Reduction）的简称，指的是对我国境内可再生能源、林业碳汇、甲烷利用等项目的温室气体减排效果进行量化核证，并在国家温室气体自愿减排交易注册登记系统中登记的温室气体减排量。"
      },
      projectTypes: {
        title: "项目类型",
        renewableEnergyProjects: {
          title: "可再生能源项目",
          description: "包括风电、光伏、水电、生物质能等项目。这些项目通过利用可再生能源发电，减少对传统化石能源的依赖，从而实现温室气体减排。"
        },
        forestryCarbonSequestrationProjects: {
          title: "林业碳汇项目",
          description: "主要通过造林、森林经营等活动，增加森林面积和森林蓄积量，吸收大气中的二氧化碳，实现碳汇功能。"
        },
        methaneUtilizationProjects: {
          title: "甲烷利用项目",
          description: "如垃圾填埋气回收利用、沼气发电等项目，将原本会排放到大气中的甲烷进行收集和利用，减少甲烷这一强效温室气体的排放。"
        }
      },
      tradingProcess: {
        title: "交易流程",
        projectFiling: {
          title: "项目备案",
          description: "项目业主需要将符合条件的自愿减排项目向国家主管部门申请备案，提交项目设计文件、监测计划等相关材料。"
        },
        emissionReductionCertification: {
          title: "减排量核证",
          description: "项目经过一定时间的实施后，由专业的核证机构对项目的减排量进行监测、核算和验证，确保减排量的真实性和准确性。"
        },
        registration: {
          title: "登记注册",
          description: "核证后的减排量在国家温室气体自愿减排交易注册登记系统中进行登记，成为可交易的CCER。"
        },
        tradingStage: {
          title: "交易环节",
          description: "重点排放企业或其他有需求的机构和个人，可以通过全国碳排放权交易市场或其他合法的交易平台，购买CCER用于抵消其温室气体排放量。"
        }
      },
      roleAndSignificance: {
        title: "作用与意义",
        carbonPeakAndNeutralityGoals: {
          title: "助力碳达峰碳中和目标实现",
          description: "为各类减排项目提供了市场化的激励机制，鼓励企业和社会资本投入到温室气体减排行动中，有助于推动我国能源结构转型、生态保护修复等工作，加快实现碳达峰碳中和目标。"
        },
        carbonMarketImprovement: {
          title: "完善碳排放权交易市场",
          description: "作为全国碳排放权交易市场的补充，CCER丰富了市场交易品种，增加了市场的灵活性和流动性，有助于降低重点排放企业的减排成本，提高碳市场的运行效率。"
        },
        sustainableDevelopmentPromotion: {
          title: "促进可持续发展",
          description: "带动了可再生能源产业、林业等相关领域的发展，促进了生态环境的保护和改善，同时也为地方经济发展提供了新的增长点，推动了可持续发展战略的实施。"
        }
      }
    },        
    lcaPage: {
      title: "培训",
      recentCourses: "培训课程清单",
      recentTip: "欢迎企业来电订制内训课程",
      courseCategories: "课程大类",
      courseSubcategory: "课程子分类",
      seriesCourseName: "系列课程名称",
      courseDesc: "课程简介",
      courseInfo: "课程详情",
      course: {
        hoursLabel: "课时：",
        foodProvided: "提供饮食",
        startTimeLabel: "开课时间",
        signup: "我要报名",
        notOpen: "当前课程暂未开放报名"
      },
      categories: {
        carbonManagement: "碳管理",
        greenManufacturing: "绿色制造",
        basicCourse: "基础课",
        practicalCourse: "实操课",
        managementCourse: "管理课"
      },
      courseList: [
        {
          name: "《ESG（环境、社会和公司治理）介绍》",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "ESG",
          subCategory: "ESG",
          desc: `ESG的概念是什么？
提升ESG绩效对于企业有什么益处？
企业如何实现长期的社会价值和可持续发展？
企业如何吸引更多重视ESG的投资者？
企业如何提高管理效率？

课程收益：
●了解ESG的背景及发展趋势
●学习ESG相关指引及政策
●为后续的企业ESG响应策略做好规划

推荐听课人群：
●企业的法人/管理者
●企业ESG/可持续发展部门
●企业EHS部门负责人
●即将上市的公司/已经上市的公司
●对ESG感兴趣的人
`
        },
        {
          name: "中国内地主流ESG要求及指引介绍",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "ESG",
          subCategory: "ESG",
          desc: `课程目录：
●ESG及其发展历史简介
●ESG披露要求日趋严格
●中国内地主流ESG要求及指引介绍
课程亮点:
●全球市场ESG监管要求趋势(以美国、英国、香港为例)
●企业如何做才能获得更好的金融机构风险评级
●中国内地ESG相关标准介绍
面对人群：
●企业ESG相关负责人或专职管理人员
●企业资深ESG技术人员
●其他对ESG感兴趣的人士
课程收益
●了解ESG概念及其发展历史
●了解ESG监管要求日趋严格的趋势
●了解中国内地主流ESG要求及指弓`
        },
        {
          name: "ESG评级面面观",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "ESG",
          subCategory: "ESG",
          desc: `●ESG评级作为ESG生态圈必不可少的环节之一，是推动国际组织和监管机构的落实的重要力量，也能有效缓解投资者与上市公司之间的信息不对称的问题，降低投资者的决策成本，提升上市公司的ESG意识和措施落实。
●ESG评级的高低已成为衡量企业运营绩效的新指标，越来越多的投资机构将企业的评级结果纳入投资决策考虑因素，对企业融资产生影响。
●企业需要了解和把握ESG主流评级体系要求、指标内容、评级流程与回应方法，针对性提升ESG评级。
●通过ESG评级概览和案例经验萃取，帮助企业挖掘ESG管理能力提升的关键点。`
        },
        {
          name: "气候风险应对及信息披露",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "ESG",
          subCategory: "ESG",
          desc: `● 气候变化风险是什么？
● 国际上对气候信息披露有何监管要求？
● 企业应该如何进行气候信息披露？`
        },
        {
          name: "企业人权合规",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "ESG",
          subCategory: "ESG",
          desc: `在全球性供应链体系的背景下，企业人权合规成为企业合规经营的一个重要组成部分：
● 作为企业，尤其是跨国企业，需要了解企业人权保护对企业经营的重要性；
● 掌握企业人权保护的重点内容和重点途径，能够帮助企业有效地进行合规管理。
● 企业人权合规管理主要包含哪些方面？
● 如何进行企业人权合规管理？
`
        },
        {
          name: "法规聚焦：聚焦欧盟ESG法规，出海企业如何应对挑战",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "ESG",
          subCategory: "ESG",
          desc: `近年来，中国企业在出海过程中面临着国际ESG监管与立法的诸多挑战，尤其是站在全球ESG领域前沿的欧盟。对于出海企业，如何应对ESG监管已成为不容忽视的问题：
●建立ESG意识，提升对重要议题的关注度，建立可持续发展的核心理念
●跟踪欧盟ESG法规最新动态，助力企业识别与评估合规风险
面对人群：
● 出海企业管理人员
● 企业董事会
● ESG委员会/工作小组成员
● 意向了解国际ESG法规动态的人士`
        },
        {
          name: "ISO 26000应用，实现企业可持续发展",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "ESG",
          subCategory: "ESG",
          desc: `1. 走进ISO 26000
※ 什么是ISO 26000？
※ 为什么要制定ISO 26000？
※ ISO 26000的定位
※ ISO 26000的内容
2. ISO 26000核心内容解析
※ 社会责任的概念
※ 社会责任的两大基本实践
※ 社会责任七大原则
※ 社会责任七大核心主题
3. 弘绿元助力ISO 26000融入企业
ESG理念是目前企业可持续发展的先进管理思想，ISO 26000作为可持续发展领域的国际标准：
●了解ISO 26000的核心内容，助力企业了解和梳理可持续发展的重要议题，理解每一个议题的内涵
●从ISO 26000入手，帮助企业树立可持续发展理念，做好议题管理，融入企业组织管理
●企业的法人/管理者
●ESG委员会/工作小组成员
●企业社会责任工作者
●有意了解ESG相关指引的人员
`
        },
        // 8
        {
          name: "EcoVadis可持续性评估分享",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "ESG",
          subCategory: "ESG",
          desc: `课程亮点：
1.企业ESG/CSR相关负责人或专职管理人员2.企业供应链管理人员3.企业资深ESG/CSR技术人员4.其他对EcoVadis感兴趣的人士
课程大纲;
2.什么是EcoVadis评估?2.EcoVadis评估方法论3EcoVadis评估步骤
面向人群;
3.企业ESG/CSR相关负责人或专职管理人员2.企业供应链管理人员3.企业资深ESG/CSR技术人员4.其他对EcoVadis感兴趣的人士
课程收益;
4.了解EcoVadis评估收益及其方法论2了解EcoVadis评估问卷填报基本步骤及其注意事项。
`
        },
        // 9
        {
          name: "EcoVadis可持续性评估介绍",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "ESG",
          subCategory: "ESG",
          desc: `课程大纲：
1. 什么是EcoVadis评估
2. EcoVadis评估基本方法论
3. EcoVadis评估主要流程
4. 案例分析
面对人群：
●企业ESG/CSR相关负责人或专职管理人员
● 企业供应链管理人员
● 企业ESG/CSR技术人员
● 其他对供应链管理和EcoVadis感兴趣的人士
课程收益：
●了解EcoVadis评估的基本方法论
●了解EcoVadis评估问卷填报的基本步骤及其注意事项`
        },
        // 10
        {
          name: "可持续信息披露新纪元：ISSB标准以及中国最新进展",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "ESG",
          subCategory: "ESG",
          desc: `课程大纲：
1.可持续信披概要
※可持续信息披露介绍
※国内可持续信息披露现状
2.ISSB标准解读
※ISSB背景和定位
※标准制定历程
※ISSB标准主要内容
※国际认可情况
3.中国进展分享
※上市公司可持续信披指引制定中
※国资委ESG监管发展步伐加快
课程收益：
● 树立ESG理念
● 认识ISSB可持续信息披露标准
● 掌握国内ESG信息披露最新动态
● 学习应对ESG信息披露挑战`
        },
        // 11
        {
          name: "ESG最新政策趋势解读",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "ESG",
          subCategory: "ESG",
          desc: `1. 国际ESG最新政策
ISSB《国际财务报告可持续披露准则》
欧盟《公司可持续发展报告指令》CSRD
欧洲可持续报告准则ESRS 
2. 中国ESG政策发展
国务院国资委《央企控股上市ESG专项报告编制研究》成果
深交所上市公司自律监管指引-行业信息披露
3. 对企业的影响及企业如何积极应对`
        },
        // 12
        {
          name: "ESG Navigator——ESG风险与应对的有效工具",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "ESG",
          subCategory: "ESG",
          desc: `课程大纲：
1. ESG发展趋势与主要挑战；
2. 如何应对ESG加速跑；
3. 即刻开启ESG Navigator 评估之旅
面对人群：
●企业ESG相关负责人或专职管理人员
●供应链相关管理人员
● 可持续金融机构从业人员
● 参与ESG投资的其他利益相关者
● 其他对ESG感兴趣的人士
课程收益：
●了解ESG发展趋势与主要挑战
●了解对应对“ESG加速跑”现状的管理建议
● 了解使用ESG Navigator 在ESG管理与评估方面的收益、优势以及系统简介`
        },
        // 13
        {
          name: "探索绿色金融新赛道：转型金融",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "ESG",
          subCategory: "ESG",
          desc: `课程大纲：
1.转型金融内涵与界定标准
2.转型金融与绿色金融的关系
3.国内外转型金融发展
※G20转型金融框架
※欧盟可持续金融分类方案
※中国转型金融探索
4.转型金融行动建议
※企业转型金融实施路径
※国际银行转型金融案例
※国内转型金融产品案例
面对人群：
● 可持续岗位、从事绿色金融业务企业的相关管理人员
● 绿色金融领域从业者
● 企业董事会
● 意向了解转型金融的人士
课程收益：
● 了解绿色金融领域新动态
● 掌握转型金融背景知识
● 获取转型金融行动建议`
        },
        // 14
        {
          name: "ISO 20400可持续采购介绍",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "ESG",
          subCategory: "ESG",
          desc: `面对人群：
●企业高级管理者
●采购管理人员/采购人员
●有意了解企业可持续发展相关指引的人员
课程收益：
●ISO 20400是什么?
●ISO 20400的核心内容有哪些?
●如何将ISO 20400应用于企业采购实践 ?`
        },
        // 15
        {
          name: "供应链企业社会责任：核心议题分享",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "ESG",
          subCategory: "ESG",
          desc: `课程大纲：
1.供应链企业社会责任所涉及的基本概念
2.供应链企业社会责任监管趋势
3.供应链企业社会责任相关核心议题解读
面对人群：
●企业高级管理人员
●企业供应链管理人员
●其他有意愿了解供应链企业社会责任管理的相关方
课程收益：
●了解供应链企业社会责任的监管趋势
●了解供应链企业社会责任的核心议题`
        },
        // 16
        {
          name: "“企业第二张财报”：财政部出手 中国可持续披露准则拉开序幕",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "ESG",
          subCategory: "ESG",
          desc: `课程大纲：
1. 可持续披露中国进展
2. 财政部基本准则意见稿解读
3. 对标国际可持续披露准则ISSB
4. 企业可持续披露行动建议
面对人群：
● 企业董事会及管理高层
● ESG委员会/工作小组成员
● 可持续发展管理岗位人员
● 意向了解国内ESG动态的人士
课程收益：
● 理解可持续信息披露内涵
● 追踪中国可持续信息披露动态
● 掌握财政部可持续披露准则
● 为可持续信息披露做好准备`
        },
        // 17
        {
          name: "企业可持续发展尽职调查指令 (CSDDD)解读与分享",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "ESG",
          subCategory: "可持续",
          desc: `课程大纲：
1. CSDDD概览
2. CSDDD核心要求与内容解读
3. 企业如何积极应对潜在挑战
面对人群：
●企业高级管理者
●供应链管理人员
●有意了解可持续发展相关指令的人员
课程收益：
●初步了解CSDDD的适用范围、核心要求
●识别CSDDD带来的潜在风险与挑战`
        },
        // 18
        {
          name: "解码ESG议题：生物多样性",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "ESG",
          subCategory: "ESG",
          desc: `课程大纲：
1. ESG议题与生物多样性内涵
※ESG议题概念
※ESG议题案例
※生物多样性内涵
2. 企业为何践行生物多样性
※全球行动
※监管政策
※外部评级
3. 生物多样性如何融入ESG管理
※披露标准指引
※风险评估方法
※供应链管理
4. 企业优秀案例分享
面对人群：
●企业高级管理者
●ESG委员会/工作小组成员
●环境、供应链、可持续发展管理岗位人员
●有意了解企业可持续发展相关指引的人员
课程收益：
● 认识ESG重大议题
● 掌握生物多样性议题背景
● 通过生物多样性助力ESG管理提升
● 学习主流ESG信息披露指引`
        },
        // 19
        {
          name: "碳中和大讲堂",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "能源低碳",
          subCategory: "低碳",
          desc: `课程收益：
● 了解碳中和的背景及碳中和的概念
● 学习碳中和相关政策和法规标准
● 通过培训掌握企业/个人如何积极准备碳中和的相关步骤

推荐听课人群：
●各企事业单位环保管理人员
●从事能耗监测管理，碳排放核查的技术人员或培训人员
●生产组织人员/各企事业单位负责人`
        },
        // 20
        {
          name: "法规聚焦：《综合能耗计算通则》GB/T2589-2020 解读",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "能源低碳",
          subCategory: "能源",
          desc: `新“规”来袭，你是否有以下疑惑：
新标准有何更新，新旧标准之间有何区别？
标准中的专业名词如何解释？
综合能耗如何进行计算，需要注意什么？

课程收益
●了解新旧标准变更要点与区别
●标准相关专业名词解释
●综合能耗的计算方法

培训对象
●企业的经营管理者
●企业能源技术人员
●意向成为工业企业节能专业人才的人士`
        },
        // 21
        {
          name: "法规聚焦：重点用能单位如何进行节能管理？",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "能源低碳",
          subCategory: "能源",
          desc: `如何进行综合能耗的计算？
重点用能单位需要哪些节能管理措施？
国家针对节能制定了哪些奖惩措施？
那么听完本次课程后，您的这些疑惑都将迎刃而解！！！

课程收益
●了解重点用能单位的筛选原则
●掌握重点用能单位的节能管理工作要求
●为后续能源管理工作的开展提供方向参考

培训对象
●重点用能单位分管节能工作的领导
●重点用能单位能源管理岗位负责人
●重点用能单位能源管理团队成员
●意向提升能源管理水平的相关人员
`
        },
        // 22
        {
          name: "工业节能及运行管理",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "能源低碳",
          subCategory: "能源",
          desc: `工业节能有何必要性？

工业节能的思路与节能路径是怎样的？

计量系统的三级计量是什么意思？
                  `
        },
        // 23
        {
          name: "法规聚焦：绿色建筑评价标准 GB/T50378-2019 解读",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "能源低碳",
          subCategory: "能源",
          desc: `绿色建筑评价标准新旧版本有何区别？
新版标准主要有哪些技术条文变化？

课程收益
●了解绿色建筑评价标准的背景与内容
●掌握新旧标准内容之前的对比变化
●为后续绿色建筑建设工作的开展提供参考

培训对象
●有志于从事绿色建筑行业的人员
●绿色建筑工程师
●建筑企业管理人员/负责人`
        },
        // 24
        {
          name: "《双控双限政策下，企业如何应对双碳目标》",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "能源低碳",
          subCategory: "低碳",
          desc: `随着国家重磅政策《2030年前碳达峰行动方案》的发布，在双碳目标，双控双限考核下，企业，尤其是大型企业，有必要了解这些问题:

企业为什么要做碳中和？
在双控双限政策下，企业如何应对双碳目标？`
        },
        // 25
        {
          name: "“十四五”全国清洁生产推行方案解读",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "能源低碳",
          subCategory: "能源",
          desc: `你是否有下面的疑问？

清洁生产相关法律法规有哪些？
清洁生产审核是什么？
本次推行方案需要关注哪些点呢？
那么听完本次课程后，您的这些疑惑都将迎刃而解！！！

课程收益：
●了解清洁生产相关法律法规
●了解清洁生产审核
●掌握“十四五”全国清洁生产推行方案需要关注的点

培训对象:
●企业环保部门负责人及相关人员
●企业清洁生产审核人员
●意向培养相关能力的人士`
        },
        // 26
        {
          name: "自愿减排项目培训（CCER）",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "能源低碳",
          subCategory: "低碳",
          desc: `中国核证自愿减排量CCER的特点是什么？
申报CCER的项目需要满足哪些条件？
CCER交易流程是怎样的？`
        },
        // 27
        {
          name: "ISCC国际可持续发展与碳认证",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "能源低碳",
          subCategory: "低碳",
          desc: `ISCC认证可以帮助企业证明其在以下方面的责任：
减少温室气体排放（GHG）
土地可持续利用
自然生物圈保护
增进社会的可持续发展

对于ISCC认证，你是否有以下困惑？
ISCC是什么？
ISCC认证有什么用？
如何开展ISCC认证？
`
        },
        // 28
        {
          name: "绿色金融与可持续发展",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "能源低碳",
          subCategory: "低碳",
          desc: `什么是绿色金融？
绿色金融五大支柱是什么？
我国有哪些关于绿色金融的最新政策？
绿色金融应该如何实践？

课程收益：
● 了解绿色金融起源，发展与绿色金融的概念
● 掌握绿色金融五大支柱与我国绿色金融政策
● 通过我国绿色金融实践案例，了解绿色金融的实践方式

推荐听课人群：
●银行、证券、基金等金融机构相关人员
●绿色融资需求的各类企业相关负责人员
●各级政府，公共机构等的绿色金融管理人员
●其他对绿色金融感兴趣的人士`
        },
        // 29
        {
          name: "法规聚焦第30期：企业电平衡测试与评价",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "能源低碳",
          subCategory: "能源",
          desc: `用电系统运行状态是什么样的？
主要耗能设备运行状态是什么样的？
企业应该从哪些方面挖掘节能潜力？

那么听完本次课程后，您的这些疑惑都将迎刃而解！！！`
        },
        // 30
        {
          name: "绿色建筑认证与房地产的可持续发展",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "能源低碳",
          subCategory: "低碳",
          desc: `实现“2030年前碳达峰、2060年前碳中和”的“双碳”目标，随着我国双碳目标的设定，绿色建筑与可持续发展已成为了热门话题，越来越多的房地产企业也开始关注这个话题。`
        },
        // 31
        {
          name: "新建类项目节能审查申报指引",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "能源低碳",
          subCategory: "能源",
          desc: `什么是节能审查？
为什么要进行节能审查？
节能审查申报工作应该怎么做？
违反节能审查办法有什么后果？

课程收益
●了解节能审查申报工作重要性
●了解企业哪些项目需要进行节能审查
●了解节能审查申报办理流程
●了解节能审查申报材料以及相关具体要求

培训对象
●EHS体系工程师
●企业能管负责人
●企业的法人/管理者
●企业合规部门负责人`
        },
        // 32
        {
          name: "生命周期评价和产品碳足迹",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "能源低碳",
          subCategory: "低碳",
          desc: `LCA和PCF相关标准有哪些？
生命周期评价/碳足迹有哪些优势？
生命周期评价/碳足迹有哪些局限性？
产品碳足迹核算步骤有哪些？
生命周期评价方法有哪些步骤？`
        },
        // 33
        {
          name: "生命周期评价介绍",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "能源低碳",
          subCategory: "低碳",
          desc: `内容：
引题讨论
生命周期评价基础介绍
生命周期评价开展流程
产品碳足迹介绍
计算
案例分析
针对：制造企业负责产品/环境可持续负责人，
企业通过绿色产品、绿色工厂、零碳等认证加分。
帮助：了解LCA和PCF的关系
了解热点话题PCF的计算方法`
        },
        // 34
        {
          name: "绿色供应链全面解析",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "能源低碳",
          subCategory: "能源",
          desc: `课程目录：
1.背号及政策
2.工作内容、目标、流程
3.绿色制造体系进展
4.绿色供应链要求
5.绿色供应链管理评价解读
6.企业需提供材料清单

课程亮点:
“十四五”工业绿色发展规划（2021-2025年）提出，持续推进绿色供应链管理企业建设，面对国家日益重视的局面，企业需要了解：
●绿色供应链是将环境保护和资源节约的理念贯穿于企业从产品设计到原材料采购、生产、运输、储存、销售、使用和报废处理的全过程，使企业的经济活动与环境保护相协调的上下游供应关系；
● 推行绿色供应链管理的目的是发挥供应链上核心企业的主体作用，一方面做好自身的节能减排和环境保护工作，不断扩大对社会的有效供给，另一方面引领带动供应链上下游企业持续提高资源能源利用效率，改善环境绩效，实现绿色发展。
今天的课程将会从六个方面全面解析绿色供应链，相信对您会有所帮助~`
        },
        // 35
        {
          name: "绿色金融“贷”动企业低碳发展",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "能源低碳",
          subCategory: "低碳",
          desc: `课程目录：
●概述
●绿色信贷的发展绿色信贷产品案例
●绿色信贷对企业低碳发展的意义

课程亮点:
碳中和”目标提出后，我国绿色发展进入了“以降碳为重点战略方向”的阶段，各个行业加速低碳转型，资金需求大，绿色金融将成为我国应对气候变化、实现双碳目标的重要工具。要实现碳中和目标，离不开金融市场的支持。

面对人群：
●企业的法人/管理者金融机构
●绿色金融部门人员
课程收益
●了解绿色金融的含义和发展
●了解企业低碳发展的方向
●了解企业如何借助金融手段更好的发展`
        },
        // 36
        {
          name: "我国节约能源法的实施情况",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "能源低碳",
          subCategory: "能源",
          desc: `课程目录：
1.节约能源法的概述 
2.我国当前的节能状况
3.我国的节能体制
4.节约能源的重要意义
5.工业节能技术

课程面向人群：
●企业能源负责人
●从事节能方面的人士

课程收益：
●进一步了解我国当前的节能状况
●通过对我国节约能源法和相关考核机制的了解，进一步推动企业产业结构和能源结构转型升级
●通过学习相关的工业节能技术，加快企业节能减排的步伐`
        },
        // 37
        {
          name: "碳管理体系介绍",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "能源低碳",
          subCategory: "低碳",
          desc: `课程亮点：随着国家3060政策的推出，各个行业都在不断认知碳的相关知识，同时就出现了大量的碳相关的需求，那么各个单位如何去做好自身的碳管理，碳管理体系就此应运而生。
课程大纲：
1.什么是碳
2.什么是碳管理体系
3.适用范围
4.体系建立周期

课程面向人群：
●企业的法人/管理者
●碳管理负责人
●企业形象提升部门
●环境管理人员
客户关系开发保障人员

课程收益：
了解相关知识
了解体系作用
提升企业管理`
        },
        // 38
        {
          name: "中国双碳政策发展分享",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "能源低碳",
          subCategory: "低碳",
          desc: `课程大纲：
一、双碳政策与目标的发展历程
二、碳减排政策框架
三、政策支持与企业挑战

解决问题：
1．双碳政策有哪些法规？
2．企业碳排放管理的要求是什么？
3．双碳政策对于企业的影响是什么？

课程收益：
● 了解政府对碳排放管理的具体要求和目标
● 了解中国双碳政策的趋势和动态
● 助力企业更好地制定和实施企业碳减排策略
`
        },
        // 39
        {
          name: "政策解读：欧盟碳边境调节机制—CBAM",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "能源低碳",
          subCategory: "低碳",
          desc: `课程大纲：
1.CBAM政策背景
※欧盟气候政策
※政策发展历史
2.CBAM运行机制介绍与解读
※覆盖范围、运行机制、计算方法
※过渡期前后如何运行
3.进口商企业如何应对
※面临的挑战与应对措施

面向人群：
● 企业董事会、管理层
● 企业ESG、EHS相关人员，
● 温室气体/双碳工作小组成员
● 低碳管理、可持续发展管理岗位人员

课程收益：
● 了解CBAM政策内容
● 分析政策重点
● 掌握面临的挑战和应对方法`
        },
        // 40
        {
          name: "节能降耗：企业节能实务操作",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "能源低碳",
          subCategory: "能源",
          desc: `课程大纲：
1. 暖通空调节能介绍
2. 空压机系统节能介绍
3. 水泵及电机系统节能介绍
4. 余热余压技术介绍
5. 能源管理系统介绍

面对人群：
● 各企事业单位能源审计负责人及节能减排工作负责人 
● 负责企业事业单位能源审计、节能诊断的工作人员 
● 从事能源管理、规划、审核及咨询等的专业人员 

课程收益：
● 了解企业节能实务操作
● 了解国内外最新的节能技术`
        },
        {
          name: "政策解读：欧盟新电池法规",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "能源低碳",
          subCategory: "低碳",
          desc: `课程大纲：
1.欧盟新电池法规介绍
※法规内容介绍
※重点要点分析
2.中国企业如何应对
※电池企业面临的挑战
※企业如何应对

面对人群：
● 电池企业、电池供应链上其他企业董事会、管理层等
● 相关企业ESG、EHS相关人员，
● 温室气体/双碳工作小组成员
● 低碳管理、可持续发展管理岗位人员

课程收益：
● 了解政策内容
● 分析政策重点
● 掌握面临的挑战和应对方法`
        },
        // 42
        {
          name: "中英双语：欧盟新电池法解读",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "能源低碳",
          subCategory: "低碳",
          desc: `课程大纲：
1. 欧盟新电池法概述
2. 新电池法中可持续性与安全性要求
3. 新电池法中标签、二维码及电池护照要求
4. 新电池法中废弃电池管理要求
5. 企业面临的挑战及应对措施

面对人群：
●电池行业供应链上下游相关人员
●电池行业企业相关人员
●意向了解欧盟新电池法的人士

课程收益：
●了解新电池法各项新规定及执行节点
●针对新电池法各项新规定管理中遇到的挑战采取适用的应对措施
●了解新电池法对于行业供应链中各角色的影响`
        },
        // 43
        {
          name: "环境产品声明（EPD）介绍",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "能源低碳",
          subCategory: "低碳",
          desc: `课程大纲：
1.名词解释
2.EPD介绍
3.EPD、LCA与PCF的区别与联系
4.EPD环境产品声明的特征

面对人群：
●企业环保负责人
● LCA工程师

课程收益：
●认识EPD
●了解EPD,LCA以及碳足迹之间的区别和联系
●EPD的关键文件解读
●EPD发布步骤介绍`
        },
        // 44
        {
          name: "新能源汽车准入管理法规介绍",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "能源低碳",
          subCategory: "能源",
          desc: `课程大纲：
1、汽车产业投资管理规定（发改委·2018-22号令）
2、新能源汽车生产企业及产品准入管理规定（工信部·2017-39号令）（工信部·2020-54号令）
3、道路机动车辆生产企业及产品准入管理办法（工信部·2018-50号令）

面对人群：
●汽车零部件开发或生产企业人员
● 汽车整车开发或生产企业人员

课程收益：
●了解执行标准法规的原因；
● 了解可销售生产必须关注的法规条例是什么
● 了解法规的重点内容`
        },
        // 45
        {
          name: "产品碳足迹助力企业绿色发展",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "能源低碳",
          subCategory: "低碳",
          desc: `课程大纲：
1.政策背景
2.碳足迹概念简介 
3.碳足迹标准简介
4.企业碳足迹评估流程
5.案例分享

面对人群：
● 企业董事会、管理层
● 企业ESG、EHS相关人员，
● 温室气体/双碳工作小组成员
● 低碳管理、可持续发展管理岗位人员

课程收益：
● 了解碳足迹政策内容
● 分析政策重点
● 掌握面临的挑战和应对方法`
        },
        // 46
        {
          name: "碳管理体系基础讲解",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "能源低碳",
          subCategory: "低碳",
          desc: `课程大纲：
1.什么是碳
2.什么是碳管理体系
3.适用范围
4.体系建立周期

面对人群：
●企业的法人/管理者
●碳管理负责人
●企业形象提升部门
●环境管理人员
●客户关系开发保障人员

课程收益：
了解相关知识
了解体系作用
提升企业管理`
        },
        // 47
        {
          name: "解密“碳管理体系”，助力低碳未来",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "能源低碳",
          subCategory: "低碳",
          desc: `课程大纲：
1.政府及客户对于企业的碳管理要求有哪些？
2.详细了解碳管理体系建立及评定流程？
3.由碳排放至碳中和过程如何规划？
4.新形势下的风险和机遇有哪些？`
        },
        // 48
        {
          name: "科学碳目标与企业范围三核算",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "能源低碳",
          subCategory: "低碳",
          desc: `课程大纲：
1.气候科学与人类应对
※气候科学的最新发现
※COP28总结与回顾
2.SBTi科学碳目标介绍与解读
※如何加入SBTi
※如何制定符合SBTi要求的减排目标
3.企业范围三核算
※ISO14064与GHG Protocol差异解读
※企业如何收集活动数据

面对人群：
● 企业董事会、管理层
● 企业ESG、EHS相关人员
● 温室气体/双碳工作小组成员
● 低碳管理、可持续发展管理岗位人员

课程收益：
● 了解最新气候科学
● 解读科学碳目标倡议具体要求
● 理解范围三核算要点`
        },
        // 49 
        {
          name: "CCER机制与碳资产开发",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "能源低碳",
          subCategory: "低碳",
          desc: `课程大纲：
1.碳市场发展背景
2.碳抵消机制机理
3.中国自愿减排项目要求
4.CCER项目开发与交易实践
5.CCER交易市场分析

面对人群：
●清洁能源企业、节能减排企业管理人员和技术人员
●相关咨询公司技术人员
●感兴趣于CCER项目开发的人士，关注碳中和目标并有志于发展和抓住绿色产业机会的人员

课程收益：
●了解国内外碳市场与抵消机制发展形势和国内政策走势
●提升相关人员减排项目开发、计量与交易专业能力
●抓住抵消市场发展战略机遇，充分参与全国碳市场，实现企业碳中和`
        },
        // 50
        {
          name: "可持续发展与能源转型",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "能源低碳",
          subCategory: "能源",
          desc: `课程大纲：
1.CBAM政策背景与运行机制
※欧盟碳边境调节机制的政策背景
※主要运行机制
※企业的角色与应对方法
2.全球可持续发展政策和能源转型
※全球可持续发展政策进展
※全球清洁能源发展现状
※能源转型的问题与挑战
3.未来的展望与全球影响

面对人群：
● 企业董事会、管理层等
● 相关企业ESG、EHS相关人员，
● 温室气体/双碳工作小组成员
● 低碳管理、可持续发展管理岗位人员

课程收益：
● 了解政策内容
● 分析政策重点
● 掌握面临的挑战和应对方法`
        },
        // 51
        {
          name: "产品碳足迹和水足迹简介",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "能源低碳",
          subCategory: "能源",
          desc: `课程大纲：
1.概述
2.相关标准介绍
3.企业执行流程和要求
4.碳足迹、水足迹评估的意义

面对人群：
●企业的法人/管理者
●生产、EHS等部门人员

课程收益：
● 了解碳足迹、水足迹的含义和发展
● 了解企业低碳发展的方向`
        },
        // 52
        {
          name: "太阳能管理倡议评估准则解读",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "能源低碳",
          subCategory: "能源",
          desc: `课程大纲：
1. 背景
2. SSI标准介绍
3. 主要覆盖范围和核心议题
4. 标准具体内容
5. 生效时间和后续发展
6. 对企业的影响

面对人群：
●光伏行业企业的法人/管理者
●EHS负责人
●EHS部门专职管理人员
●ESG负责人

课程收益：
●了解SSI标准中的关注议题
● 了解审核关注点
●实时更新`
        },
        // 53
        {
          name: "绿色供应链前世今生",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "能源低碳",
          subCategory: "能源",
          desc: `课程大纲：
1、绿色供应链背景与政策
2、绿色供应链概念及相关标准
3、绿色供应链实施与评价

面对人群：
●企业环保工作人员
●可持续发展部门管理人员
●采购、供应链负责人

课程收益：
●了解绿色供应链实施的必要性和对组织的收益
●掌握绿色供应链评价指标科学设计
●废弃物零填埋认证的目的和意义`
        },
        // 54
        {
          name: "碳普惠政策与方法学解读",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "能源低碳",
          subCategory: "低碳",
          desc: `课程大纲：
1.碳普惠概念、背景和作用
2.碳普惠案例
3.方法学基本概念
4.方法学编制大纲和申报流程

面对人群：
●有减排意向的企业人员
●社区环保负责人
●意向提升环境管理能力的人士

课程收益：
●学习碳普惠知识
●了解碳普惠相关案例
●了解方法学申报流程`
        },
        // 55
        {
          name: "组织碳“范围三”计算",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "能源低碳",
          subCategory: "低碳",
          desc: `课程大纲：
1、组织碳“范围三”意义
2、如何计算范围三
3、企业如何策划计算范围三

面对人群：
●企业碳管理者
●采购管理人员/采购人员
●有意了解碳计算、碳管理的相关人员

课程收益：
● 了解“范围三”重要性，提前策划企业范围三计算
● 掌握“范围三”计算方法学，轻松驾驭企业“组织碳”计算`
        },
        // 56
        {
          name: "数字化全面解决方案+弘绿元一站式汽车法规服务全景介绍",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "能源低碳",
          subCategory: "能源",
          desc: `课程大纲：
1. 汽车标准法规背景
2.汽车行业标准法规痛点
3.弘绿元 一站式汽车法规服务

面对人群：
●汽车零部件及整车主机厂工程师
●专业采购部门人员
●有意了解汽车法规现状及有法规服务购买需求人员

课程收益：
●了解汽车法规对企业的重要性
●深入了解海内外汽车法规现状
●弘绿元法规一站式服务全景获悉 `
        },
        // 57
        {
          name: " 欧盟零毁林法案EUDR专题研讨会",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "能源低碳",
          subCategory: "低碳",
          desc: `课程大纲：
1.  欧盟零毁林法案EUDR介绍
2.  EUDR与EUTR的区别
3.  弘绿元提供的解决方案
4.  Q&A

面对人群：
●企业高级管理者
●供应链相关负责人
●有意了解EUDR法案的人员

课程收益：
●了解EUDR法案
● 如何应对EUDR法案
● 企业如何针对EUDR开展尽职调查`
        },
        // 58
        {
          name: "ISO14068-1：碳中和介绍",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "能源低碳",
          subCategory: "低碳",
          desc: `课程大纲：
1. ISO 14068-1标准主要内容
2. ISO 14068-1对企业的影响
3. 企业如何积极应对

面对人群：
●企业高级管理者
●碳排放/碳中和管理人员
●对可持续发展较高要求的企业

课程收益：
●树立企业碳中和理念
●了解碳中和在企业可持续发展中的重要性
●学习开展碳中和工作`
        },
        // 59
        {
          name: "面对双碳政策如何提高企业竞争力",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "能源低碳",
          subCategory: "低碳",
          desc: `课程大纲：
1  碳排放国内外政策
1.1 全球双碳动态
1.2 我国双碳推进概述
1.3 碳关税
2  如何让提高企业竞争力
2.1 应对措施
2.2 实施方案
3  信息化助力企业碳中和

面对人群：
●从事企业温室气体排放核算服务机构、咨询服务公司相关人员
●低碳试点城市、园区、社区及政府与应对气候变化相关的管理人员
● 其他关注碳达峰、碳中和行业人士及需求企业

课程收益：
●学习双碳政策
●了解审核关注点
●实时更新`
        },
        // 60
        {
          name: "绿色低碳物流管理体系介绍",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "能源低碳",
          subCategory: "低碳",
          desc: `课程大纲：
1.绿色低碳物流体系介绍  
2.绿色低碳物流体系标准架构解读
3.绿色低碳物流体系贯标认证流程

面对人群：
●物流企业、物流园区管理人员
●管理上下游物流企业的人员

课程收益：
●优化物流企业管理过程 ，改善绿色物流绩效 
●应对上游挑战`
        },
        // 61
        {
          name: "能源计量配备标准解读",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "能源低碳",
          subCategory: "能源",
          desc: `课程大纲：
1. 用能单位能源计量器具配备和管理通则分享解读
2. 企业能源计量器具配备率检查方法分享解读
3. 企业应对措施分享

面对人群：
●企业能源管理人员
●企业能源计量器具管理人员
●意向提升能源管理能力的人员

课程收益：
●了解国家最新能源计量器具管理标准
●了解双碳背景下用能单位能源计量要求
●了解企业能源计量体系建立要点`
        },
        // 62
        {
          name: "双碳主题下的产品碳足迹",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "能源低碳",
          subCategory: "低碳",
          desc: `课程大纲：
1.双碳背景与挑战
2.双碳相关政策
3.产品碳足迹概述
4.产品碳足迹的应用
5.减少产品碳足迹的策略
6.未来展望与挑战
7.结论与建议

面对人群：
●企业环保负责人
●意向提升环境管理能力的人士

课程收益：
●了解产品碳足迹的定义                                       
●了解产品碳足迹对于提升竞争力的重大意义      
●了解产品碳足迹的基本计算逻辑`
        },
        // 63
        {
          name: "有限空间作业安全知识培训",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "安全",
          desc: `课程收益：
● 了解有限空间的概念及有限空间作业的危险特性
● 学习有限空间如何进行管理和作业风险防控
● 通过培训掌握有限空间作业安全相关知识

推荐听课人群：
●各企事业单位管理人员
●有限空间作业人员
●现场安全管理人员/企业安全负责人
●生产组织人员/各企事业单位员工`
        },
        // 64
        {
          name: "法规聚焦：《国家危险废物名录（2021版）》解读",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "环境",
          desc: `本期课程背景：
本课程将针对《国家危险废物名录（2021版）》新版法规进行深度解读，帮助大家了解有关危废鉴别的国家标准。

课程收益
●学习危险废物详细的判定流程
●解读《国家危险废物名录》新旧版本法规内容之间的区别
●了解有关危废鉴别的国家标准

培训对象：
●企业EHS环境与职业健康安全管理人员
●企业EHS管理者/体系工程师
●危险化学品生产、储存、运输、使用单位管理人员`
        },
        // 65
        {
          name: "2020全年度国家EHS法规更新解读",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "法规",
          desc: `通过课程学习，让学员获得：
●学习EHS法律法规、标准的准确解读
●知晓EHS大事件
●了解法规动态
●感知企业风险`
        },
        // 66
        {
          name: "企业废弃物管理培训",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "环境",
          desc: `危险废弃物如何界定？
如何建立内部废弃物管理组织架构？
关于废弃物有哪些法规要求？
废弃物如何进行减量、合法化处理？

课程收益：
●全面系统的了解危险废弃物的种类及识别方法
● 学会管理工厂危险废弃物并了解相关法规要求
● 学习并掌握废弃物减量、合法化处理的方式

推荐听课人群：
●企业环境与职业健康安全管理人员
●各部门中层管理人员/专职EHS管理人员
●企业总负责人/总经理`
        },
        // 67
        {
          name: "法规聚焦：《工作场所职业卫生管理规定》（国家卫生健康委员会第5号令）解读",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "职业健康",
          desc: `新“规”来袭，你是否有以下疑惑呢：
《职业病防治法》及《工作场所职业卫生管理规定》等配套法规有何关联？
职业病防护设施“三同时”行政管理责任如何移交，企业如何执行？
与企业相关的重点法规条款有哪些？

课程收益：
●了解法规变更要点
●企业的职业健康安全管理应如何进行合规性调整

培训对象：
●企业的法人/管理者
●职业健康安全负责人
●职业健康安全管理员
●意向提升职业健康安全能力的人士`
        },
        // 68
        {
          name: "建设项目环评那些事",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "环境",
          desc: `什么是环境影响评价？
如何判断项目的环评类别？
环评审批的过程是怎样的？

课程收益：
●全面系统的了解环评的基本定义
● 学会如何判断建设项目的环评类别
● 学习并掌握环评正常审批及重新报批的流程

推荐听课人群：
●企业环评部门负责人
●各部门中层管理人员/专职EHS管理人员
●企业总负责人/总经理`
        },
        // 69
        {
          name: "重大变动那点事—变动项目环评与排污许可管理",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "环境",
          desc: `听课之前，你是否有以下疑惑：
如何判断是否属于重大变动？
判定属于重大变动该如何履行相应的环评手续和排污许可管理？
判定不属于重大变动，工厂是否就不需要任何环评和排污管理手续？

课程收益:
●了解重大变动清单
●懂得变动项目环评与排污许可管理相关事宜

培训对象：
●EHS体系工程师
●企业环保负责人
●意向提升环境管理能力的人士`
        },
        // 70
        {
          name: "法规聚焦：解读电子工业水污染物排放标准（GB 39731-2020)",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "环境",
          desc: `听课之前，你是否有以下疑惑：
电子工业企业还需要执行电镀污染物排放标准吗？
污染物排放限值有什么变化吗？
新增的综合毒性控制项目是什么？
什么叫单位产品基准排水量？怎么统计单位产品实际排水量？

课程收益:
●了解标准规定的相关内容
●懂得电子工业企业水污染物排放的主要技术内容
●深入学习电子工业企业水污染物排放的监测要求及排污口规范化

培训对象:
●电子工业企业污水集中处理设施管理人员
●电子工业企业环保负责人
●电子工业企业主管或领导者`
        },
        // 71
        {
          name: "中华人民共和国生物安全法解读",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "安全",
          desc: `作为生物安全依法治理的里程碑，这部法律与你我有着怎样的关联，又会提供哪些安全保障?
国家安全法律法规体系是怎样的？
生物安全法立法背景是什么？
生物安全法主要内容有什么？
这部法规有哪些需要注意的点？

课程收益：
●全面系统的了解国家安全法律法规体系
● 学习并了解生物安全法的立法背景
● 学习并掌握生物安全法规内容及需要注意的点

推荐听课人群：
●企业生物安全管理负责人
●各部门实验室EHS管理人员
●企业总负责人/总经理/安全管理负责人`
        },
        // 72
        {
          name: "法规聚焦：中华人民共和国安全生产法（2021修正）解读",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "安全",
          desc: `企业的安全生产责任是如何规定的？
企业负责人的安全生产责任是如何规定的？
企业安全管理机构及人员的安全生产责任是如何规定的？
新安全生产法处罚规定有哪些变更呢？
企业又该如何应对呢？

课程收益:
●指导企业贯彻落实新安全生产法
●掌握新安全生产法对企业的要求
●帮助企业提升安全管理水平

培训对象:
●企业主要负责人
●企业其他负责人
●企业EHS部门负责人
●企业从业人员
●有意向提升安全管理能力的人士`
        },
        // 73
        {
          name: "企业安全管理文件综述",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "安全",
          desc: `在日常工作中，你是否有下面的疑问？
安全管理文件太繁琐，不知从哪里开始准备？
不知道安全管理文件具体如何做才能满足法律法规的要求？
那么听完本次课程后，您的这些疑惑都将迎刃而解！！！

课程收益:
●了解企业需要哪些安全管理文件
●了解每项安全管理文件的法律出处

培训对象:
●安全工程师
●企业安全负责人
●意向提升安全管理能力的人士
`
        },
        // 74
        {
          name: "企业环保合规管理要点及环保违法案例分析",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "环境",
          desc: `企业日常环境保护管理中，应主要开展哪些工作？
企业在检查自身环境保护合规性时，应关注哪些重要问题？
企业常见的典型违法案例有哪些？

课程收益：
●了解当前企业环境管理趋势及现状
●掌握企业环境保护管理主要内容及自查重点
●学会建立企业环境管理台账
●规避企业环境保护管理违法行为

适合听课人群：
●EHS负责人
●EHS部门专职管理人员
●意向培养环境管理能力的人士`
        },
        // 75
        {
          name: "法规聚焦29期 | 《企业环境信息依法披露管理办法》解读",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "环境",
          desc: `《环境信息依法披露管理办法》适用范围？
哪些企业需要作为披露主体披露相关环境信息？
企业披露环境信息的主要内容、形式和时限要求？
违反《管理办法》的相关罚则？


课程收益:
● 了解企业环境信息依法披露的发展过程
● 了解《管理办法》出台的背景
● 了解《管理办法》主要内容及罚则
● 对企业提出几点相关建议

培训对象:
●企业的法人/管理者
●EHS负责人
●EHS部门专职管理人员
●资深EHS技术人员`
        },
        // 76
        {
          name: "EHS法规更新解读课程第八期：2021年全年度EHS法规更新解读",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "法规",
          desc: `2021年全年度，弘绿元网站共收录近1094条正式国家级EHS文件，征求意见稿276条，这些更新的法规，您都了解吗？
碳达峰碳中和“1+N”政策体系已建立健全？？？
《排污许可管理条例》发布？？？
环境信息强制性披露？？？
如何防范噪声污染？？？
如何加强危险废物全过程管理？？？
职业卫生推进“放改服”改革？？？
新安全生产法有哪些新规定？？？
`
        },
        // 77
        {
          name: "法规聚焦：电气风险预防及安全管理",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "安全",
          desc: `本次课程将全面系统梳理电气安全技术管理知识，便于企业电气设备、安全管理人员掌握关键要点，降低电气事故放生概率；重点篇章后附带相关真实事故、隐患案例的讲解，并以对应的法规条款及风险进行解读，便于大家理解。
电气风险重点关注什么？
隐患对应的法规标准依据？`
        },
        // 78
        {
          name: "公共消防安全知识",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "安全",
          desc: `消防安全关系到每一个人,每一个家庭,每一个企业。因此预防和减少火灾事故的发生,对社会长治久安具有重要意义。
火灾的发生是现实生活中最常见、最突出、危害最大的一种灾难,是直接关系到人民生命安全、财产安全的大问题,所以我们要系统地学习如何预防火灾以及当火灾发生时如何科学逃生。
课程收益：
●作为企业，需要了解燃烧与火灾原理基础知识
●学习正确的方法灭火
●科学的逃生方法`
        },
        // 79
        {
          name: "一般工业固体废物管理",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "环境",
          desc: `为落实新《中华人民共和国固体废物污染环境防治法》关于工业固体废物管理的有关要求，指导产生工业固体废物的单位做好制度、设施管理、供应商、台账相关工作，确保一般工业固废合法合规。
面对人群：
●企业的法人/管理者
●EHS负责人
●EHS部门专职管理人员
●资深EHS技术人员
课程收益：
●学习EHS法律法规、标准的准确解读
● 了解审核关注点
●实时更新`
        },
        // 80
        {
          name: "法规聚焦：消防设施通用规范（GB55036-2022）--灭火器",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "安全",
          desc: `《消防设施通用规范》自2023年3月1日起实施，本规范为强制性工程建设规范，全部条文必须严格执行。同时废止十九项工程建设标准相关强制性条文，其中有两项标准与灭火器相关。

能获得哪些收益：
●了解新规范中关于灭火器的条文内容
●了解废止的灭火器相关条文内容
客户较关心的痛点及问题:
● 灭火器的类型选择有哪些新要求？
● 灭火器的报废条件是否发生变化？
● 灭火器的最大报废期限是否发生变化？`
        },
        // 81
        {
          name: "如何提升安全领导力",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "安全",
          desc: `1、什么是安全？安全领导力？
2、安全管理的目的？安全管什么？
3、提升安全领导力的工具之一、二
4、安全领导力企业最佳实践
5、安全管理函数曲线图

课程亮点：
●以浅显的问题拨开安全管理的谜团
●法规高效解读法
●安全领导力提升两大高效实用工具
●先进安全领导力最佳实践
●安全辩证法（曲线图）

面对人群：
●企业第一负责人、业务管理人员
●安全管理人员
●工段班组管理人员
课程收益：
●理解安全领导力的含义
●提升安全领导力
●对安全工作的新思维、新认知`
        },
        // 82
        {
          name: "法规聚焦——企业安全生产费用提取和使用管理办法（2022年修订）",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "安全",
          desc: `课程目录：
1.《办法》适用范围
2.安全生产费用的提取标准和支出范围
3.安全生产费用的管理和监督

课程亮点:
新修订的《企业安全生产费用提取和使用管理办法》自2022年11月21日起实施，与原办法相比，适用范围由原来的九类行业企业增加至十二类行业企业，并给出每类行业企业安全生产费用的提取标准和支出范围，细化了安全生产费用的管理和监督要求。

面对人群：
●EHS负责人
●EHS部门专职管理人员
●资深EHS技术人员

课程收益：
●了解新办法的适用范围
●了解提取标准、支出范围及管理要求`
        },
        // 83
        {
          name: "近两年环保处罚案例分享",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "环境",
          desc: `课程目录：
1.我国环保形式
2.探讨近两年典型环保案例
3.企业现状与未来

课程亮点:
了解国家环保典型违规案例总体趋势
提升工作作风
提升环保意识
了解我国环保新动态
进一步理清环保工作人员的工作动向

面对人群：
●企业管理者
●EHS体系工程师
●企业环保负责人
●意向提升环境管理能力的人士

课程收益:
●国家环保违规案例总体趋势
●环保生产法规对于企业环保管理要求
●通过案例学习如何进行企业环保管理`
        },
        // 84
        {
          name: "法规聚焦--新污染物最新政策解读",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "环境",
          desc: `课程目录：
1.新污染物的定义
2.新污染物最新政策解读
3.各地新污染物政策汇总

课程亮点:
●什么是新污染物
●新污染物最新政策有哪些
●新污染物与新化学物质登记管理之间有什么关系
●企业应该如何应对最新出台的各项新污染物政策要求

面对人群：
●环境/EHS管理人员
●化学品采购管理人员
●有毒有害物质控制管理人员
●意向了解新污染物的人士

课程收益:
●了解新排污许可管理现状
●针对申领许可证遇到的疑难问题
●找到适用的解决方案
●了解证后监测管理执行要点`
        },
        // 85
        {
          name: "法规聚焦：最新建筑防火通用规范与消防设施通用规范解读",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "安全",
          desc: `课程目录：
1.消防通用规范编制的背景与目的
2.建筑防火与消防设施通用规范介绍
3.与国家现行相关技术标准的关系
4.建筑防火与消防设施完整可靠的重要性
5.消防安全评估与维保检测

课程亮点：
解读最新GB55036消防设施通用规范与GB55037建筑防火通用规范，让企业与用户进一步了解新颁布GB55036与GB55037与现行消防设施技术标准的关系。

课程面向人群：
●EHS体系工程师
●消防安全责任人与消防安全管理人
●消防维保检测与安全评估人员

课程收益:
●了解消防设施完好有效的标准
●让其消防设施符合法律法规
●避免消防设施与建筑消防隐患带来的火灾事故
●避免因消防问题带来监管部门的处罚`
        },
        // 86
        {
          name: "从业人员对于企业实现安全生产所应承担的责任",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "安全",
          desc: `课程目录：
1.从业人员对于企业实现安全生产的意义
2.从业人员有哪些安全生产责任以及企业如何压实从业人员的安全责任
3.从业人员未履责关联企业的违法责任

课程面向人群：
●企业主要负责人&各BU负责人
●EHS安全管理人员
●企业从业人员
●意向提升安全管理能力的人士

课程收益:
●企业管理者可了解到从业人员的安全生产责任以及一旦从业人员未履责那么企业需要承担的法律责任
●从业人员可以了解到需承担的安全生产责任以及未履责将收到的法律惩处`
        },
        // 87
        {
          name: "法规聚焦-职业卫生管理",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "职业健康",
          desc: `课程亮点：以职业病防治法宣传周为大背景，针对职业卫生管理的重要法规解读，全面覆盖企业职业卫生管理各项维度要求及合规性要求中常见注意事项。

课程大纲：
1.职业病防治基础知识
2.职业病防护管理常用法规
3.《工作场所职业卫生管理规定》解读

课程面向人群:
●EHS经理、工程师
●职业卫生管理人员
●接触职业危害因素岗位人员及管理者

课程收益:
●了解职业并防治基础知识
●掌握职业卫生管理相关法规清单
●聚焦用人单位工作场所视角，职业卫生管理的要素及合规注意事项`
        },
        // 88
        {
          name: "废弃物零填埋管理体系",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "环境",
          desc: `课程亮点：开展“无废城市”建设，是推动减污降碳协同增效的重要举措，是实现美丽中国建设目标的内在要求。“推动 100 个左右地级及以上城市开展“无废城 市”建设，到 2025 年，“无废城市”固体废物产生强度较快下降， 综合利用水平显著提升，无害化处置能力有效保障，减污降碳协同增 效作用充分发挥，基本实现固体废物管理信息“一张网”，“无废” 理念得到广泛认同，固体废物治理体系和治理能力得到明显提升”已是《“十四五”时期“无废城市”建设工作方案》明确的目标。

面向人群：
1、企业管理者
2、EHS体系工程师
3、企业环保负责人
4、意向提升环境管理能力的人士

课程大纲：
1、零填埋”体系与我国的“无废
2、废弃物零填埋管理体系
3、企业如何应对“无废、零填埋

课程收益：
1、了解我国“无废及零填埋”相关政策
2、了解“废弃物零填埋管理体系”核心内容
3、走在环保管理前沿，将风险转化为机遇，树立行业环保标杆`
        },
        // 89
        {
          name: "法规聚焦-建筑防火之安全疏散",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "安全",
          desc: `课程大纲：
1.安全疏散问题导致的火灾事故
2.安全疏散问题的行政处罚
3.法律法规对安全疏散的要求
4.正确设置疏散出口、疏散门及安全出口
5.疏散门规范具体要求

面向人群:
●EHS体系工程师
●消防安全责任人与消防安全管理人
●消防维保检测与安全评估人员

课程收益:
●了解安全疏散的重要性
●正确设置疏散出口、疏散门及安全出口
●了解设置疏散路径的原则
●安全疏散设置的好坏在火灾救援中起着重要作用。
`
        },
        // 90
        {
          name: "环境应急预案合规管理",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "环境",
          desc: `课程大纲：
1、为什么要编制环境应急预案
2、如何编制环境应急预案
3、合规管理要点

面对人群：
●环境/EHS管理人员
●环境应急预案小组成员
●意向了解环境应急预案的人士

课程收益：
●了解环境应急预案法规政策
●学习如何制定本单位环境应急预案
●梳理环境应急预案合规管理要点`
        },
        // 91
        {
          name: "供应链的可追溯性服务",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "供应链",
          desc: `课程大纲：
01 Background 
02 Supply chain mapping
03 Traceability Management System Audit
04 Audit Steps 

课程亮点：
1、针对 《维吾尔强迫劳动预防法案》的实施相关企业的对策；
2、以光伏产业为例介绍可追性审核的注意事项；
3、以光伏产业为例介绍可追溯性审核的步骤。

面对人群：
●相关企业的法人/管理者
●相关企业质量（可追溯性）负责人
●相关企业质量（可追溯性）专职管理人员
●相关企业质量（可追溯性）技术人员

课程收益：
●相关法律法规具体实施解读
● 了解审核关注点`
        },
        // 92
        {
          name: "事故应急响应法规解读",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "安全",
          desc: `课程大纲：
一、总则
总体介绍分享法规的基本信息
二、近期颁布的事故应急类法规研讨
覆盖法规适用范围、关联法规
国家及地方响应新法的行动
三、刑法对于生产安全事故惩处的规定

面对人群：
● 企业主要负责人
● 企业安全管理相关人员
● 企业一线从业人员

课程收益：
● 帮助安全相关从业人员了解法规动向增强职业素养；
● 协助安全从业人员落实法规新要求，提高执业能力；
● 查缺补漏，通过研讨新法规、新标准，弥补管理盲点。`
        },
        // 93
        {
          name: "排污权二十问",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "环境",
          desc: `课程大纲：
1. 排污权定义及概述
2. 排污权交易概述
3. 排污权交易在我国的发展历程及试点现状
4. 排污权交易相关法规解读
5. 企业进行排污权交易的流程及挑战

面对人群：
●排污权交易相关企业管理人员
●涉及排污权相关行业领域人员
●对排污权管理及交易感兴趣的人员

课程收益：
●了解排污权内涵及排污权交易流程
●了解排污权交易过程中企业的定位角色
●了解排污权及交易相关法律法规`
        },
        // 94
        {
          name: " 产品出口：企业如何应对国际关注的劳工问题",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "劳工",
          desc: `课程大纲：
1. 背景概述 
2. 涉及法规及指引
3. 劳工审核关注点
4. 劳工工作环境及健康OHS审核点
5. 企业可以做哪些准备

课程亮点：
随着欧盟及美国对于中国出口产品“强迫劳动”问题的日益关注和限制，让企业及相关供应商了解海外客户主要关注审核的“人权”问题有哪些，可提前做好准备，减少可能存在的风险

面对人群：
●企业的法人/管理者
● 企业人事部门及体系负责人

课程收益：
● 学习不同的审核关注点
● 了解所涉及到的法规和相关国际条约`
        },
        // 95
        {
          name: "法规聚焦——《工贸企业重大事故隐患判定标准》管理类和专项类判定情形",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "安全",
          desc: `课程大纲：
1.《判定标准》适用范围
2.管理类重大事故隐患判定情形
3.专项类重大事故隐患判定情形

面对人群：
●EHS负责人
●EHS部门专职管理人员
●资深EHS技术人员

课程收益：
●了解工贸企业管理类重大事故隐患的判定情形
●了解工贸企业专项类重大事故隐患的判定情形`
        },
        // 96
        {
          name: "安全管理之燃气安全",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "安全",
          desc: `课程大纲：
1.燃气安全事故案例分析
2.家用燃气关键部件
3.燃气管理过程常见安全隐患及法规依据

面对人群：
● 居民及工商业用户
●工商业用户的安全管理人
●燃气公司管理人员

课程收益：
●汲取事故教训
●了解燃气使用过程安全关键部件
● 了解管理中比较容易疏忽的隐患，正确认识燃气法规标准`
        },
        // 97
        {
          name: "重点排污单位解读",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "环境",
          desc: `课程大纲：
1. 重点排污单位的确定流程
2. 重点排污单位的分类及要求
3. 重点排污单位需履行的义务

面对人群：
●企业的法人/管理者
●企业环境管理人员
●企业环境技术人员

课程收益：
●了解重点排污单位的确定流程与时间节点
●了解各类重点排污单位的要求
●了解重点排污单位需履行的义务`
        },
        // 98
        {
          name: "企业如何开展节后消防检查",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "安全",
          desc: `课程大纲：
1.企业消防检查的方法
2.企业消防检查的内容
3.消防安全隐患的案例

面对人群：
●企业消防负责人
●企业消防管理人员及消防重点部位管理人员
●消防服务机构人员

课程收益：
●节后消防检查的内容
●节后消防检查的方法
●通过消防案例督促企业落实消防安全责任制`
        },
        // 99
        {
          name: "有限空间安全风险及防范规定解读",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "法规",
          desc: `面对人群：
●工贸企业EHS人员
●工贸企业有限空间作业人员、监护人员

课程收益：
●分析《工贸企业有限空间作业安全规定》重点要求
●认识有限空间的安全风险
●掌握有限空间作业人员及监护人员的职责`
        },
        // 100
        {
          name: "环境合规管理系列之危险废物识别标志的设置",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "环境/安全",
          desc: `课程大纲：
1.危险废物识别标志设置的法律依据和标准规范
2.三类危险废物识别标志的内容以及制作、设置要求
3.企业实操过程的问题及建议

面对人群：
●企业环保负责人
●EHS部门专职环境管理人员
●EHS咨询人员

课程收益：
●详细解读危险废物识别标志设置要求
●改善企业危险废物环境管理水平
●提升企业环境管理绩效`
        },
        // 101
        {
          name: "你我同行，共建“无废城市”",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "环境",
          desc: `课程大纲：
1.“无废城市”实施背景及相关政策
2.“无废工厂”评价指标体系
3.“零填埋”管理体系

面对人群：
●企业法人/可持续发展负责人
●EHS、ESG部门负责人
●企业环保负责人
●环保管理人员

课程收益：
●了解“无废城市”建设的相关政策
●在我国废弃物处理处置现状的基础上，寻求固体废物”减量化、资源化
无害化“的发力点
●管理体系的相关要求
●学习创建“无废工厂”及“零填埋`
        },
        // 102
        {
          name: "从火灾案例谈企业如何做好消防防控",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "安全",
          desc: `课程大纲：
1. 火灾典型案例分析
2. 企业消防管理现状
3. 如何做好消防管理工作
4. 消防安全评估体系

面对人群：
●消防安全责任人
●消防安全管理人员及消防设施维护技术人员
●普通的人员

课程收益：
●正确理解法定要求的消防维保检测工作
●了解预防火灾的方法
●了解初期火灾扑救的方法`
        },
        // 103
        {
          name: "供应链可持续尽职调查",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "供应链",
          desc: `课程大纲：
1.引言——供应链概念及属性
2.供应链责任倡议及规范
3.供应链社会责任管理
4.供应链尽责立法及发展趋势

面对人群：
●企业环保工作人员
●公司人力资源管理人员
●可持续发展部门管理人员
●采购、供应链负责人

课程收益：
●了解供应链概念及社会属性
●了解供应链社会责任相关标准和规范
●了解如何管理供应链尽职调查相关内容`
        },
        // 104
        {
          name: "企业供应链可追溯管理",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "供应链",
          desc: `课程大纲：
1. 可追溯性的概念
2. 可追溯性的管理
3. 如何进行可追溯管理
4. 企业积极应对

面对人群：
●企业高级管理者
●供应链管理人员
●有意了解企业可持续发展相关议题的人员

课程收益：
●树立企业可持续发展理念
●了解可追溯管理在企业可持续发展中的重要性
●学习将可追溯管理理念融入企业管理实践`
        },
        // 105
        {
          name: "安全管理之畅通生命通道",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "安全",
          desc: `课程大纲：
1.火灾事故案例分析
2.正确理解“畅通生命通道”
3.“畅通生命通道”法规要求

面对人群：
●企业，事业单位，商业综合题安全管理人员
●消防安全责任人与消防安全管理人
●消防维保检测与安全评估人员

课程收益：
●汲取火灾事故教训
●正确理解“生命通道”含义
●怎么检查确保“生命通道”畅通`
        },
        // 106
        {
          name: "以特种设备“四类人员”为基点，探讨特种设备使用单位如何落实安全主体责任",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "法规",
          desc: `课程大纲：
第一部分 特种设备相关事故类型
√ 压力容器爆炸事故
√ 叉车侧翻伤害事故
√ 电梯坠落事故
√ 起重机械害事故
第二部分 特种设备使用单位如何落实主体责任
√ 特种设备类型
√ 组织架构
√ 主体责任内容
√ 如何落实
第三部分 特种设备相关法规汇总

面对人群：
●企业安全管理人员（安全总监、安全工程师、安全员等）
●企业主要负责人
●企业特种设备管理及操作人员
●意向提升安全管理能力的人士

课程收益：
●了解特种设备方面的事故类型从而规避风险
●针对特种设备使用及管理当中遇到的疑难问题找到适用的解决方案
●了解特种设备设备使用单位落实主体责任的要点`
        },
        // 107
        {
          name: "2024上半年EHS法规回顾",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "法规",
          desc: `课程大纲：
1.2024上半年EHS法规政策更新概述
2.上半年度重点法规标准内容梳理
——排污许可管理办法
——节约用水条例
——安全生产治本攻坚三年行动方案
——突发事件应急预案管理办法
——开展企业安全生产费用统计直报工作的通知

面对人群：
●企业的法人/管理者
●EHS负责人
●EHS部门专职管理人员
●资深EHS技术人员
●意向了解EHS法规政策的人士

课程收益：
● 实时更新EHS法规标准
● 学习EHS最新重点法规、标准
● 掌握EHS法规变化点
● 了解最新EHS政策趋势`
        },
        // 108
        {
          name: "环境合规管理系列之废弃物零填埋管理体系",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "环境",
          desc: `课程大纲：
1.什么是废弃物零填埋
2.废弃物零填埋管理体系的建立
3.废弃物零填埋管理体系的认证

面对人群：
●企业环保负责人
●EHS部门专职环境管理人员
●EHS咨询人员

课程收益：
●详细解读危险废物识别标志设置要求
●改善企业危险废物环境管理水平
●提升企业环境管理绩效`
        },
        // 109
        {
          name: " 企业如何做好有效的电气安全管理",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "安全",
          desc: `课程大纲：
1. 电气火灾典型案例分析
2. 企业电气管理现状
3. 如何做好电气管理工作
4. 电气安全评估体系

面对人群：
●电气安全负责人
●电气安全工程师与电气安全技术员
●电气设计人员

课程收益：
●正确识别电气安全隐患
●了解电气设计原理
●掌握整改电气安全隐患方法`
        },
        // 110
        {
          name: " 基于“出海热”背景下的全球汽车准入及法规探讨",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "汽车",
          desc: `课程大纲：
1. 高速增长的汽车出口市场简析
2. 全球车辆认证及法规介绍
3. 弘绿元一站式汽车法规服务
4. Q&A

面对人群：
●零部件企业
●整车企业
●检测认证机构

课程收益：
●建立汽车出口基本知识框架
●欧盟E-MARK认证体系了解
●提高产品法规合规性`
        },
        // 111
        {
          name: "欧盟型式认证及GSR II要点探讨",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "汽车",
          desc: `课程大纲：
1. 围绕欧盟型式认证
2.GSR更新内容
3.法规解读服务

面对人群：
●意向出口欧盟整车及零部件企业
●法规解读人员
●有意了解汽车法规现状及有法规服务购买需求人员

课程收益：
●建立汽车出口基本知识框架
●GSR II更新点深入解读
●法规解读合规化`
        },
        // 112
        {
          name: "排污许可管理法规要求及合规管理",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "环境",
          desc: `课程大纲：
1.新排污许可制度实施情况回顾
2.申领排污许可申报系统的准备工作
3.电子行业如何申领排污许可证申领系统
4.证后监管的主要内容

面对人群：
●环境工程师
●企业环保负责人
●意向提升环境管理能力的人士

课程收益：
●了解排污许可法规制度架构
●学习最新排污许可管理法规要求
●掌握排污许可合规管理要点`
        },
        // 113
        {
          name: "企业环境管理人员如何看懂环评报告",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "环境",
          desc: `课程大纲：
1. 什么是环评
2. 为什么要做环评
3. 如何做环评
4. 环评知识快问快答

面对人群：
●企业环境管理人员
●企业EHS部门负责人
●企业环保工程师

课程收益：
●了解环评有关的基础知识
●了解环评的结构框架
●学习将环评报告融入日常环境管理`
        },
        // 114
        {
          name: "UN ECE R10 法规重点解读及准入探讨",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "汽车",
          desc: `课程大纲：
1.全球法规背景
2.UN ECE R10 术语详解
3.欧盟准入介绍
4.UN ECE R10 技术详解
5.中欧法规重点比较

面对人群：
●意向出口欧盟整车及零部件企业
●企业标准化工作人员
●有意了解汽车法规现状及有法规服务购买需求人员

课程收益：
●UN ECE R10重难点解读；
●GB 34660-2017与UN ECE R10技术对比
●法规解读合规化`
        },
        // 115
        {
          name: "实验室安全管理培训",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "安全",
          desc: `课程大纲：
1、实验室安全管理背景
2、实验室安全管理内容和参考标准
3、实验室安全管理实例
4、小结和心得

面对人群：
●企业EHS管理人员
●实验室管理人员
●公司主要负责

课程收益：
●了解实验室安全管理的工具、标准
●掌握实验室安全管理的重点、难点`
        },
        // 116
        {
          name: " 企业如何建立产品可追溯体系",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "供应链",
          desc: `课程大纲：
1. 国际对于可追溯的要求
2. 产品可追溯关注模块
3. 什么才是有效的可追溯
4. 企业如何应对

面对人群：
●企业高级管理者
●质量管理人员
●供应链管理人员
●生产管理人员
●有意了解可追溯体系的人员

课程收益：
●了解国际对于产品可追溯的要求；
●了解可追溯体系的建立、实施和改进`
        },
        // 117
        {
          name: "快速描述EHS现状 Where we are？",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "EHS",
          desc: `课程大纲：
1、描述本单位EHS现状的难点；
2、与高层沟通EHS现状的难点；
3、解决方法；
4、几个场景下沟通举例；
5、总结。

面对人群：
●EHS体系工程师
●企业EHS负责人
●意向提升管理能力的人士

课程收益：
●了解本单位EHS难点
●了解EHS沟通难点
●如何解决的参考方法`
        },
        // 118
        {
          name: " 法规聚焦：建筑消防设施检测 技术规范(GB/T 44481-2024)",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "法规",
          desc: `课程大纲：
1.《规范》的适用范围和定义
2.建筑消防设施的检测内容
3.建筑消防设施检测的技术要求

面对人群：
●EHS管理人员
●消防安全管理人员
●建筑消防设施检测人员

课程收益：
●了解建筑消防设施检测的内容
●了解建筑消防设施检测的技术要求`
        },
        // 119
        {
          name: "全面实行排污许可制解读分享",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "法规",
          desc: `课程大纲：
1. 改革背景目的
2. 重点工作任务
3. 地方政府法规
4. 企业应对措施

面对人群：
●相关企业管理者
●相关企业环境管理人员
●有意了解排污许可制相关改革的人员

课程收益：
●了解目前全面实行排污许可制的改革任务
●学习了解固定污染源相关制度及管理措施
●帮助企业构建基于排污许可证的环境管理制度`
        },
        // 120
        {
          name: "《液化石油气钢瓶》（GB5842-2023）解读",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "法规",
          desc: `课程大纲：
1.前言
2.主要内变化内容分析
3.规范详细解读

面对人群：
●液化石油气钢瓶制造单位负责人/安全管理人/操作人员
●液化石油气钢瓶充装单位负责人/安全管理人/操作人员
●液化石油气钢瓶的使用单位负责人/安全管理人/操作人员

课程收益：
●制造气瓶的企业通过本规范的解读能正确理解气瓶制造要求。
●充装运输单位能正确认识到合格气瓶的要求，进一步提高了运输安全。
●使用单位通过本规范的解读更能安全有效的管理气瓶。`
        },
        // 121
        {
          name: "电碳协同推动绿色能源转型&碳减排",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "低碳",
          desc: `课程大纲：
1.电碳协同的基本概念
2.中国的电碳市场现状
3.电碳协同的市场机制与案例

面对人群：
● 电力企业相关人员
● 碳交易市场的参与者
● 研究机构与高校学者● 政府部门与政策制定者

课程收益：
●深入理解电碳协同的市场机制和技术路径。
●掌握绿电交易和碳减排的实际操作方法。
●提升在绿色能源转型中的竞争力和创新能力。`
        },
        // 122
        {
          name: "高处作业专项探讨",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "安全",
          desc: `课程大纲：
1.认识高处作业
2.相关法律法规标准汇总
3.高处作业操作及防护

面对人群：
●安全系工程师
●高处作业操作人员/监护人员/生产管理人员
●意向提升安全管理能力的人士

课程收益：
●了解高处坠落事故的危害后果  提高重视程度
●帮助相关人员更好地识别和防范高处作业中的风险
●降低高处坠落事故发生的概率`
        },
        // 123
        {
          name: "危险废物名录（2025年版）主要内容及变化要点解读",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "EHS",
          desc: `课程大纲：
1.国家危险废物名录（2025年版）主要内容解读
2.国家危险废物名录（2025年版）变化要点解读
3.针对国家危险废物名录（2025年版）的变化，企业应该做哪些工作？

面对人群：
●EHS负责人
●EHS部门专职管理人员
●资深EHS技术人员

课程收益：
●全面掌握国家危险废物名录（2025年版）相关内容
●明确需要调整的危险废物管理的相关工作内容
●获得危险废物管理的实用建议`
        },
        // 124
        {
          name: "新版《职业病分类和目录》解读",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "EHS",
          desc: `课程大纲：
1.职业病的定义及四要件
2.《职业病分类和目录》详解
3.法定职业病病人有哪些保障
4.企业职业病防治管理

面对人群：
●企业职业健康负责人
●职业健康管理人员
●职业病高危岗位员工
●意向提升职业健康管理能力的人士

课程收益：
●了解职业病分类和目录的最新变化
●学习各类职业病及职业危害因素
●掌握职业病管理策略`
        },
        // 125
        {
          name: "尽职调查合规性要求解析",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "EHS",
          desc: `课程大纲：
1.欧盟尽职调查的背景
2.欧盟尽职调查的主要要求
3.尽职调查的执行步骤
4.尽职调查中的常见挑战

面对人群：
●企业供应链管理人员
●企业质量管理人员
●企业EHS管理人员

课程收益：
●了解欧盟对于尽职调查合规性方面的要求
●讲解尽职调查的执行步骤，从前期准备到运行要求。
●了解尽职调查中的常见问题`
        },
        // 126
        {
          name: "如何应对欧盟绿色贸易壁垒产品环境足迹评价（PEF）",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "EHS",
          desc: `课程大纲：
1.欧盟与环境足迹方法相关的法规政策
2.环境足迹方法的基本概念及方法要点
3.环境足迹方法与ISO 14040系列标准规范的LCA方法的主要差异
4.企业如何应对？（重点纺织行业）

面对人群：
●EHS体系工程师
●企业环保负责人
●意向提升环境管理能力的人士

课程收益：
●了解什么是欧盟环境足迹
●学习PEF的基本概念和方法
●了解企业如何应对欧盟绿色贸易壁垒●了解企业如何更好的进行低碳管理`
        },
        // 127
        {
          name: "法规聚焦——《粉尘爆炸泄压规范（GB 15605-2024）》",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "EHS",
          desc: `课程大纲：
1. 范围
2. 术语和定义
3. 技术要求
4.安装使用和维护
5.证实方法

面对人群：
●EHS管理人员
●消防安全管理人员
●设备管理人员

课程收益：
●了解粉尘爆炸泄压的技术要求
●了解爆炸泄压装置安装使用和维护要求
● 了解相应的证实方法`
        },
        // 128
        {
          name: "供应链可追溯性实践",
          hours: "12课时",
          startTime: "2025年8月10日",
          category: "EHS",
          subCategory: "ESG",
          desc: `课程大纲：
1. 基础概念
2. 供应链可追溯性评价的目的
3. 可追溯性技术要素
4. 可追溯性评价流程和内容

面对人群：
●供应链管理及采购
●质量管理人员
●生产制造和仓储物流
●海外销售人员

课程收益：
●了解供应链可追溯的来源和目的
●了解供应链可追溯性关注的技术要素
●了解供应链可追溯的评价流程和内容`
        },
      ]
    },
    serviceSupport: {
      welcome: '欢迎访问RedC帮助中心',
      tryRedC: '试用RedC >',
      business: {
        title: '业务咨询',
        phone: '业务咨询电话',
        email: '业务咨询邮箱',
        wechat: '业务咨询公众号'
      },
      technical: {
        title: '技术咨询',
        phone: '技术咨询电话',
        email: '技术咨询邮箱',
        wechat: '技术咨询公众号'
      }
    },
    understandRedC: {
      title: '关于我们',
      desc: '弘绿元供应链管理（上海）有限公司，我们是一家致力于为企业打造绿色、可持续供应链的战略管理服务机构。我们在节能、低碳、环保、ESG、数字化转型等领域拥有丰富的实战经验，并拥有多名资深的行业技术专家为项目落地保驾护航。',
      features: '我们的愿景是为我们的用户提供专业、高效的一站式解决方案，并与其携手共进，迈向可持续发展的新纪元。',
      freeUse: '免费试用 >',
      AdvantagesRedC: 'RedC的优势',
      advantages: {
        title: '一体化碳管理解决方案',
        desc: ['RedC 覆盖从数据采集、碳排计算、报告生成到减排计划、监测和项目管理的全流程', '帮助企业高效管理碳排放，减少不同工具之间的切换成本'],
      },
      SaaS: { 
        title: 'SaaS 模式',
        desc: ['企业可快速上线使用，降低 IT 维护成本', '保持软件的持续更新和优化'],
      },
      dataCollection: {
        title: '数据采集与因子匹配能力',
        desc: ['支持多种数据源输入，并可根据行业标准进行因子匹配', '确保碳排计算的准确性，符合国际碳排放核算方法'],
      },
      automation: {
        title: '自动化碳排计算与报告生成',
        desc: ['支持一键生成碳排放报告，符合监管机构和市场需求', '减少人工计算和合规风险'],
      },
      moduleDesign: {
        title: '模块化设计',
        desc: ['RedC 提供组织碳、产品碳、CBAM 等多个模块', '企业可按需选择，满足不同规模和行业的碳管理需求'],
      },
      dataAnalysis: {
        title: '智能分析与减排策略优化',
        desc: ['内置智能分析工具，可提供碳排放趋势预测、减排建议和可视化展示', '帮助企业制定可持续发展策略，提高碳管理决策的科学性'],
      },
      operationDemoVideo: '操作演示视频',
    },
    bookDemo: {
      title: '立即咨询',
      desc: '请完善以下信息，我们的顾问会在1个工作日内与您联系',
      name: '姓名',
      inputName: '请输入姓名',
      phone: '手机号',
      inputPhone: '请输入手机号',
      email: '邮箱',
      inputEmail: '请输入邮箱',
      company: '公司名称',
      inputCompany: '请输入公司名称',
      position: '职位',
      inputPosition: '请输入职位',
      from: '得知途径',
      inputFrom: '请输入您从何处得知我们',
      ConfirmClause: '勾选视为您已阅读并同意弘绿元《隐私政策》',
      submit: '提交',
      privacyPolicy: {
        title: '试用账号隐私条款',
        intro: '欢迎您使用我们的试用服务！本隐私条款旨在向您说明，在您申请和使用试用账号的过程中，我们如何收集、使用、存储和保护您的个人信息。请您仔细阅读本隐私条款，以了解我们对您个人信息的处理方式。如您对本隐私条款有任何疑问或建议，请随时与我们联系。',
        
        section1: '一、收集的信息',
        registrationInfo: '注册信息：申请试用账号时，我们会收集您提供的关键注册信息，包括：',
        item1: '1. 姓名：方便识别您的身份，便于沟通交流。',
        item2: '2. 手机号码：可用于身份验证、接收验证码或紧急联系。',
        item3: '3. 电子邮箱：用于发送试用账号相关信息。请确保邮箱准确且能正常接收邮件。',
        item4: '4. 公司名称：助于建立您的使用场景。',
        item5: '5. 职位（选填）：以便为您提供更贴合工作需求的服务。',
        
        section2: '二、信息存储与安全',
        storageLocation: '（一）存储位置：我们在中华人民共和国境内存储您的个人信息。',
        securityMeasures: '（二）安全措施：我们采用多种技术和管理措施保护您的个人信息安全，如数据加密、访问控制和安全检测等。',
        
        section3: '三、用户权利',
        accessRight: '1. 访问权：您可随时访问您的个人信息。',
        correctionRight: '2. 更正权：如果您的信息有误，您可以申请更正。',
        deletionRight: '3. 删除权：您有权要求删除您的个人信息，法律规定需保留的除外。',
        consentWithdrawal: '4. 撤回同意权：您可随时撤回对个人信息的使用授权。',
        accountDeletion: '5. 注销权：您可申请注销您的网站账号，账号注销后不可恢复。',
        
        section4: '四、条款变更',
        changesInfo: '我们可能会根据法律法规的更新、业务发展或其他需要适时修改本隐私条款。当隐私条款发生变更时，我们将通过公告或邮件通知您。',
        
        section5: '五、联系我们',
        contactInfo: '如您对隐私条款有任何疑问，可联系我们：',
        email: '📧 电子邮箱：info@hongly-sh.com',
        address: '📍 地址：上海市嘉定区环城路2222号1幢J',
        phone: '📞 客服电话：15800921098',
        haveRead: '我已阅读'
      }
    },
    shopping: {
      title: '购物车',
    },
    callMeBottom: {
      item1: '产品',
      item1_1: '产品碳',
      item1_2: '组织碳',
      item1_3: 'CBAM',
      item2: '联系我们',
      item2_1: '上海',
      item2_2: '电话：021-3143 6179',
      item2_3: '邮箱：info@hongly-sh.com',
      item2_4: '地址：上海市嘉定区环城路2222号1幢J',
      item3: '天津',
      item3_1: '天津市西青区桂苑路14号',
      item4: '关注我们',
      item5: '网站'
    }
  }
};

const i18n = new VueI18n({
  locale: localStorage.getItem("language") || "zh", // 默认语言改为中文
  fallbackLocale: "zh", // 语言找不到时回退到中文
  messages,
});

// 添加切换语言的方法
export const setI18nLanguage = (lang) => {
  i18n.locale = lang;
  localStorage.setItem("language", lang);
  document.querySelector('html').setAttribute('lang', lang);
  return lang;
};

export default i18n;
